import x, { createContext as O, useRef as L, useCallback as j, useState as W, useContext as H, useEffect as _, useMemo as z, version as Tf, forwardRef as ie, cloneElement as El, isValidElement as kf } from "react";
import Pl, { flushSync as Nn, createPortal as Bf } from "react-dom";
const Ff = O(null);
O(null);
O(null);
O(null);
O(null);
const Dl = O({}), $r = O(null), Rr = O(null), X = typeof document < "u" ? x.useLayoutEffect : () => {
};
var er;
const Kf = (er = x.useInsertionEffect) !== null && er !== void 0 ? er : X;
function te(t) {
  const e = L(null);
  return Kf(() => {
    e.current = t;
  }, [
    t
  ]), j((...n) => {
    const r = e.current;
    return r?.(...n);
  }, []);
}
function Lf(t) {
  let [e, n] = W(t), r = L(null), i = te(() => {
    if (!r.current) return;
    let o = r.current.next();
    if (o.done) {
      r.current = null;
      return;
    }
    e === o.value ? i() : n(o.value);
  });
  X(() => {
    r.current && i();
  });
  let l = te((o) => {
    r.current = o(e), i();
  });
  return [
    e,
    l
  ];
}
const En = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Sl = /* @__PURE__ */ x.createContext(En), Mf = /* @__PURE__ */ x.createContext(!1);
let If = !!(typeof window < "u" && window.document && window.document.createElement), tr = /* @__PURE__ */ new WeakMap();
function Af(t = !1) {
  let e = H(Sl), n = L(null);
  if (n.current === null && !t) {
    var r, i;
    let l = (i = x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (r = i.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (l) {
      let o = tr.get(l);
      o == null ? tr.set(l, {
        id: e.current,
        state: l.memoizedState
      }) : l.memoizedState !== o.state && (e.current = o.id, tr.delete(l));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function Nf(t) {
  let e = H(Sl);
  e === En && !If && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Af(!!t), r = e === En && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return t || `${r}-${n}`;
}
function Rf(t) {
  let e = x.useId(), [n] = W(Me()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${En.prefix}`;
  return t || `${r}-${e}`;
}
const Of = typeof x.useId == "function" ? Rf : Nf;
function Vf() {
  return !1;
}
function zf() {
  return !0;
}
function Hf(t) {
  return () => {
  };
}
function Me() {
  return typeof x.useSyncExternalStore == "function" ? x.useSyncExternalStore(Hf, Vf, zf) : H(Mf);
}
let _f = !!(typeof window < "u" && window.document && window.document.createElement), Ct = /* @__PURE__ */ new Map(), Vt;
typeof FinalizationRegistry < "u" && (Vt = new FinalizationRegistry((t) => {
  Ct.delete(t);
}));
function ae(t) {
  let [e, n] = W(t), r = L(null), i = Of(e), l = L(null);
  if (Vt && Vt.register(l, i), _f) {
    const o = Ct.get(i);
    o && !o.includes(r) ? o.push(r) : Ct.set(i, [
      r
    ]);
  }
  return X(() => {
    let o = i;
    return () => {
      Vt && Vt.unregister(l), Ct.delete(o);
    };
  }, [
    i
  ]), _(() => {
    let o = r.current;
    return o && n(o), () => {
      o && (r.current = null);
    };
  }), i;
}
function Uf(t, e) {
  if (t === e) return t;
  let n = Ct.get(t);
  if (n)
    return n.forEach((i) => i.current = e), e;
  let r = Ct.get(e);
  return r ? (r.forEach((i) => i.current = t), t) : e;
}
function ft(t = []) {
  let e = ae(), [n, r] = Lf(e), i = j(() => {
    r(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    r
  ]);
  return X(i, [
    e,
    i,
    ...t
  ]), n;
}
function Ue(...t) {
  return (...e) => {
    for (let n of t) typeof n == "function" && n(...e);
  };
}
const Q = (t) => {
  var e;
  return (e = t?.ownerDocument) !== null && e !== void 0 ? e : document;
}, ge = (t) => t && "window" in t && t.window === t ? t : Q(t).defaultView || window;
function jf(t) {
  return t !== null && typeof t == "object" && "nodeType" in t && typeof t.nodeType == "number";
}
function Wf(t) {
  return jf(t) && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in t;
}
let Gf = !1;
function Rn() {
  return Gf;
}
function oe(t, e) {
  if (!Rn()) return e && t ? t.contains(e) : !1;
  if (!t || !e) return !1;
  let n = e;
  for (; n !== null; ) {
    if (n === t) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : Wf(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const be = (t = document) => {
  var e;
  if (!Rn()) return t.activeElement;
  let n = t.activeElement;
  for (; n && "shadowRoot" in n && (!((e = n.shadowRoot) === null || e === void 0) && e.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function J(t) {
  return Rn() && t.target.shadowRoot && t.composedPath ? t.composedPath()[0] : t.target;
}
class qf {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(e) {
    if (!oe(this.root, e)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = e, i = e;
    for (this._currentNode = e; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const o = r, a = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(a), a.currentNode = i, this._currentSetFor.add(a), r = i = o.host;
    } else r = r.parentNode;
    const l = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(l), l.currentNode = i, this._currentSetFor.add(l), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let e = this.currentNode, n = this.nextNode();
    return oe(e, n) ? (n && (this.currentNode = n), n) : (this.currentNode = e, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const e = this._walkerStack[0].nextNode();
    if (e) {
      if (e.shadowRoot) {
        var n;
        let i;
        if (typeof this.filter == "function" ? i = this.filter(e) : !((n = this.filter) === null || n === void 0) && n.acceptNode && (i = this.filter.acceptNode(e)), i === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = e, e;
        let l = this.nextNode();
        return l && (this.currentNode = l), l;
      }
      return e && (this.currentNode = e), e;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.nextNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  previousNode() {
    const e = this._walkerStack[0];
    if (e.currentNode === e.root) {
      if (this._currentSetFor.has(e))
        if (this._currentSetFor.delete(e), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let i = this.previousNode();
          return i && (this.currentNode = i), i;
        } else return null;
      return null;
    }
    const n = e.previousNode();
    if (n) {
      if (n.shadowRoot) {
        var r;
        let l;
        if (typeof this.filter == "function" ? l = this.filter(n) : !((r = this.filter) === null || r === void 0) && r.acceptNode && (l = this.filter.acceptNode(n)), l === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let o = this.lastChild();
        return o && (this.currentNode = o), o;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let i = this.previousNode();
      return i && (this.currentNode = i), i;
    } else return null;
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(e, n, r, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (o) => {
      if (o.nodeType === Node.ELEMENT_NODE) {
        const s = o.shadowRoot;
        if (s) {
          const u = this._doc.createTreeWalker(s, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(u), NodeFilter.FILTER_ACCEPT;
        } else {
          var a;
          if (typeof this.filter == "function") return this.filter(o);
          if (!((a = this.filter) === null || a === void 0) && a.acceptNode) return this.filter.acceptNode(o);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = e, this.root = n, this.filter = i ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(e.createTreeWalker(n, r, this._acceptNode));
    const l = n.shadowRoot;
    if (l) {
      const o = this._doc.createTreeWalker(l, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(o);
    }
  }
}
function Yf(t, e, n, r) {
  return Rn() ? new qf(t, e, n, r) : t.createTreeWalker(e, n, r);
}
function Cl(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (n = Cl(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function Xf() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++) (t = arguments[n]) && (e = Cl(t)) && (r && (r += " "), r += e);
  return r;
}
function R(...t) {
  let e = {
    ...t[0]
  };
  for (let n = 1; n < t.length; n++) {
    let r = t[n];
    for (let i in r) {
      let l = e[i], o = r[i];
      typeof l == "function" && typeof o == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? e[i] = Ue(l, o) : (i === "className" || i === "UNSAFE_className") && typeof l == "string" && typeof o == "string" ? e[i] = Xf(l, o) : i === "id" && l && o ? e.id = Uf(l, o) : e[i] = o !== void 0 ? o : l;
    }
  }
  return e;
}
function tn(...t) {
  return t.length === 1 && t[0] ? t[0] : (e) => {
    let n = !1;
    const r = t.map((i) => {
      const l = pi(i, e);
      return n || (n = typeof l == "function"), l;
    });
    if (n) return () => {
      r.forEach((i, l) => {
        typeof i == "function" ? i() : pi(t[l], null);
      });
    };
  };
}
function pi(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
const Zf = /* @__PURE__ */ new Set([
  "id"
]), Jf = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Qf = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), ev = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), mi = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), tv = /^(data-.*)$/;
function q(t, e = {}) {
  let { labelable: n, isLink: r, global: i, events: l = i, propNames: o } = e, a = {};
  for (const s in t) Object.prototype.hasOwnProperty.call(t, s) && (Zf.has(s) || n && Jf.has(s) || r && Qf.has(s) || i && ev.has(s) || l && mi.has(s) || s.endsWith("Capture") && mi.has(s.slice(0, -7)) || o?.has(s) || tv.test(s)) && (a[s] = t[s]);
  return a;
}
function ve(t) {
  if (nv()) t.focus({
    preventScroll: !0
  });
  else {
    let e = rv(t);
    t.focus(), iv(e);
  }
}
let dn = null;
function nv() {
  if (dn == null) {
    dn = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return dn = !0, !0;
        }
      });
    } catch {
    }
  }
  return dn;
}
function rv(t) {
  let e = t.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== r; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && n.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function iv(t) {
  for (let { element: e, scrollTop: n, scrollLeft: r } of t)
    e.scrollTop = n, e.scrollLeft = r;
}
function On(t) {
  var e;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands;
  return Array.isArray(n) && n.some((r) => t.test(r.brand)) || t.test(window.navigator.userAgent);
}
function Or(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function je(t) {
  if (process.env.NODE_ENV === "test") return t;
  let e = null;
  return () => (e == null && (e = t()), e);
}
const vt = je(function() {
  return Or(/^Mac/i);
}), wl = je(function() {
  return Or(/^iPhone/i);
}), Tl = je(function() {
  return Or(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  vt() && navigator.maxTouchPoints > 1;
}), nn = je(function() {
  return wl() || Tl();
}), lv = je(function() {
  return vt() || nn();
}), kl = je(function() {
  return On(/AppleWebKit/i) && !Vr();
}), Vr = je(function() {
  return On(/Chrome/i);
}), Vn = je(function() {
  return On(/Android/i);
}), ov = je(function() {
  return On(/Firefox/i);
}), Bl = /* @__PURE__ */ O({
  isNative: !0,
  open: av,
  useHref: (t) => t
});
function l0(t) {
  let { children: e, navigate: n, useHref: r } = t, i = z(() => ({
    isNative: !1,
    open: (l, o, a, s) => {
      Kl(l, (u) => {
        Fl(u, o) ? n(a, s) : tt(u, o);
      });
    },
    useHref: r || ((l) => l)
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ x.createElement(Bl.Provider, {
    value: i
  }, e);
}
function Bt() {
  return H(Bl);
}
function Fl(t, e) {
  let n = t.getAttribute("target");
  return (!n || n === "_self") && t.origin === location.origin && !t.hasAttribute("download") && !e.metaKey && // open in new tab (mac)
  !e.ctrlKey && // open in new tab (windows)
  !e.altKey && // download
  !e.shiftKey;
}
function tt(t, e, n = !0) {
  var r, i;
  let { metaKey: l, ctrlKey: o, altKey: a, shiftKey: s } = e;
  ov() && (!((i = window.event) === null || i === void 0 || (r = i.type) === null || r === void 0) && r.startsWith("key")) && t.target === "_blank" && (vt() ? l = !0 : o = !0);
  let u = kl() && vt() && !Tl() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: l,
    ctrlKey: o,
    altKey: a,
    shiftKey: s
  }) : new MouseEvent("click", {
    metaKey: l,
    ctrlKey: o,
    altKey: a,
    shiftKey: s,
    bubbles: !0,
    cancelable: !0
  });
  tt.isOpening = n, ve(t), t.dispatchEvent(u), tt.isOpening = !1;
}
tt.isOpening = !1;
function Kl(t, e) {
  if (t instanceof HTMLAnchorElement) e(t);
  else if (t.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = t.getAttribute("data-href"), t.hasAttribute("data-target") && (n.target = t.getAttribute("data-target")), t.hasAttribute("data-rel") && (n.rel = t.getAttribute("data-rel")), t.hasAttribute("data-download") && (n.download = t.getAttribute("data-download")), t.hasAttribute("data-ping") && (n.ping = t.getAttribute("data-ping")), t.hasAttribute("data-referrer-policy") && (n.referrerPolicy = t.getAttribute("data-referrer-policy")), t.appendChild(n), e(n), t.removeChild(n);
  }
}
function av(t, e) {
  Kl(t, (n) => tt(n, e));
}
function Ll(t) {
  let e = Bt();
  var n;
  const r = e.useHref((n = t.href) !== null && n !== void 0 ? n : "");
  return {
    "data-href": t.href ? r : void 0,
    "data-target": t.target,
    "data-rel": t.rel,
    "data-download": t.download,
    "data-ping": t.ping,
    "data-referrer-policy": t.referrerPolicy
  };
}
function Ml(t) {
  let e = Bt();
  var n;
  const r = e.useHref((n = t?.href) !== null && n !== void 0 ? n : "");
  return {
    href: t?.href ? r : void 0,
    target: t?.target,
    rel: t?.rel,
    download: t?.download,
    ping: t?.ping,
    referrerPolicy: t?.referrerPolicy
  };
}
function Il(t, e, n, r) {
  !e.isNative && t.currentTarget instanceof HTMLAnchorElement && t.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !t.isDefaultPrevented() && Fl(t.currentTarget, t) && n && (t.preventDefault(), e.open(t.currentTarget, t, n, r));
}
let Je = /* @__PURE__ */ new Map(), gr = /* @__PURE__ */ new Set();
function hi() {
  if (typeof window > "u") return;
  function t(r) {
    return "propertyName" in r;
  }
  let e = (r) => {
    if (!t(r) || !r.target) return;
    let i = Je.get(r.target);
    i || (i = /* @__PURE__ */ new Set(), Je.set(r.target, i), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), i.add(r.propertyName);
  }, n = (r) => {
    if (!t(r) || !r.target) return;
    let i = Je.get(r.target);
    if (i && (i.delete(r.propertyName), i.size === 0 && (r.target.removeEventListener("transitioncancel", n), Je.delete(r.target)), Je.size === 0)) {
      for (let l of gr) l();
      gr.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? hi() : document.addEventListener("DOMContentLoaded", hi));
function sv() {
  for (const [t] of Je)
    "isConnected" in t && !t.isConnected && Je.delete(t);
}
function Al(t) {
  requestAnimationFrame(() => {
    sv(), Je.size === 0 ? t() : gr.add(t);
  });
}
function rn() {
  let t = L(/* @__PURE__ */ new Map()), e = j((i, l, o, a) => {
    let s = a?.once ? (...u) => {
      t.current.delete(o), o(...u);
    } : o;
    t.current.set(o, {
      type: l,
      eventTarget: i,
      fn: s,
      options: a
    }), i.addEventListener(l, s, a);
  }, []), n = j((i, l, o, a) => {
    var s;
    let u = ((s = t.current.get(o)) === null || s === void 0 ? void 0 : s.fn) || o;
    i.removeEventListener(l, u, a), t.current.delete(o);
  }, []), r = j(() => {
    t.current.forEach((i, l) => {
      n(i.eventTarget, i.type, l, i.options);
    });
  }, [
    n
  ]);
  return _(() => r, [
    r
  ]), {
    addGlobalListener: e,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Nl(t, e) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = t;
  return n = ae(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && e && (r = e), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
function Ie(t) {
  const e = L(null), n = L(void 0), r = j((i) => {
    if (typeof t == "function") {
      const l = t, o = l(i);
      return () => {
        typeof o == "function" ? o() : l(null);
      };
    } else if (t)
      return t.current = i, () => {
        t.current = null;
      };
  }, [
    t
  ]);
  return z(() => ({
    get current() {
      return e.current;
    },
    set current(i) {
      e.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
function uv(t, e) {
  const n = L(!0), r = L(null);
  _(() => (n.current = !0, () => {
    n.current = !1;
  }), []), _(() => {
    let i = r.current;
    n.current ? n.current = !1 : (!i || e.some((l, o) => !Object.is(l, i[o]))) && t(), r.current = e;
  }, e);
}
function $i(t, e) {
  const n = L(!0), r = L(null);
  X(() => (n.current = !0, () => {
    n.current = !1;
  }), []), X(() => {
    n.current ? n.current = !1 : (!r.current || e.some((i, l) => !Object.is(i, r[l]))) && t(), r.current = e;
  }, e);
}
function dv() {
  return typeof window.ResizeObserver < "u";
}
function Wt(t) {
  const { ref: e, box: n, onResize: r } = t;
  _(() => {
    let i = e?.current;
    if (i)
      if (dv()) {
        const l = new window.ResizeObserver((o) => {
          o.length && r();
        });
        return l.observe(i, {
          box: n
        }), () => {
          i && l.unobserve(i);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    e,
    n
  ]);
}
function zr(t, e) {
  X(() => {
    if (t && t.ref && e)
      return t.ref.current = e.current, () => {
        t.ref && (t.ref.current = null);
      };
  });
}
function bt(t, e) {
  if (!t) return !1;
  let n = window.getComputedStyle(t), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && e && (r = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), r;
}
function ze(t, e) {
  let n = t;
  for (bt(n, e) && (n = n.parentElement); n && !bt(n, e); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function cv(t, e) {
  const n = [];
  for (; t && t !== document.documentElement; )
    bt(t, e) && n.push(t), t = t.parentElement;
  return n;
}
function Pt(t) {
  return vt() ? t.metaKey : t.ctrlKey;
}
const fv = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function _t(t) {
  return t instanceof HTMLInputElement && !fv.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
let Pe = typeof document < "u" && window.visualViewport;
function vv() {
  let t = Me(), [e, n] = W(() => t ? {
    width: 0,
    height: 0
  } : gi());
  return _(() => {
    let r = () => {
      Pe && Pe.scale > 1 || n((o) => {
        let a = gi();
        return a.width === o.width && a.height === o.height ? o : a;
      });
    }, i, l = (o) => {
      Pe && Pe.scale > 1 || _t(o.target) && (i = requestAnimationFrame(() => {
        (!document.activeElement || !_t(document.activeElement)) && n((a) => {
          let s = {
            width: window.innerWidth,
            height: window.innerHeight
          };
          return s.width === a.width && s.height === a.height ? a : s;
        });
      }));
    };
    return window.addEventListener("blur", l, !0), Pe ? Pe.addEventListener("resize", r) : window.addEventListener("resize", r), () => {
      cancelAnimationFrame(i), window.removeEventListener("blur", l, !0), Pe ? Pe.removeEventListener("resize", r) : window.removeEventListener("resize", r);
    };
  }, []), e;
}
function gi() {
  return {
    // Multiply by the visualViewport scale to get the "natural" size, unaffected by pinch zooming.
    width: Pe ? Pe.width * Pe.scale : window.innerWidth,
    height: Pe ? Pe.height * Pe.scale : window.innerHeight
  };
}
let bv = 0;
const nr = /* @__PURE__ */ new Map();
function Hr(t) {
  let [e, n] = W();
  return X(() => {
    if (!t) return;
    let r = nr.get(t);
    if (r)
      n(r.element.id);
    else {
      let i = `react-aria-description-${bv++}`;
      n(i);
      let l = document.createElement("div");
      l.id = i, l.style.display = "none", l.textContent = t, document.body.appendChild(l), r = {
        refCount: 0,
        element: l
      }, nr.set(t, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), nr.delete(t));
    };
  }, [
    t
  ]), {
    "aria-describedby": t ? e : void 0
  };
}
function dt(t, e, n, r) {
  let i = te(n), l = n == null;
  _(() => {
    if (l || !t.current) return;
    let o = t.current;
    return o.addEventListener(e, i, r), () => {
      o.removeEventListener(e, i, r);
    };
  }, [
    t,
    e,
    r,
    l,
    i
  ]);
}
function Rl(t, e) {
  let n = yi(t, e, "left"), r = yi(t, e, "top"), i = e.offsetWidth, l = e.offsetHeight, o = t.scrollLeft, a = t.scrollTop, { borderTopWidth: s, borderLeftWidth: u, scrollPaddingTop: d, scrollPaddingRight: c, scrollPaddingBottom: f, scrollPaddingLeft: v } = getComputedStyle(t), { scrollMarginTop: b, scrollMarginRight: p, scrollMarginBottom: h, scrollMarginLeft: $ } = getComputedStyle(e), y = o + parseInt(u, 10), P = a + parseInt(s, 10), S = y + t.clientWidth, A = P + t.clientHeight, w = parseInt(d, 10) || 0, M = parseInt(f, 10) || 0, T = parseInt(c, 10) || 0, N = parseInt(v, 10) || 0, I = parseInt(b, 10) || 0, m = parseInt(h, 10) || 0, K = parseInt(p, 10) || 0, B = parseInt($, 10) || 0, D = n - B, F = n + i + K, g = r - I, E = r + l + m, k = o + parseInt(u, 10) + N, V = S - T, C = a + parseInt(s, 10) + w, Y = A - M;
  if ((D > k || F < V) && (D <= o + N ? o = D - parseInt(u, 10) - N : F > S - T && (o += F - S + T)), (g > C || E < Y) && (g <= P + w ? a = g - parseInt(s, 10) - w : E > A - M && (a += E - A + M)), process.env.NODE_ENV === "test") {
    t.scrollLeft = o, t.scrollTop = a;
    return;
  }
  t.scrollTo({
    left: o,
    top: a
  });
}
function yi(t, e, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let i = 0;
  for (; e.offsetParent && (i += e[r], e.offsetParent !== t); ) {
    if (e.offsetParent.contains(t)) {
      i -= t[r];
      break;
    }
    e = e.offsetParent;
  }
  return i;
}
function Ze(t, e) {
  if (t && document.contains(t)) {
    let o = document.scrollingElement || document.documentElement;
    if (!(window.getComputedStyle(o).overflow === "hidden") && !Vr()) {
      var n;
      let { left: s, top: u } = t.getBoundingClientRect();
      t == null || (n = t.scrollIntoView) === null || n === void 0 || n.call(t, {
        block: "nearest"
      });
      let { left: d, top: c } = t.getBoundingClientRect();
      if (Math.abs(s - d) > 1 || Math.abs(u - c) > 1) {
        var r, i, l;
        e == null || (i = e.containingElement) === null || i === void 0 || (r = i.scrollIntoView) === null || r === void 0 || r.call(i, {
          block: "center",
          inline: "center"
        }), (l = t.scrollIntoView) === null || l === void 0 || l.call(t, {
          block: "nearest"
        });
      }
    } else {
      let s = cv(t);
      for (let u of s) Rl(u, t);
    }
  }
}
function yr(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : Vn() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function pv(t) {
  return !Vn() && t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse";
}
function o0(t, e) {
  let n = L(null);
  return t && n.current && e(t, n.current) && (t = n.current), n.current = t, t;
}
function _r(t, e, n) {
  let r = te(() => {
    n && n(e);
  });
  _(() => {
    var i;
    let l = t == null || (i = t.current) === null || i === void 0 ? void 0 : i.form;
    return l?.addEventListener("reset", r), () => {
      l?.removeEventListener("reset", r);
    };
  }, [
    t,
    r
  ]);
}
function mv(t, e) {
  let { collection: n, onLoadMore: r, scrollOffset: i = 1 } = t, l = L(null), o = te((a) => {
    for (let s of a)
      s.isIntersecting && r && r();
  });
  X(() => (e.current && (l.current = new IntersectionObserver(o, {
    root: ze(e?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), l.current.observe(e.current)), () => {
    l.current && l.current.disconnect();
  }), [
    n,
    o,
    e,
    i
  ]);
}
function hv(t) {
  const e = Tf.split(".");
  return parseInt(e[0], 10) >= 19 ? t : t ? "true" : void 0;
}
const $v = "react-aria-clear-focus", gv = "react-aria-focus";
function zn(t, e = !0) {
  let [n, r] = W(!0), i = n && e;
  return X(() => {
    if (i && t.current && "getAnimations" in t.current)
      for (let l of t.current.getAnimations()) l instanceof CSSTransition && l.cancel();
  }, [
    t,
    i
  ]), Ol(t, i, j(() => r(!1), [])), i;
}
function Pn(t, e) {
  let [n, r] = W(e ? "open" : "closed");
  switch (n) {
    case "open":
      e || r("exiting");
      break;
    case "closed":
    case "exiting":
      e && r("open");
      break;
  }
  let i = n === "exiting";
  return Ol(t, i, j(() => {
    r((l) => l === "exiting" ? "closed" : l);
  }, [])), i;
}
function Ol(t, e, n) {
  X(() => {
    if (e && t.current) {
      if (!("getAnimations" in t.current)) {
        n();
        return;
      }
      let r = t.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.all(r.map((l) => l.finished)).then(() => {
        i || Nn(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        i = !0;
      };
    }
  }, [
    t,
    e,
    n
  ]);
}
const yv = typeof Element < "u" && "checkVisibility" in Element.prototype;
function xv(t) {
  const e = ge(t);
  if (!(t instanceof e.HTMLElement) && !(t instanceof e.SVGElement)) return !1;
  let { display: n, visibility: r } = t.style, i = n !== "none" && r !== "hidden" && r !== "collapse";
  if (i) {
    const { getComputedStyle: l } = t.ownerDocument.defaultView;
    let { display: o, visibility: a } = l(t);
    i = o !== "none" && a !== "hidden" && a !== "collapse";
  }
  return i;
}
function Ev(t, e) {
  return !t.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !t.hasAttribute("data-react-aria-prevent-focus") && (t.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? t.hasAttribute("open") : !0);
}
function Ur(t, e) {
  return yv ? t.checkVisibility({
    visibilityProperty: !0
  }) && !t.closest("[data-react-aria-prevent-focus]") : t.nodeName !== "#comment" && xv(t) && Ev(t, e) && (!t.parentElement || Ur(t.parentElement, t));
}
const jr = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], Pv = jr.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
jr.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const Dv = jr.join(':not([hidden]):not([tabindex="-1"]),');
function Wr(t) {
  return t.matches(Pv) && Ur(t) && !Vl(t);
}
function Sv(t) {
  return t.matches(Dv) && Ur(t) && !Vl(t);
}
function Vl(t) {
  let e = t;
  for (; e != null; ) {
    if (e instanceof e.ownerDocument.defaultView.HTMLElement && e.inert) return !0;
    e = e.parentElement;
  }
  return !1;
}
function We(t, e, n) {
  let [r, i] = W(t || e), l = L(t !== void 0), o = t !== void 0;
  _(() => {
    let u = l.current;
    u !== o && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${u ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), l.current = o;
  }, [
    o
  ]);
  let a = o ? t : r, s = j((u, ...d) => {
    let c = (f, ...v) => {
      n && (Object.is(a, f) || n(f, ...v)), o || (a = f);
    };
    typeof u == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((v, ...b) => {
      let p = u(o ? a : v, ...b);
      return c(p, ...d), o ? v : p;
    })) : (o || i(u), c(u, ...d));
  }, [
    o,
    a,
    n
  ]);
  return [
    a,
    s
  ];
}
function et(t, e = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(t, e), n);
}
function cn(t, e) {
  let n = t, r = 0, i = e.toString(), l = i.toLowerCase().indexOf("e-");
  if (l > 0) r = Math.abs(Math.floor(Math.log10(Math.abs(e)))) + l;
  else {
    let o = i.indexOf(".");
    o >= 0 && (r = i.length - o);
  }
  if (r > 0) {
    let o = Math.pow(10, r);
    n = Math.round(n * o) / o;
  }
  return n;
}
function Oe(t, e, n, r) {
  e = Number(e), n = Number(n);
  let i = (t - (isNaN(e) ? 0 : e)) % r, l = cn(Math.abs(i) * 2 >= r ? t + Math.sign(i) * (r - Math.abs(i)) : t - i, r);
  return isNaN(e) ? !isNaN(n) && l > n && (l = Math.floor(cn(n / r, r)) * r) : l < e ? l = e : !isNaN(n) && l > n && (l = e + Math.floor(cn((n - e) / r, r)) * r), l = cn(l, r), l;
}
const Gt = Symbol("default");
function pe({ values: t, children: e }) {
  for (let [n, r] of t)
    e = /* @__PURE__ */ x.createElement(n.Provider, {
      value: r
    }, e);
  return e;
}
function le(t) {
  let { className: e, style: n, children: r, defaultClassName: i, defaultChildren: l, defaultStyle: o, values: a } = t;
  return z(() => {
    let s, u, d;
    return typeof e == "function" ? s = e({
      ...a,
      defaultClassName: i
    }) : s = e, typeof n == "function" ? u = n({
      ...a,
      defaultStyle: o || {}
    }) : u = n, typeof r == "function" ? d = r({
      ...a,
      defaultChildren: l
    }) : r == null ? d = l : d = r, {
      className: s ?? i,
      style: u || o ? {
        ...o,
        ...u
      } : void 0,
      children: d ?? l,
      "data-rac": ""
    };
  }, [
    e,
    n,
    r,
    i,
    l,
    o,
    a
  ]);
}
function mt(t, e) {
  let n = H(t);
  if (e === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = e || Gt;
    if (!n.slots[r]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((o) => `"${o}"`)), l = e ? `Invalid slot "${e}".` : "A slot prop is required.";
      throw new Error(`${l} Valid slot names are ${i}.`);
    }
    return n.slots[r];
  }
  return n;
}
function ee(t, e, n) {
  let r = mt(n, t.slot) || {}, { ref: i, ...l } = r, o = Ie(z(() => tn(e, i), [
    e,
    i
  ])), a = R(l, t);
  return "style" in l && l.style && "style" in t && t.style && (typeof l.style == "function" || typeof t.style == "function" ? a.style = (s) => {
    let u = typeof l.style == "function" ? l.style(s) : l.style, d = {
      ...s.defaultStyle,
      ...u
    }, c = typeof t.style == "function" ? t.style({
      ...s,
      defaultStyle: d
    }) : t.style;
    return {
      ...d,
      ...c
    };
  } : a.style = {
    ...l.style,
    ...t.style
  }), [
    a,
    o
  ];
}
function Ft(t = !0) {
  let [e, n] = W(t), r = L(!1), i = j((l) => {
    r.current = !0, n(!!l);
  }, []);
  return X(() => {
    r.current || n(!1);
  }, []), [
    i,
    e
  ];
}
function qt(t) {
  const e = /^(data-.*)$/;
  let n = {};
  for (const r in t) e.test(r) || (n[r] = t[r]);
  return n;
}
const zl = 7e3;
let De = null;
function Dn(t, e = "assertive", n = zl) {
  De ? De.announce(t, e, n) : (De = new wv(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? De.announce(t, e, n) : setTimeout(() => {
    De?.isAttached() && De?.announce(t, e, n);
  }, 100));
}
function Cv(t) {
  De && De.clear(t);
}
class wv {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", e), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, n = "assertive", r = zl) {
    var i, l;
    if (!this.node) return;
    let o = document.createElement("div");
    typeof e == "object" ? (o.setAttribute("role", "img"), o.setAttribute("aria-labelledby", e["aria-labelledby"])) : o.textContent = e, n === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(o) : (l = this.politeLog) === null || l === void 0 || l.appendChild(o), e !== "" && setTimeout(() => {
      o.remove();
    }, r);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const Le = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, Sn = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Tv = {
  top: "left",
  left: "top"
}, xr = {
  top: "height",
  left: "width"
}, Hl = {
  width: "totalWidth",
  height: "totalHeight"
}, fn = {};
let ce = typeof document < "u" ? window.visualViewport : null;
function xi(t) {
  let e = 0, n = 0, r = 0, i = 0, l = 0, o = 0, a = {};
  var s;
  let u = ((s = ce?.scale) !== null && s !== void 0 ? s : 1) > 1;
  if (t.tagName === "BODY") {
    let b = document.documentElement;
    r = b.clientWidth, i = b.clientHeight;
    var d;
    e = (d = ce?.width) !== null && d !== void 0 ? d : r;
    var c;
    n = (c = ce?.height) !== null && c !== void 0 ? c : i, a.top = b.scrollTop || t.scrollTop, a.left = b.scrollLeft || t.scrollLeft, ce && (l = ce.offsetTop, o = ce.offsetLeft);
  } else
    ({ width: e, height: n, top: l, left: o } = wt(t, !1)), a.top = t.scrollTop, a.left = t.scrollLeft, r = e, i = n;
  if (kl() && (t.tagName === "BODY" || t.tagName === "HTML") && u) {
    a.top = 0, a.left = 0;
    var f;
    l = (f = ce?.pageTop) !== null && f !== void 0 ? f : 0;
    var v;
    o = (v = ce?.pageLeft) !== null && v !== void 0 ? v : 0;
  }
  return {
    width: e,
    height: n,
    totalWidth: r,
    totalHeight: i,
    scroll: a,
    top: l,
    left: o
  };
}
function kv(t) {
  return {
    top: t.scrollTop,
    left: t.scrollLeft,
    width: t.scrollWidth,
    height: t.scrollHeight
  };
}
function Ei(t, e, n, r, i, l, o) {
  var a;
  let s = (a = i.scroll[t]) !== null && a !== void 0 ? a : 0, u = r[xr[t]], d = r.scroll[Le[t]] + l, c = u + r.scroll[Le[t]] - l, f = e - s + o[t] - r[Le[t]], v = e - s + n + o[t] - r[Le[t]];
  return f < d ? d - f : v > c ? Math.max(c - v, d - f) : 0;
}
function Bv(t) {
  let e = window.getComputedStyle(t);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function Pi(t) {
  if (fn[t]) return fn[t];
  let [e, n] = t.split(" "), r = Le[e] || "right", i = Tv[r];
  Le[n] || (n = "center");
  let l = xr[r], o = xr[i];
  return fn[t] = {
    placement: e,
    crossPlacement: n,
    axis: r,
    crossAxis: i,
    size: l,
    crossSize: o
  }, fn[t];
}
function rr(t, e, n, r, i, l, o, a, s, u) {
  let { placement: d, crossPlacement: c, axis: f, crossAxis: v, size: b, crossSize: p } = r, h = {};
  var $;
  h[v] = ($ = t[v]) !== null && $ !== void 0 ? $ : 0;
  var y, P, S, A;
  c === "center" ? h[v] += (((y = t[p]) !== null && y !== void 0 ? y : 0) - ((P = n[p]) !== null && P !== void 0 ? P : 0)) / 2 : c !== v && (h[v] += ((S = t[p]) !== null && S !== void 0 ? S : 0) - ((A = n[p]) !== null && A !== void 0 ? A : 0)), h[v] += l;
  const w = t[v] - n[p] + s + u, M = t[v] + t[p] - s - u;
  if (h[v] = et(h[v], w, M), d === f) {
    const T = a ? o[b] : e[Hl[b]];
    h[Sn[f]] = Math.floor(T - t[f] + i);
  } else h[f] = Math.floor(t[f] + t[b] + i);
  return h;
}
function Fv(t, e, n, r, i, l, o, a) {
  const s = r ? n.height : e[Hl.height];
  var u;
  let d = t.top != null ? n.top + t.top : n.top + (s - ((u = t.bottom) !== null && u !== void 0 ? u : 0) - o);
  var c, f, v, b, p, h;
  let $ = a !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, e.height + e.top + ((c = e.scroll.top) !== null && c !== void 0 ? c : 0) - d - (((f = i.top) !== null && f !== void 0 ? f : 0) + ((v = i.bottom) !== null && v !== void 0 ? v : 0) + l))
  ) : Math.max(0, d + o - (e.top + ((b = e.scroll.top) !== null && b !== void 0 ? b : 0)) - (((p = i.top) !== null && p !== void 0 ? p : 0) + ((h = i.bottom) !== null && h !== void 0 ? h : 0) + l));
  return Math.min(e.height - l * 2, $);
}
function Di(t, e, n, r, i, l) {
  let { placement: o, axis: a, size: s } = l;
  var u, d;
  if (o === a) return Math.max(0, n[a] - t[a] - ((u = t.scroll[a]) !== null && u !== void 0 ? u : 0) + e[a] - ((d = r[a]) !== null && d !== void 0 ? d : 0) - r[Sn[a]] - i);
  var c;
  return Math.max(0, t[s] + t[a] + t.scroll[a] - e[a] - n[a] - n[s] - ((c = r[a]) !== null && c !== void 0 ? c : 0) - r[Sn[a]] - i);
}
function Kv(t, e, n, r, i, l, o, a, s, u, d, c, f, v, b, p) {
  let h = Pi(t), { size: $, crossAxis: y, crossSize: P, placement: S, crossPlacement: A } = h, w = rr(e, a, n, h, d, c, u, f, b, p), M = d, T = Di(a, u, e, i, l + d, h);
  if (o && r[$] > T) {
    let Te = Pi(`${Sn[S]} ${A}`), ye = rr(e, a, n, Te, d, c, u, f, b, p);
    Di(a, u, e, i, l + d, Te) > T && (h = Te, w = ye, M = d);
  }
  let N = "bottom";
  h.axis === "top" ? h.placement === "top" ? N = "top" : h.placement === "bottom" && (N = "bottom") : h.crossAxis === "top" && (h.crossPlacement === "top" ? N = "bottom" : h.crossPlacement === "bottom" && (N = "top"));
  let I = Ei(y, w[y], n[P], a, s, l, u);
  w[y] += I;
  let m = Fv(w, a, u, f, i, l, n.height, N);
  v && v < m && (m = v), n.height = Math.min(n.height, m), w = rr(e, a, n, h, M, c, u, f, b, p), I = Ei(y, w[y], n[P], a, s, l, u), w[y] += I;
  let K = {}, B = e[y] - w[y] - i[Le[y]], D = B + 0.5 * e[P];
  const F = b / 2 + p;
  var g, E, k, V;
  const C = Le[y] === "left" ? ((g = i.left) !== null && g !== void 0 ? g : 0) + ((E = i.right) !== null && E !== void 0 ? E : 0) : ((k = i.top) !== null && k !== void 0 ? k : 0) + ((V = i.bottom) !== null && V !== void 0 ? V : 0), Y = n[P] - C - b / 2 - p, ne = e[y] + b / 2 - (w[y] + i[Le[y]]), G = e[y] + e[P] - b / 2 - (w[y] + i[Le[y]]), fe = et(D, ne, G);
  K[y] = et(fe, F, Y), { placement: S, crossPlacement: A } = h, b ? B = K[y] : A === "right" ? B += e[P] : A === "center" && (B += e[P] / 2);
  let se = S === "left" || S === "top" ? n[$] : 0, me = {
    x: S === "top" || S === "bottom" ? B : se,
    y: S === "left" || S === "right" ? B : se
  };
  return {
    position: w,
    maxHeight: m,
    arrowOffsetLeft: K.left,
    arrowOffsetTop: K.top,
    placement: S,
    triggerAnchorPoint: me
  };
}
function Lv(t) {
  let { placement: e, targetNode: n, overlayNode: r, scrollNode: i, padding: l, shouldFlip: o, boundaryElement: a, offset: s, crossOffset: u, maxHeight: d, arrowSize: c = 0, arrowBoundaryOffset: f = 0 } = t, v = r instanceof HTMLElement ? Mv(r) : document.documentElement, b = v === document.documentElement;
  const p = window.getComputedStyle(v).position;
  let h = !!p && p !== "static", $ = b ? wt(n, !1) : Si(n, v, !1);
  if (!b) {
    let { marginTop: K, marginLeft: B } = window.getComputedStyle(n);
    $.top += parseInt(K, 10) || 0, $.left += parseInt(B, 10) || 0;
  }
  let y = wt(r, !0), P = Bv(r);
  var S, A;
  y.width += ((S = P.left) !== null && S !== void 0 ? S : 0) + ((A = P.right) !== null && A !== void 0 ? A : 0);
  var w, M;
  y.height += ((w = P.top) !== null && w !== void 0 ? w : 0) + ((M = P.bottom) !== null && M !== void 0 ? M : 0);
  let T = kv(i), N = xi(a), I = xi(v), m = a.tagName === "BODY" ? wt(v, !1) : Si(v, a, !1);
  return v.tagName === "HTML" && a.tagName === "BODY" && (I.scroll.top = 0, I.scroll.left = 0), Kv(e, $, y, T, P, l, o, N, I, m, s, u, h, d, c, f);
}
function Gr(t, e) {
  let { top: n, left: r, width: i, height: l } = t.getBoundingClientRect();
  return e && t instanceof t.ownerDocument.defaultView.HTMLElement && (i = t.offsetWidth, l = t.offsetHeight), {
    top: n,
    left: r,
    width: i,
    height: l
  };
}
function wt(t, e) {
  let { top: n, left: r, width: i, height: l } = Gr(t, e), { scrollTop: o, scrollLeft: a, clientTop: s, clientLeft: u } = document.documentElement;
  return {
    top: n + o - s,
    left: r + a - u,
    width: i,
    height: l
  };
}
function Si(t, e, n) {
  let r = window.getComputedStyle(t), i;
  if (r.position === "fixed") i = Gr(t, n);
  else {
    i = wt(t, n);
    let l = wt(e, n), o = window.getComputedStyle(e);
    l.top += (parseInt(o.borderTopWidth, 10) || 0) - e.scrollTop, l.left += (parseInt(o.borderLeftWidth, 10) || 0) - e.scrollLeft, i.top -= l.top, i.left -= l.left;
  }
  return i.top -= parseInt(r.marginTop, 10) || 0, i.left -= parseInt(r.marginLeft, 10) || 0, i;
}
function Mv(t) {
  let e = t.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !Ci(e) && (e = document.documentElement), e == null)
    for (e = t.parentElement; e && !Ci(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function Ci(t) {
  let e = window.getComputedStyle(t);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const _l = /* @__PURE__ */ new WeakMap();
function Iv(t) {
  let { triggerRef: e, isOpen: n, onClose: r } = t;
  _(() => {
    if (!n || r === null) return;
    let i = (l) => {
      let o = l.target;
      if (!e.current || o instanceof Node && !o.contains(e.current) || l.target instanceof HTMLInputElement || l.target instanceof HTMLTextAreaElement) return;
      let a = r || _l.get(e.current);
      a && a();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    r,
    e
  ]);
}
const Av = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Nv = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Rv(t) {
  if (Intl.Locale) {
    let n = new Intl.Locale(t).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Av.has(n.script);
  }
  let e = t.split("-")[0];
  return Nv.has(e);
}
const Ov = Symbol.for("react-aria.i18n.locale");
function Ul() {
  let t = typeof window < "u" && window[Ov] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      t
    ]);
  } catch {
    t = "en-US";
  }
  return {
    locale: t,
    direction: Rv(t) ? "rtl" : "ltr"
  };
}
let Er = Ul(), zt = /* @__PURE__ */ new Set();
function wi() {
  Er = Ul();
  for (let t of zt) t(Er);
}
function Vv() {
  let t = Me(), [e, n] = W(Er);
  return _(() => (zt.size === 0 && window.addEventListener("languagechange", wi), zt.add(n), () => {
    zt.delete(n), zt.size === 0 && window.removeEventListener("languagechange", wi);
  }), []), t ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const zv = /* @__PURE__ */ x.createContext(null);
function Ae() {
  let t = Vv();
  return H(zv) || t;
}
const Hv = Symbol.for("react-aria.i18n.locale"), _v = Symbol.for("react-aria.i18n.strings");
let xt;
class Hn {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, n) {
    let i = this.getStringsForLocale(n)[e];
    if (!i) throw new Error(`Could not find intl message ${e} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let n = this.strings[e];
    return n || (n = Uv(e, this.strings, this.defaultLocale), this.strings[e] = n), n;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let n = window[Hv];
    if (xt === void 0) {
      let i = window[_v];
      if (!i) return null;
      xt = {};
      for (let l in i) xt[l] = new Hn({
        [n]: i[l]
      }, n);
    }
    let r = xt?.[e];
    if (!r) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(e, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function Uv(t, e, n = "en-US") {
  if (e[t]) return e[t];
  let r = jv(t);
  if (e[r]) return e[r];
  for (let i in e)
    if (i.startsWith(r + "-")) return e[i];
  return e[n];
}
function jv(t) {
  return Intl.Locale ? new Intl.Locale(t).language : t.split("-")[0];
}
const Ti = /* @__PURE__ */ new Map(), ki = /* @__PURE__ */ new Map();
class Wv {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, n) {
    let r = this.strings.getStringForLocale(e, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(e, n, r = "cardinal") {
    let i = n["=" + e];
    if (i) return typeof i == "function" ? i() : i;
    let l = this.locale + ":" + r, o = Ti.get(l);
    o || (o = new Intl.PluralRules(this.locale, {
      type: r
    }), Ti.set(l, o));
    let a = o.select(e);
    return i = n[a] || n.other, typeof i == "function" ? i() : i;
  }
  number(e) {
    let n = ki.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), ki.set(this.locale, n)), n.format(e);
  }
  select(e, n) {
    let r = e[n] || e.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(e, n) {
    this.locale = e, this.strings = n;
  }
}
const Bi = /* @__PURE__ */ new WeakMap();
function Gv(t) {
  let e = Bi.get(t);
  return e || (e = new Hn(t), Bi.set(t, e)), e;
}
function qv(t, e) {
  return e && Hn.getGlobalDictionaryForPackage(e) || Gv(t);
}
function Ge(t, e) {
  let { locale: n } = Ae(), r = qv(t, e);
  return z(() => new Wv(n, r), [
    n,
    r
  ]);
}
function Yv(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Xv(t, e, n) {
  Yv(t, e), e.set(t, n);
}
let ir = /* @__PURE__ */ new Map(), Pr = !1;
try {
  Pr = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Cn = !1;
try {
  Cn = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const jl = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class wn {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(e) {
    let n = "";
    if (!Pr && this.options.signDisplay != null ? n = Jv(this.numberFormatter, this.options.signDisplay, e) : n = this.numberFormatter.format(e), this.options.style === "unit" && !Cn) {
      var r;
      let { unit: i, unitDisplay: l = "short", locale: o } = this.resolvedOptions();
      if (!i) return n;
      let a = (r = jl[i]) === null || r === void 0 ? void 0 : r[l];
      n += a[o] || a.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(e) {
    return this.numberFormatter.formatToParts(e);
  }
  /** Formats a number range as a string. */
  formatRange(e, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    return `${this.format(e)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(e, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(e), i = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...i.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let e = this.numberFormatter.resolvedOptions();
    return !Pr && this.options.signDisplay != null && (e = {
      ...e,
      signDisplay: this.options.signDisplay
    }), !Cn && this.options.style === "unit" && (e = {
      ...e,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), e;
  }
  constructor(e, n = {}) {
    this.numberFormatter = Zv(e, n), this.options = n;
  }
}
function Zv(t, e = {}) {
  let { numberingSystem: n } = e;
  if (n && t.includes("-nu-") && (t.includes("-u-") || (t += "-u-"), t += `-nu-${n}`), e.style === "unit" && !Cn) {
    var r;
    let { unit: o, unitDisplay: a = "short" } = e;
    if (!o) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = jl[o]) === null || r === void 0) && r[a])) throw new Error(`Unsupported unit ${o} with unitDisplay = ${a}`);
    e = {
      ...e,
      style: "decimal"
    };
  }
  let i = t + (e ? Object.entries(e).sort((o, a) => o[0] < a[0] ? -1 : 1).join() : "");
  if (ir.has(i)) return ir.get(i);
  let l = new Intl.NumberFormat(t, e);
  return ir.set(i, l), l;
}
function Jv(t, e, n) {
  if (e === "auto") return t.format(n);
  if (e === "never") return t.format(Math.abs(n));
  {
    let r = !1;
    if (e === "always" ? r = n > 0 || Object.is(n, 0) : e === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let i = t.format(-n), l = t.format(n), o = i.replace(l, "").replace(/\u200e|\u061C/, "");
      return [
        ...o
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), i.replace(l, "!!!").replace(o, "+").replace("!!!", l);
    } else return t.format(n);
  }
}
const Qv = new RegExp("^.*\\(.*\\).*$"), eb = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng",
  "fullwide"
];
class Wl {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(e) {
    return lr(this.locale, this.options, e).parse(e);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(e, n, r) {
    return lr(this.locale, this.options, e).isValidPartialNumber(e, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(e) {
    return lr(this.locale, this.options, e).options.numberingSystem;
  }
  constructor(e, n = {}) {
    this.locale = e, this.options = n;
  }
}
const Fi = /* @__PURE__ */ new Map();
function lr(t, e, n) {
  let r = Ki(t, e);
  if (!t.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let i of eb) if (i !== r.options.numberingSystem) {
      let l = Ki(t + (t.includes("-u-") ? "-nu-" : "-u-nu-") + i, e);
      if (l.isValidPartialNumber(n)) return l;
    }
  }
  return r;
}
function Ki(t, e) {
  let n = t + (e ? Object.entries(e).sort((i, l) => i[0] < l[0] ? -1 : 1).join() : ""), r = Fi.get(n);
  return r || (r = new tb(t, e), Fi.set(n, r)), r;
}
class tb {
  parse(e) {
    let n = this.sanitize(e);
    if (this.symbols.group && (n = Et(n, this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let o = n.indexOf("-");
      n = n.replace("-", ""), n = n.replace("+", "");
      let a = n.indexOf(".");
      a === -1 && (a = n.length), n = n.replace(".", ""), a - 2 === 0 ? n = `0.${n}` : a - 2 === -1 ? n = `0.0${n}` : a - 2 === -2 ? n = "0.00" : n = `${n.slice(0, a - 2)}.${n.slice(a - 2)}`, o > -1 && (n = `-${n}`);
    }
    let r = n ? +n : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var i, l;
      let o = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((i = this.options.minimumFractionDigits) !== null && i !== void 0 ? i : 0) + 2, 20),
        maximumFractionDigits: Math.min(((l = this.options.maximumFractionDigits) !== null && l !== void 0 ? l : 0) + 2, 20)
      };
      return new Wl(this.locale, o).parse(new wn(this.locale, o).format(r));
    }
    return this.options.currencySign === "accounting" && Qv.test(e) && (r = -1 * r), r;
  }
  sanitize(e) {
    return e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (e = e.replace(",", this.symbols.decimal), e = e.replace("،", this.symbols.decimal)), this.symbols.group && (e = Et(e, ".", this.symbols.group))), this.symbols.group === "’" && e.includes("'") && (e = Et(e, "'", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && (e = Et(e, " ", this.symbols.group), e = Et(e, /\u00A0/g, this.symbols.group)), e;
  }
  isValidPartialNumber(e, n = -1 / 0, r = 1 / 0) {
    return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && n < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && r > 0 && (e = e.slice(this.symbols.plusSign.length)), this.symbols.group && e.startsWith(this.symbols.group) || this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (e = Et(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), e.length === 0);
  }
  constructor(e, n = {}) {
    this.locale = e, n.roundingIncrement !== 1 && n.roundingIncrement != null && (n.maximumFractionDigits == null && n.minimumFractionDigits == null ? (n.maximumFractionDigits = 0, n.minimumFractionDigits = 0) : n.maximumFractionDigits == null ? n.maximumFractionDigits = n.minimumFractionDigits : n.minimumFractionDigits == null && (n.minimumFractionDigits = n.maximumFractionDigits)), this.formatter = new Intl.NumberFormat(e, n), this.options = this.formatter.resolvedOptions(), this.symbols = rb(e, this.formatter, this.options, n);
    var r, i;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((i = this.options.maximumFractionDigits) !== null && i !== void 0 ? i : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const Li = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), nb = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function rb(t, e, n, r) {
  var i, l, o, a;
  let s = new Intl.NumberFormat(t, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand"
  }), u = s.formatToParts(-10000.111), d = s.formatToParts(10000.111), c = nb.map((I) => s.formatToParts(I));
  var f;
  let v = (f = (i = u.find((I) => I.type === "minusSign")) === null || i === void 0 ? void 0 : i.value) !== null && f !== void 0 ? f : "-", b = (l = d.find((I) => I.type === "plusSign")) === null || l === void 0 ? void 0 : l.value;
  !b && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (b = "+");
  let h = (o = new Intl.NumberFormat(t, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((I) => I.type === "decimal")) === null || o === void 0 ? void 0 : o.value, $ = (a = u.find((I) => I.type === "group")) === null || a === void 0 ? void 0 : a.value, y = u.filter((I) => !Li.has(I.type)).map((I) => Mi(I.value)), P = c.flatMap((I) => I.filter((m) => !Li.has(m.type)).map((m) => Mi(m.value))), S = [
    .../* @__PURE__ */ new Set([
      ...y,
      ...P
    ])
  ].sort((I, m) => m.length - I.length), A = S.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${S.join("|")}|[\\p{White_Space}]`, "gu"), w = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), M = new Map(w.map((I, m) => [
    I,
    m
  ])), T = new RegExp(`[${w.join("")}]`, "g");
  return {
    minusSign: v,
    plusSign: b,
    decimal: h,
    group: $,
    literals: A,
    numeral: T,
    index: (I) => String(M.get(I))
  };
}
function Et(t, e, n) {
  return t.replaceAll ? t.replaceAll(e, n) : t.split(e).join(n);
}
function Mi(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Dr(t = {}) {
  let { locale: e } = Ae();
  return z(() => new wn(e, t), [
    e,
    t
  ]);
}
let or = /* @__PURE__ */ new Map();
function Gl(t) {
  let { locale: e } = Ae(), n = e + (t ? Object.entries(t).sort((i, l) => i[0] < l[0] ? -1 : 1).join() : "");
  if (or.has(n)) return or.get(n);
  let r = new Intl.Collator(e, t);
  return or.set(n, r), r;
}
function a0(t) {
  let e = Gl({
    usage: "search",
    ...t
  }), n = j((l, o) => o.length === 0 ? !0 : (l = l.normalize("NFC"), o = o.normalize("NFC"), e.compare(l.slice(0, o.length), o) === 0), [
    e
  ]), r = j((l, o) => o.length === 0 ? !0 : (l = l.normalize("NFC"), o = o.normalize("NFC"), e.compare(l.slice(-o.length), o) === 0), [
    e
  ]), i = j((l, o) => {
    if (o.length === 0) return !0;
    l = l.normalize("NFC"), o = o.normalize("NFC");
    let a = 0, s = o.length;
    for (; a + s <= l.length; a++) {
      let u = l.slice(a, a + s);
      if (e.compare(o, u) === 0) return !0;
    }
    return !1;
  }, [
    e
  ]);
  return z(() => ({
    startsWith: n,
    endsWith: r,
    contains: i
  }), [
    n,
    r,
    i
  ]);
}
let ue = typeof document < "u" ? window.visualViewport : null;
function ql(t) {
  let { direction: e } = Ae(), { arrowSize: n, targetRef: r, overlayRef: i, arrowRef: l, scrollRef: o = i, placement: a = "bottom", containerPadding: s = 12, shouldFlip: u = !0, boundaryElement: d = typeof document < "u" ? document.body : null, offset: c = 0, crossOffset: f = 0, shouldUpdatePosition: v = !0, isOpen: b = !0, onClose: p, maxHeight: h, arrowBoundaryOffset: $ = 0 } = t, [y, P] = W(null), S = [
    v,
    a,
    i.current,
    r.current,
    l?.current,
    o.current,
    s,
    u,
    d,
    c,
    f,
    b,
    e,
    h,
    $,
    n
  ], A = L(ue?.scale);
  _(() => {
    b && (A.current = ue?.scale);
  }, [
    b
  ]);
  let w = j(() => {
    if (v === !1 || !b || !i.current || !r.current || !d || ue?.scale !== A.current) return;
    let K = null;
    if (o.current && o.current.contains(document.activeElement)) {
      var B;
      let C = (B = document.activeElement) === null || B === void 0 ? void 0 : B.getBoundingClientRect(), Y = o.current.getBoundingClientRect();
      var D;
      if (K = {
        type: "top",
        offset: ((D = C?.top) !== null && D !== void 0 ? D : 0) - Y.top
      }, K.offset > Y.height / 2) {
        K.type = "bottom";
        var F;
        K.offset = ((F = C?.bottom) !== null && F !== void 0 ? F : 0) - Y.bottom;
      }
    }
    let g = i.current;
    if (!h && i.current) {
      var E;
      g.style.top = "0px", g.style.bottom = "";
      var k;
      g.style.maxHeight = ((k = (E = window.visualViewport) === null || E === void 0 ? void 0 : E.height) !== null && k !== void 0 ? k : window.innerHeight) + "px";
    }
    let V = Lv({
      placement: lb(a, e),
      overlayNode: i.current,
      targetNode: r.current,
      scrollNode: o.current || i.current,
      padding: s,
      shouldFlip: u,
      boundaryElement: d,
      offset: c,
      crossOffset: f,
      maxHeight: h,
      arrowSize: n ?? (l?.current ? Gr(l.current, !0).width : 0),
      arrowBoundaryOffset: $
    });
    if (V.position) {
      if (g.style.top = "", g.style.bottom = "", g.style.left = "", g.style.right = "", Object.keys(V.position).forEach((C) => g.style[C] = V.position[C] + "px"), g.style.maxHeight = V.maxHeight != null ? V.maxHeight + "px" : "", K && document.activeElement && o.current) {
        let C = document.activeElement.getBoundingClientRect(), Y = o.current.getBoundingClientRect(), ne = C[K.type] - Y[K.type];
        o.current.scrollTop += ne - K.offset;
      }
      P(V);
    }
  }, S);
  X(w, S), ib(w), Wt({
    ref: i,
    onResize: w
  }), Wt({
    ref: r,
    onResize: w
  });
  let M = L(!1);
  X(() => {
    let K, B = () => {
      M.current = !0, clearTimeout(K), K = setTimeout(() => {
        M.current = !1;
      }, 500), w();
    }, D = () => {
      M.current && B();
    };
    return ue?.addEventListener("resize", B), ue?.addEventListener("scroll", D), () => {
      ue?.removeEventListener("resize", B), ue?.removeEventListener("scroll", D);
    };
  }, [
    w
  ]);
  let T = j(() => {
    M.current || p?.();
  }, [
    p,
    M
  ]);
  Iv({
    triggerRef: r,
    isOpen: b,
    onClose: p && T
  });
  var N, I, m;
  return {
    overlayProps: {
      style: {
        position: y ? "absolute" : "fixed",
        top: y ? void 0 : 0,
        left: y ? void 0 : 0,
        zIndex: 1e5,
        ...y?.position,
        maxHeight: (N = y?.maxHeight) !== null && N !== void 0 ? N : "100vh"
      }
    },
    placement: (I = y?.placement) !== null && I !== void 0 ? I : null,
    triggerAnchorPoint: (m = y?.triggerAnchorPoint) !== null && m !== void 0 ? m : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: y?.arrowOffsetLeft,
        top: y?.arrowOffsetTop
      }
    },
    updatePosition: w
  };
}
function ib(t) {
  X(() => (window.addEventListener("resize", t, !1), () => {
    window.removeEventListener("resize", t, !1);
  }), [
    t
  ]);
}
function lb(t, e) {
  return e === "rtl" ? t.replace("start", "right").replace("end", "left") : t.replace("start", "left").replace("end", "right");
}
function qr(t) {
  let e = t;
  return e.nativeEvent = t, e.isDefaultPrevented = () => e.defaultPrevented, e.isPropagationStopped = () => e.cancelBubble, e.persist = () => {
  }, e;
}
function Yl(t, e) {
  Object.defineProperty(t, "target", {
    value: e
  }), Object.defineProperty(t, "currentTarget", {
    value: e
  });
}
function Xl(t) {
  let e = L({
    isFocused: !1,
    observer: null
  });
  X(() => {
    const r = e.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = te((r) => {
    t?.(r);
  });
  return j((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let i = r.target, l = (o) => {
        if (e.current.isFocused = !1, i.disabled) {
          let a = qr(o);
          n(a);
        }
        e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      i.addEventListener("focusout", l, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && i.disabled) {
          var o;
          (o = e.current.observer) === null || o === void 0 || o.disconnect();
          let a = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), e.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Tn = !1;
function Ii(t) {
  for (; t && !Wr(t); ) t = t.parentElement;
  let e = ge(t), n = e.document.activeElement;
  if (!n || n === t) return;
  Tn = !0;
  let r = !1, i = (d) => {
    (d.target === n || r) && d.stopImmediatePropagation();
  }, l = (d) => {
    (d.target === n || r) && (d.stopImmediatePropagation(), !t && !r && (r = !0, ve(n), s()));
  }, o = (d) => {
    (d.target === t || r) && d.stopImmediatePropagation();
  }, a = (d) => {
    (d.target === t || r) && (d.stopImmediatePropagation(), r || (r = !0, ve(n), s()));
  };
  e.addEventListener("blur", i, !0), e.addEventListener("focusout", l, !0), e.addEventListener("focusin", a, !0), e.addEventListener("focus", o, !0);
  let s = () => {
    cancelAnimationFrame(u), e.removeEventListener("blur", i, !0), e.removeEventListener("focusout", l, !0), e.removeEventListener("focusin", a, !0), e.removeEventListener("focus", o, !0), Tn = !1, r = !1;
  }, u = requestAnimationFrame(s);
  return s;
}
let St = "default", Sr = "", yn = /* @__PURE__ */ new WeakMap();
function Ai(t) {
  if (nn()) {
    if (St === "default") {
      const e = Q(t);
      Sr = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    St = "disabled";
  } else if (t instanceof HTMLElement || t instanceof SVGElement) {
    let e = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    yn.set(t, t.style[e]), t.style[e] = "none";
  }
}
function ar(t) {
  if (nn()) {
    if (St !== "disabled") return;
    St = "restoring", setTimeout(() => {
      Al(() => {
        if (St === "restoring") {
          const e = Q(t);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = Sr || ""), Sr = "", St = "default";
        }
      });
    }, 300);
  } else if ((t instanceof HTMLElement || t instanceof SVGElement) && t && yn.has(t)) {
    let e = yn.get(t), n = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    t.style[n] === "none" && (t.style[n] = e), t.getAttribute("style") === "" && t.removeAttribute("style"), yn.delete(t);
  }
}
const Yt = x.createContext({
  register: () => {
  }
});
Yt.displayName = "PressResponderContext";
function ob(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function Zl(t, e, n) {
  if (!e.has(t)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return e.get(t);
}
function ab(t, e) {
  var n = Zl(t, e, "get");
  return ob(t, n);
}
function sb(t, e, n) {
  if (e.set) e.set.call(t, n);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = n;
  }
}
function Ni(t, e, n) {
  var r = Zl(t, e, "set");
  return sb(t, r, n), n;
}
function ub(t) {
  let e = H(Yt);
  if (e) {
    let { register: n, ...r } = e;
    t = R(r, t), n();
  }
  return zr(e, t.ref), t;
}
var vn = /* @__PURE__ */ new WeakMap();
class bn {
  continuePropagation() {
    Ni(this, vn, !1);
  }
  get shouldStopPropagation() {
    return ab(this, vn);
  }
  constructor(e, n, r, i) {
    Xv(this, vn, {
      writable: !0,
      value: void 0
    }), Ni(this, vn, !0);
    var l;
    let o = (l = i?.target) !== null && l !== void 0 ? l : r.currentTarget;
    const a = o?.getBoundingClientRect();
    let s, u = 0, d, c = null;
    r.clientX != null && r.clientY != null && (d = r.clientX, c = r.clientY), a && (d != null && c != null ? (s = d - a.left, u = c - a.top) : (s = a.width / 2, u = a.height / 2)), this.type = e, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = s, this.y = u;
  }
}
const Ri = Symbol("linkClicked"), Oi = "react-aria-pressable-style", Vi = "data-react-aria-pressable";
function nt(t) {
  let { onPress: e, onPressChange: n, onPressStart: r, onPressEnd: i, onPressUp: l, onClick: o, isDisabled: a, isPressed: s, preventFocusOnPress: u, shouldCancelOnPointerExit: d, allowTextSelectionOnPress: c, ref: f, ...v } = ub(t), [b, p] = W(!1), h = L({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: $, removeAllGlobalListeners: y } = rn(), P = te((m, K) => {
    let B = h.current;
    if (a || B.didFirePressStart) return !1;
    let D = !0;
    if (B.isTriggeringEvent = !0, r) {
      let F = new bn("pressstart", K, m);
      r(F), D = F.shouldStopPropagation;
    }
    return n && n(!0), B.isTriggeringEvent = !1, B.didFirePressStart = !0, p(!0), D;
  }), S = te((m, K, B = !0) => {
    let D = h.current;
    if (!D.didFirePressStart) return !1;
    D.didFirePressStart = !1, D.isTriggeringEvent = !0;
    let F = !0;
    if (i) {
      let g = new bn("pressend", K, m);
      i(g), F = g.shouldStopPropagation;
    }
    if (n && n(!1), p(!1), e && B && !a) {
      let g = new bn("press", K, m);
      e(g), F && (F = g.shouldStopPropagation);
    }
    return D.isTriggeringEvent = !1, F;
  }), A = te((m, K) => {
    let B = h.current;
    if (a) return !1;
    if (l) {
      B.isTriggeringEvent = !0;
      let D = new bn("pressup", K, m);
      return l(D), B.isTriggeringEvent = !1, D.shouldStopPropagation;
    }
    return !0;
  }), w = te((m) => {
    let K = h.current;
    if (K.isPressed && K.target) {
      K.didFirePressStart && K.pointerType != null && S(at(K.target, m), K.pointerType, !1), K.isPressed = !1, K.isOverTarget = !1, K.activePointerId = null, K.pointerType = null, y(), c || ar(K.target);
      for (let B of K.disposables) B();
      K.disposables = [];
    }
  }), M = te((m) => {
    d && w(m);
  }), T = te((m) => {
    a || o?.(m);
  }), N = te((m, K) => {
    if (!a && o) {
      let B = new MouseEvent("click", m);
      Yl(B, K), o(qr(B));
    }
  }), I = z(() => {
    let m = h.current, K = {
      onKeyDown(D) {
        if (sr(D.nativeEvent, D.currentTarget) && oe(D.currentTarget, J(D.nativeEvent))) {
          var F;
          _i(J(D.nativeEvent), D.key) && D.preventDefault();
          let g = !0;
          if (!m.isPressed && !D.repeat) {
            m.target = D.currentTarget, m.isPressed = !0, m.pointerType = "keyboard", g = P(D, "keyboard");
            let E = D.currentTarget, k = (V) => {
              sr(V, E) && !V.repeat && oe(E, J(V)) && m.target && A(at(m.target, V), "keyboard");
            };
            $(Q(D.currentTarget), "keyup", Ue(k, B), !0);
          }
          g && D.stopPropagation(), D.metaKey && vt() && ((F = m.metaKeyEvents) === null || F === void 0 || F.set(D.key, D.nativeEvent));
        } else D.key === "Meta" && (m.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(D) {
        if (!(D && !oe(D.currentTarget, J(D.nativeEvent))) && D && D.button === 0 && !m.isTriggeringEvent && !tt.isOpening) {
          let F = !0;
          if (a && D.preventDefault(), !m.ignoreEmulatedMouseEvents && !m.isPressed && (m.pointerType === "virtual" || yr(D.nativeEvent))) {
            let g = P(D, "virtual"), E = A(D, "virtual"), k = S(D, "virtual");
            T(D), F = g && E && k;
          } else if (m.isPressed && m.pointerType !== "keyboard") {
            let g = m.pointerType || D.nativeEvent.pointerType || "virtual", E = A(at(D.currentTarget, D), g), k = S(at(D.currentTarget, D), g, !0);
            F = E && k, m.isOverTarget = !1, T(D), w(D);
          }
          m.ignoreEmulatedMouseEvents = !1, F && D.stopPropagation();
        }
      }
    }, B = (D) => {
      var F;
      if (m.isPressed && m.target && sr(D, m.target)) {
        var g;
        _i(J(D), D.key) && D.preventDefault();
        let k = J(D), V = oe(m.target, J(D));
        S(at(m.target, D), "keyboard", V), V && N(D, m.target), y(), D.key !== "Enter" && Yr(m.target) && oe(m.target, k) && !D[Ri] && (D[Ri] = !0, tt(m.target, D, !1)), m.isPressed = !1, (g = m.metaKeyEvents) === null || g === void 0 || g.delete(D.key);
      } else if (D.key === "Meta" && (!((F = m.metaKeyEvents) === null || F === void 0) && F.size)) {
        var E;
        let k = m.metaKeyEvents;
        m.metaKeyEvents = void 0;
        for (let V of k.values()) (E = m.target) === null || E === void 0 || E.dispatchEvent(new KeyboardEvent("keyup", V));
      }
    };
    if (typeof PointerEvent < "u") {
      K.onPointerDown = (g) => {
        if (g.button !== 0 || !oe(g.currentTarget, J(g.nativeEvent))) return;
        if (pv(g.nativeEvent)) {
          m.pointerType = "virtual";
          return;
        }
        m.pointerType = g.pointerType;
        let E = !0;
        if (!m.isPressed) {
          m.isPressed = !0, m.isOverTarget = !0, m.activePointerId = g.pointerId, m.target = g.currentTarget, c || Ai(m.target), E = P(g, m.pointerType);
          let k = J(g.nativeEvent);
          "releasePointerCapture" in k && k.releasePointerCapture(g.pointerId), $(Q(g.currentTarget), "pointerup", D, !1), $(Q(g.currentTarget), "pointercancel", F, !1);
        }
        E && g.stopPropagation();
      }, K.onMouseDown = (g) => {
        if (oe(g.currentTarget, J(g.nativeEvent)) && g.button === 0) {
          if (u) {
            let E = Ii(g.target);
            E && m.disposables.push(E);
          }
          g.stopPropagation();
        }
      }, K.onPointerUp = (g) => {
        !oe(g.currentTarget, J(g.nativeEvent)) || m.pointerType === "virtual" || g.button === 0 && !m.isPressed && A(g, m.pointerType || g.pointerType);
      }, K.onPointerEnter = (g) => {
        g.pointerId === m.activePointerId && m.target && !m.isOverTarget && m.pointerType != null && (m.isOverTarget = !0, P(at(m.target, g), m.pointerType));
      }, K.onPointerLeave = (g) => {
        g.pointerId === m.activePointerId && m.target && m.isOverTarget && m.pointerType != null && (m.isOverTarget = !1, S(at(m.target, g), m.pointerType, !1), M(g));
      };
      let D = (g) => {
        if (g.pointerId === m.activePointerId && m.isPressed && g.button === 0 && m.target) {
          if (oe(m.target, J(g)) && m.pointerType != null) {
            let E = !1, k = setTimeout(() => {
              m.isPressed && m.target instanceof HTMLElement && (E ? w(g) : (ve(m.target), m.target.click()));
            }, 80);
            $(g.currentTarget, "click", () => E = !0, !0), m.disposables.push(() => clearTimeout(k));
          } else w(g);
          m.isOverTarget = !1;
        }
      }, F = (g) => {
        w(g);
      };
      K.onDragStart = (g) => {
        oe(g.currentTarget, J(g.nativeEvent)) && w(g);
      };
    } else if (process.env.NODE_ENV === "test") {
      K.onMouseDown = (g) => {
        if (g.button !== 0 || !oe(g.currentTarget, J(g.nativeEvent))) return;
        if (m.ignoreEmulatedMouseEvents) {
          g.stopPropagation();
          return;
        }
        if (m.isPressed = !0, m.isOverTarget = !0, m.target = g.currentTarget, m.pointerType = yr(g.nativeEvent) ? "virtual" : "mouse", Nn(() => P(g, m.pointerType)) && g.stopPropagation(), u) {
          let k = Ii(g.target);
          k && m.disposables.push(k);
        }
        $(Q(g.currentTarget), "mouseup", D, !1);
      }, K.onMouseEnter = (g) => {
        if (!oe(g.currentTarget, J(g.nativeEvent))) return;
        let E = !0;
        m.isPressed && !m.ignoreEmulatedMouseEvents && m.pointerType != null && (m.isOverTarget = !0, E = P(g, m.pointerType)), E && g.stopPropagation();
      }, K.onMouseLeave = (g) => {
        if (!oe(g.currentTarget, J(g.nativeEvent))) return;
        let E = !0;
        m.isPressed && !m.ignoreEmulatedMouseEvents && m.pointerType != null && (m.isOverTarget = !1, E = S(g, m.pointerType, !1), M(g)), E && g.stopPropagation();
      }, K.onMouseUp = (g) => {
        oe(g.currentTarget, J(g.nativeEvent)) && !m.ignoreEmulatedMouseEvents && g.button === 0 && !m.isPressed && A(g, m.pointerType || "mouse");
      };
      let D = (g) => {
        if (g.button === 0) {
          if (m.ignoreEmulatedMouseEvents) {
            m.ignoreEmulatedMouseEvents = !1;
            return;
          }
          m.target && m.target.contains(g.target) && m.pointerType != null || w(g), m.isOverTarget = !1;
        }
      };
      K.onTouchStart = (g) => {
        if (!oe(g.currentTarget, J(g.nativeEvent))) return;
        let E = db(g.nativeEvent);
        if (!E) return;
        m.activePointerId = E.identifier, m.ignoreEmulatedMouseEvents = !0, m.isOverTarget = !0, m.isPressed = !0, m.target = g.currentTarget, m.pointerType = "touch", c || Ai(m.target), P(Xe(m.target, g), m.pointerType) && g.stopPropagation(), $(ge(g.currentTarget), "scroll", F, !0);
      }, K.onTouchMove = (g) => {
        if (!oe(g.currentTarget, J(g.nativeEvent))) return;
        if (!m.isPressed) {
          g.stopPropagation();
          return;
        }
        let E = zi(g.nativeEvent, m.activePointerId), k = !0;
        E && Hi(E, g.currentTarget) ? !m.isOverTarget && m.pointerType != null && (m.isOverTarget = !0, k = P(Xe(m.target, g), m.pointerType)) : m.isOverTarget && m.pointerType != null && (m.isOverTarget = !1, k = S(Xe(m.target, g), m.pointerType, !1), M(Xe(m.target, g))), k && g.stopPropagation();
      }, K.onTouchEnd = (g) => {
        if (!oe(g.currentTarget, J(g.nativeEvent))) return;
        if (!m.isPressed) {
          g.stopPropagation();
          return;
        }
        let E = zi(g.nativeEvent, m.activePointerId), k = !0;
        E && Hi(E, g.currentTarget) && m.pointerType != null ? (A(Xe(m.target, g), m.pointerType), k = S(Xe(m.target, g), m.pointerType), N(g.nativeEvent, m.target)) : m.isOverTarget && m.pointerType != null && (k = S(Xe(m.target, g), m.pointerType, !1)), k && g.stopPropagation(), m.isPressed = !1, m.activePointerId = null, m.isOverTarget = !1, m.ignoreEmulatedMouseEvents = !0, m.target && !c && ar(m.target), y();
      }, K.onTouchCancel = (g) => {
        oe(g.currentTarget, J(g.nativeEvent)) && (g.stopPropagation(), m.isPressed && w(Xe(m.target, g)));
      };
      let F = (g) => {
        m.isPressed && oe(J(g), m.target) && w({
          currentTarget: m.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      K.onDragStart = (g) => {
        oe(g.currentTarget, J(g.nativeEvent)) && w(g);
      };
    }
    return K;
  }, [
    $,
    a,
    u,
    y,
    c,
    w,
    M,
    S,
    P,
    A,
    T,
    N
  ]);
  return _(() => {
    if (!f || process.env.NODE_ENV === "test") return;
    const m = Q(f.current);
    if (!m || !m.head || m.getElementById(Oi)) return;
    const K = m.createElement("style");
    K.id = Oi, K.textContent = `
@layer {
  [${Vi}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), m.head.prepend(K);
  }, [
    f
  ]), _(() => {
    let m = h.current;
    return () => {
      var K;
      c || ar((K = m.target) !== null && K !== void 0 ? K : void 0);
      for (let B of m.disposables) B();
      m.disposables = [];
    };
  }, [
    c
  ]), {
    isPressed: s || b,
    pressProps: R(v, I, {
      [Vi]: !0
    })
  };
}
function Yr(t) {
  return t.tagName === "A" && t.hasAttribute("href");
}
function sr(t, e) {
  const { key: n, code: r } = t, i = e, l = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof ge(i).HTMLInputElement && !Jl(i, n) || i instanceof ge(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && Yr(i)) && n !== "Enter");
}
function db(t) {
  const { targetTouches: e } = t;
  return e.length > 0 ? e[0] : null;
}
function zi(t, e) {
  const n = t.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === e) return i;
  }
  return null;
}
function Xe(t, e) {
  let n = 0, r = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (n = e.targetTouches[0].clientX, r = e.targetTouches[0].clientY), {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r
  };
}
function at(t, e) {
  let n = e.clientX, r = e.clientY;
  return {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r
  };
}
function cb(t) {
  let e = 0, n = 0;
  return t.width !== void 0 ? e = t.width / 2 : t.radiusX !== void 0 && (e = t.radiusX), t.height !== void 0 ? n = t.height / 2 : t.radiusY !== void 0 && (n = t.radiusY), {
    top: t.clientY - n,
    right: t.clientX + e,
    bottom: t.clientY + n,
    left: t.clientX - e
  };
}
function fb(t, e) {
  return !(t.left > e.right || e.left > t.right || t.top > e.bottom || e.top > t.bottom);
}
function Hi(t, e) {
  let n = e.getBoundingClientRect(), r = cb(t);
  return fb(n, r);
}
function vb(t) {
  return t instanceof HTMLInputElement ? !1 : t instanceof HTMLButtonElement ? t.type !== "submit" && t.type !== "reset" : !Yr(t);
}
function _i(t, e) {
  return t instanceof HTMLInputElement ? !Jl(t, e) : vb(t);
}
const bb = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Jl(t, e) {
  return t.type === "checkbox" || t.type === "radio" ? e === " " : bb.has(t.type);
}
let _e = null, Xt = /* @__PURE__ */ new Set(), Ut = /* @__PURE__ */ new Map(), pt = !1, Cr = !1;
const pb = {
  Tab: !0,
  Escape: !0
};
function _n(t, e) {
  for (let n of Xt) n(t, e);
}
function mb(t) {
  return !(t.metaKey || !vt() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function kn(t) {
  pt = !0, mb(t) && (_e = "keyboard", _n("keyboard", t));
}
function Se(t) {
  _e = "pointer", (t.type === "mousedown" || t.type === "pointerdown") && (pt = !0, _n("pointer", t));
}
function Ql(t) {
  yr(t) && (pt = !0, _e = "virtual");
}
function eo(t) {
  t.target === window || t.target === document || Tn || !t.isTrusted || (!pt && !Cr && (_e = "virtual", _n("virtual", t)), pt = !1, Cr = !1);
}
function to() {
  Tn || (pt = !1, Cr = !0);
}
function Bn(t) {
  if (typeof window > "u" || typeof document > "u" || Ut.get(ge(t))) return;
  const e = ge(t), n = Q(t);
  let r = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    pt = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", kn, !0), n.addEventListener("keyup", kn, !0), n.addEventListener("click", Ql, !0), e.addEventListener("focus", eo, !0), e.addEventListener("blur", to, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Se, !0), n.addEventListener("pointermove", Se, !0), n.addEventListener("pointerup", Se, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Se, !0), n.addEventListener("mousemove", Se, !0), n.addEventListener("mouseup", Se, !0)), e.addEventListener("beforeunload", () => {
    no(t);
  }, {
    once: !0
  }), Ut.set(e, {
    focus: r
  });
}
const no = (t, e) => {
  const n = ge(t), r = Q(t);
  e && r.removeEventListener("DOMContentLoaded", e), Ut.has(n) && (n.HTMLElement.prototype.focus = Ut.get(n).focus, r.removeEventListener("keydown", kn, !0), r.removeEventListener("keyup", kn, !0), r.removeEventListener("click", Ql, !0), n.removeEventListener("focus", eo, !0), n.removeEventListener("blur", to, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Se, !0), r.removeEventListener("pointermove", Se, !0), r.removeEventListener("pointerup", Se, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Se, !0), r.removeEventListener("mousemove", Se, !0), r.removeEventListener("mouseup", Se, !0)), Ut.delete(n));
};
function hb(t) {
  const e = Q(t);
  let n;
  return e.readyState !== "loading" ? Bn(t) : (n = () => {
    Bn(t);
  }, e.addEventListener("DOMContentLoaded", n)), () => no(t, n);
}
typeof document < "u" && hb();
function kt() {
  return _e !== "pointer";
}
function Zt() {
  return _e;
}
function $b(t) {
  _e = t, _n(t, null);
}
function Xr() {
  Bn();
  let [t, e] = W(_e);
  return _(() => {
    let n = () => {
      e(_e);
    };
    return Xt.add(n), () => {
      Xt.delete(n);
    };
  }, []), Me() ? null : t;
}
const gb = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function yb(t, e, n) {
  let r = Q(n?.target);
  const i = typeof window < "u" ? ge(n?.target).HTMLInputElement : HTMLInputElement, l = typeof window < "u" ? ge(n?.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? ge(n?.target).HTMLElement : HTMLElement, a = typeof window < "u" ? ge(n?.target).KeyboardEvent : KeyboardEvent;
  return t = t || r.activeElement instanceof i && !gb.has(r.activeElement.type) || r.activeElement instanceof l || r.activeElement instanceof o && r.activeElement.isContentEditable, !(t && e === "keyboard" && n instanceof a && !pb[n.key]);
}
function xb(t, e, n) {
  Bn(), _(() => {
    let r = (i, l) => {
      yb(!!n?.isTextInput, i, l) && t(kt());
    };
    return Xt.add(r), () => {
      Xt.delete(r);
    };
  }, e);
}
function $e(t) {
  const e = Q(t), n = be(e);
  if (Zt() === "virtual") {
    let r = n;
    Al(() => {
      be(e) === r && t.isConnected && ve(t);
    });
  } else ve(t);
}
function Un(t) {
  let { isDisabled: e, onFocus: n, onBlur: r, onFocusChange: i } = t;
  const l = j((s) => {
    if (s.target === s.currentTarget)
      return r && r(s), i && i(!1), !0;
  }, [
    r,
    i
  ]), o = Xl(l), a = j((s) => {
    const u = Q(s.target), d = u ? be(u) : be();
    s.target === s.currentTarget && d === J(s.nativeEvent) && (n && n(s), i && i(!0), o(s));
  }, [
    i,
    n,
    o
  ]);
  return {
    focusProps: {
      onFocus: !e && (n || i || r) ? a : void 0,
      onBlur: !e && (r || i) ? l : void 0
    }
  };
}
function Ui(t) {
  if (!t) return;
  let e = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        e && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    t(r), e && n.stopPropagation();
  };
}
function ro(t) {
  return {
    keyboardProps: t.isDisabled ? {} : {
      onKeyDown: Ui(t.onKeyDown),
      onKeyUp: Ui(t.onKeyUp)
    }
  };
}
let Fn = /* @__PURE__ */ x.createContext(null);
function Eb(t) {
  let e = H(Fn) || {};
  zr(e, t);
  let { ref: n, ...r } = e;
  return r;
}
const Pb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  let { children: r, ...i } = e, l = Ie(n), o = {
    ...i,
    ref: l
  };
  return /* @__PURE__ */ x.createElement(Fn.Provider, {
    value: o
  }, r);
});
function ht(t, e) {
  let { focusProps: n } = Un(t), { keyboardProps: r } = ro(t), i = R(n, r), l = Eb(e), o = t.isDisabled ? {} : l, a = L(t.autoFocus);
  _(() => {
    a.current && e.current && $e(e.current), a.current = !1;
  }, [
    e
  ]);
  let s = t.excludeFromTabOrder ? -1 : 0;
  return t.isDisabled && (s = void 0), {
    focusableProps: R({
      ...i,
      tabIndex: s
    }, o)
  };
}
const s0 = /* @__PURE__ */ ie(({ children: t, ...e }, n) => {
  n = Ie(n);
  let { focusableProps: r } = ht(e, n), i = x.Children.only(t);
  _(() => {
    if (process.env.NODE_ENV === "production") return;
    let o = n.current;
    if (!o || !(o instanceof ge(o).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!e.isDisabled && !Wr(o)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (o.localName !== "button" && o.localName !== "input" && o.localName !== "select" && o.localName !== "textarea" && o.localName !== "a" && o.localName !== "area" && o.localName !== "summary" && o.localName !== "img" && o.localName !== "svg") {
      let a = o.getAttribute("role");
      a ? (
        // https://w3c.github.io/aria/#widget_roles
        a !== "application" && a !== "button" && a !== "checkbox" && a !== "combobox" && a !== "gridcell" && a !== "link" && a !== "menuitem" && a !== "menuitemcheckbox" && a !== "menuitemradio" && a !== "option" && a !== "radio" && a !== "searchbox" && a !== "separator" && a !== "slider" && a !== "spinbutton" && a !== "switch" && a !== "tab" && a !== "tabpanel" && a !== "textbox" && a !== "treeitem" && // aria-describedby is also announced on these roles
        a !== "img" && a !== "meter" && a !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${a}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    e.isDisabled
  ]);
  let l = parseInt(x.version, 10) < 19 ? i.ref : i.props.ref;
  return /* @__PURE__ */ x.cloneElement(i, {
    ...R(r, i.props),
    // @ts-ignore
    ref: tn(l, n)
  });
}), io = /* @__PURE__ */ x.forwardRef(({ children: t, ...e }, n) => {
  let r = L(!1), i = H(Yt);
  n = Ie(n || i?.ref);
  let l = R(i || {}, {
    ...e,
    ref: n,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return zr(i, n), _(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ x.createElement(Yt.Provider, {
    value: l
  }, t);
});
function Db({ children: t }) {
  let e = z(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ x.createElement(Yt.Provider, {
    value: e
  }, t);
}
function ln(t) {
  let { isDisabled: e, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = t, l = L({
    isFocusWithin: !1
  }), { addGlobalListener: o, removeAllGlobalListeners: a } = rn(), s = j((c) => {
    c.currentTarget.contains(c.target) && l.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (l.current.isFocusWithin = !1, a(), n && n(c), i && i(!1));
  }, [
    n,
    i,
    l,
    a
  ]), u = Xl(s), d = j((c) => {
    if (!c.currentTarget.contains(c.target)) return;
    const f = Q(c.target), v = be(f);
    if (!l.current.isFocusWithin && v === J(c.nativeEvent)) {
      r && r(c), i && i(!0), l.current.isFocusWithin = !0, u(c);
      let b = c.currentTarget;
      o(f, "focus", (p) => {
        if (l.current.isFocusWithin && !oe(b, p.target)) {
          let h = new f.defaultView.FocusEvent("blur", {
            relatedTarget: p.target
          });
          Yl(h, b);
          let $ = qr(h);
          s($);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    i,
    u,
    o,
    s
  ]);
  return e ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: d,
      onBlur: s
    }
  };
}
let Kn = !1, pn = 0;
function wr() {
  Kn = !0, setTimeout(() => {
    Kn = !1;
  }, 50);
}
function ji(t) {
  t.pointerType === "touch" && wr();
}
function Sb() {
  if (!(typeof document > "u"))
    return pn === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", ji) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", wr)), pn++, () => {
      pn--, !(pn > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", ji) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", wr));
    };
}
function Fe(t) {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, isDisabled: i } = t, [l, o] = W(!1), a = L({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  _(Sb, []);
  let { addGlobalListener: s, removeAllGlobalListeners: u } = rn(), { hoverProps: d, triggerHoverEnd: c } = z(() => {
    let f = (p, h) => {
      if (a.pointerType = h, i || h === "touch" || a.isHovered || !p.currentTarget.contains(p.target)) return;
      a.isHovered = !0;
      let $ = p.currentTarget;
      a.target = $, s(Q(p.target), "pointerover", (y) => {
        a.isHovered && a.target && !oe(a.target, y.target) && v(y, y.pointerType);
      }, {
        capture: !0
      }), e && e({
        type: "hoverstart",
        target: $,
        pointerType: h
      }), n && n(!0), o(!0);
    }, v = (p, h) => {
      let $ = a.target;
      a.pointerType = "", a.target = null, !(h === "touch" || !a.isHovered || !$) && (a.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: $,
        pointerType: h
      }), n && n(!1), o(!1));
    }, b = {};
    return typeof PointerEvent < "u" ? (b.onPointerEnter = (p) => {
      Kn && p.pointerType === "mouse" || f(p, p.pointerType);
    }, b.onPointerLeave = (p) => {
      !i && p.currentTarget.contains(p.target) && v(p, p.pointerType);
    }) : process.env.NODE_ENV === "test" && (b.onTouchStart = () => {
      a.ignoreEmulatedMouseEvents = !0;
    }, b.onMouseEnter = (p) => {
      !a.ignoreEmulatedMouseEvents && !Kn && f(p, "mouse"), a.ignoreEmulatedMouseEvents = !1;
    }, b.onMouseLeave = (p) => {
      !i && p.currentTarget.contains(p.target) && v(p, "mouse");
    }), {
      hoverProps: b,
      triggerHoverEnd: v
    };
  }, [
    e,
    n,
    r,
    i,
    a,
    s,
    u
  ]);
  return _(() => {
    i && c({
      currentTarget: a.target
    }, a.pointerType);
  }, [
    i
  ]), {
    hoverProps: d,
    isHovered: l
  };
}
function Cb(t) {
  let { ref: e, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: i } = t, l = L({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), o = te((s) => {
    n && mn(s, e) && (i && i(s), l.current.isPointerDown = !0);
  }), a = te((s) => {
    n && n(s);
  });
  _(() => {
    let s = l.current;
    if (r) return;
    const u = e.current, d = Q(u);
    if (typeof PointerEvent < "u") {
      let c = (f) => {
        s.isPointerDown && mn(f, e) && a(f), s.isPointerDown = !1;
      };
      return d.addEventListener("pointerdown", o, !0), d.addEventListener("click", c, !0), () => {
        d.removeEventListener("pointerdown", o, !0), d.removeEventListener("click", c, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let c = (v) => {
        s.ignoreEmulatedMouseEvents ? s.ignoreEmulatedMouseEvents = !1 : s.isPointerDown && mn(v, e) && a(v), s.isPointerDown = !1;
      }, f = (v) => {
        s.ignoreEmulatedMouseEvents = !0, s.isPointerDown && mn(v, e) && a(v), s.isPointerDown = !1;
      };
      return d.addEventListener("mousedown", o, !0), d.addEventListener("mouseup", c, !0), d.addEventListener("touchstart", o, !0), d.addEventListener("touchend", f, !0), () => {
        d.removeEventListener("mousedown", o, !0), d.removeEventListener("mouseup", c, !0), d.removeEventListener("touchstart", o, !0), d.removeEventListener("touchend", f, !0);
      };
    }
  }, [
    e,
    r,
    o,
    a
  ]);
}
function mn(t, e) {
  if (t.button > 0) return !1;
  if (t.target) {
    const n = t.target.ownerDocument;
    if (!n || !n.documentElement.contains(t.target) || t.target.closest("[data-react-aria-top-layer]")) return !1;
  }
  return e.current ? !t.composedPath().includes(e.current) : !1;
}
function wb(t, e) {
  let { onScroll: n, isDisabled: r } = t, i = j((l) => {
    l.ctrlKey || (l.preventDefault(), l.stopPropagation(), n && n({
      deltaX: l.deltaX,
      deltaY: l.deltaY
    }));
  }, [
    n
  ]);
  dt(e, "wheel", r ? void 0 : i);
}
const Tb = 500;
function lo(t) {
  let { isDisabled: e, onLongPressStart: n, onLongPressEnd: r, onLongPress: i, threshold: l = Tb, accessibilityDescription: o } = t;
  const a = L(void 0);
  let { addGlobalListener: s, removeGlobalListener: u } = rn(), { pressProps: d } = nt({
    isDisabled: e,
    onPressStart(f) {
      if (f.continuePropagation(), (f.pointerType === "mouse" || f.pointerType === "touch") && (n && n({
        ...f,
        type: "longpressstart"
      }), a.current = setTimeout(() => {
        f.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), Q(f.target).activeElement !== f.target && ve(f.target), i && i({
          ...f,
          type: "longpress"
        }), a.current = void 0;
      }, l), f.pointerType === "touch")) {
        let v = (b) => {
          b.preventDefault();
        };
        s(f.target, "contextmenu", v, {
          once: !0
        }), s(window, "pointerup", () => {
          setTimeout(() => {
            u(f.target, "contextmenu", v);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(f) {
      a.current && clearTimeout(a.current), r && (f.pointerType === "mouse" || f.pointerType === "touch") && r({
        ...f,
        type: "longpressend"
      });
    }
  }), c = Hr(i && !e ? o : void 0);
  return {
    longPressProps: R(d, c)
  };
}
const Wi = /* @__PURE__ */ x.createContext(null), Tr = "react-aria-focus-scope-restore";
let re = null;
function oo(t) {
  let { children: e, contain: n, restoreFocus: r, autoFocus: i } = t, l = L(null), o = L(null), a = L([]), { parentNode: s } = H(Wi) || {}, u = z(() => new Br({
    scopeRef: a
  }), [
    a
  ]);
  X(() => {
    let f = s || de.root;
    if (de.getTreeNode(f.scopeRef) && re && !Ln(re, f.scopeRef)) {
      let v = de.getTreeNode(re);
      v && (f = v);
    }
    f.addChild(u), de.addNode(u);
  }, [
    u,
    s
  ]), X(() => {
    let f = de.getTreeNode(a);
    f && (f.contain = !!n);
  }, [
    n
  ]), X(() => {
    var f;
    let v = (f = l.current) === null || f === void 0 ? void 0 : f.nextSibling, b = [], p = (h) => h.stopPropagation();
    for (; v && v !== o.current; )
      b.push(v), v.addEventListener(Tr, p), v = v.nextSibling;
    return a.current = b, () => {
      for (let h of b) h.removeEventListener(Tr, p);
    };
  }, [
    e
  ]), Mb(a, r, n), Fb(a, n), Ib(a, r, n), Lb(a, i), _(() => {
    const f = be(Q(a.current ? a.current[0] : void 0));
    let v = null;
    if (we(f, a.current)) {
      for (let b of de.traverse()) b.scopeRef && we(f, b.scopeRef.current) && (v = b);
      v === de.getTreeNode(a) && (re = v.scopeRef);
    }
  }, [
    a
  ]), X(() => () => {
    var f, v, b;
    let p = (b = (v = de.getTreeNode(a)) === null || v === void 0 || (f = v.parent) === null || f === void 0 ? void 0 : f.scopeRef) !== null && b !== void 0 ? b : null;
    (a === re || Ln(a, re)) && (!p || de.getTreeNode(p)) && (re = p), de.removeTreeNode(a);
  }, [
    a
  ]);
  let d = z(() => kb(a), []), c = z(() => ({
    focusManager: d,
    parentNode: u
  }), [
    u,
    d
  ]);
  return /* @__PURE__ */ x.createElement(Wi.Provider, {
    value: c
  }, /* @__PURE__ */ x.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: l
  }), e, /* @__PURE__ */ x.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: o
  }));
}
function kb(t) {
  return {
    focusNext(e = {}) {
      let n = t.current, { from: r, tabbable: i, wrap: l, accept: o } = e;
      var a;
      let s = r || be(Q((a = n[0]) !== null && a !== void 0 ? a : void 0)), u = n[0].previousElementSibling, d = ct(n), c = Ce(d, {
        tabbable: i,
        accept: o
      }, n);
      c.currentNode = we(s, n) ? s : u;
      let f = c.nextNode();
      return !f && l && (c.currentNode = u, f = c.nextNode()), f && He(f, !0), f;
    },
    focusPrevious(e = {}) {
      let n = t.current, { from: r, tabbable: i, wrap: l, accept: o } = e;
      var a;
      let s = r || be(Q((a = n[0]) !== null && a !== void 0 ? a : void 0)), u = n[n.length - 1].nextElementSibling, d = ct(n), c = Ce(d, {
        tabbable: i,
        accept: o
      }, n);
      c.currentNode = we(s, n) ? s : u;
      let f = c.previousNode();
      return !f && l && (c.currentNode = u, f = c.previousNode()), f && He(f, !0), f;
    },
    focusFirst(e = {}) {
      let n = t.current, { tabbable: r, accept: i } = e, l = ct(n), o = Ce(l, {
        tabbable: r,
        accept: i
      }, n);
      o.currentNode = n[0].previousElementSibling;
      let a = o.nextNode();
      return a && He(a, !0), a;
    },
    focusLast(e = {}) {
      let n = t.current, { tabbable: r, accept: i } = e, l = ct(n), o = Ce(l, {
        tabbable: r,
        accept: i
      }, n);
      o.currentNode = n[n.length - 1].nextElementSibling;
      let a = o.previousNode();
      return a && He(a, !0), a;
    }
  };
}
function ct(t) {
  return t[0].parentElement;
}
function Ht(t) {
  let e = de.getTreeNode(re);
  for (; e && e.scopeRef !== t; ) {
    if (e.contain) return !1;
    e = e.parent;
  }
  return !0;
}
function Bb(t) {
  if (t.checked) return !0;
  let e = [];
  if (!t.form) e = [
    ...Q(t).querySelectorAll(`input[type="radio"][name="${CSS.escape(t.name)}"]`)
  ].filter((l) => !l.form);
  else {
    var n, r;
    let l = (r = t.form) === null || r === void 0 || (n = r.elements) === null || n === void 0 ? void 0 : n.namedItem(t.name);
    e = [
      ...l ?? []
    ];
  }
  return e ? !e.some((l) => l.checked) : !1;
}
function Fb(t, e) {
  let n = L(void 0), r = L(void 0);
  X(() => {
    let i = t.current;
    if (!e) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const l = Q(i ? i[0] : void 0);
    let o = (u) => {
      if (u.key !== "Tab" || u.altKey || u.ctrlKey || u.metaKey || !Ht(t) || u.isComposing) return;
      let d = be(l), c = t.current;
      if (!c || !we(d, c)) return;
      let f = ct(c), v = Ce(f, {
        tabbable: !0
      }, c);
      if (!d) return;
      v.currentNode = d;
      let b = u.shiftKey ? v.previousNode() : v.nextNode();
      b || (v.currentNode = u.shiftKey ? c[c.length - 1].nextElementSibling : c[0].previousElementSibling, b = u.shiftKey ? v.previousNode() : v.nextNode()), u.preventDefault(), b && He(b, !0);
    }, a = (u) => {
      (!re || Ln(re, t)) && we(J(u), t.current) ? (re = t, n.current = J(u)) : Ht(t) && !Qe(J(u), t) ? n.current ? n.current.focus() : re && re.current && kr(re.current) : Ht(t) && (n.current = J(u));
    }, s = (u) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let d = Zt(), c = (d === "virtual" || d === null) && Vn() && Vr(), f = be(l);
        if (!c && f && Ht(t) && !Qe(f, t)) {
          re = t;
          let b = J(u);
          if (b && b.isConnected) {
            var v;
            n.current = b, (v = n.current) === null || v === void 0 || v.focus();
          } else re.current && kr(re.current);
        }
      });
    };
    return l.addEventListener("keydown", o, !1), l.addEventListener("focusin", a, !1), i?.forEach((u) => u.addEventListener("focusin", a, !1)), i?.forEach((u) => u.addEventListener("focusout", s, !1)), () => {
      l.removeEventListener("keydown", o, !1), l.removeEventListener("focusin", a, !1), i?.forEach((u) => u.removeEventListener("focusin", a, !1)), i?.forEach((u) => u.removeEventListener("focusout", s, !1));
    };
  }, [
    t,
    e
  ]), X(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function ao(t) {
  return Qe(t);
}
function we(t, e) {
  return !t || !e ? !1 : e.some((n) => n.contains(t));
}
function Qe(t, e = null) {
  if (t instanceof Element && t.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of de.traverse(de.getTreeNode(e)))
    if (n && we(t, n.current)) return !0;
  return !1;
}
function Kb(t) {
  return Qe(t, re);
}
function Ln(t, e) {
  var n;
  let r = (n = de.getTreeNode(e)) === null || n === void 0 ? void 0 : n.parent;
  for (; r; ) {
    if (r.scopeRef === t) return !0;
    r = r.parent;
  }
  return !1;
}
function He(t, e = !1) {
  if (t != null && !e) try {
    $e(t);
  } catch {
  }
  else if (t != null) try {
    t.focus();
  } catch {
  }
}
function so(t, e = !0) {
  let n = t[0].previousElementSibling, r = ct(t), i = Ce(r, {
    tabbable: e
  }, t);
  i.currentNode = n;
  let l = i.nextNode();
  return e && !l && (r = ct(t), i = Ce(r, {
    tabbable: !1
  }, t), i.currentNode = n, l = i.nextNode()), l;
}
function kr(t, e = !0) {
  He(so(t, e));
}
function Lb(t, e) {
  const n = x.useRef(e);
  _(() => {
    if (n.current) {
      re = t;
      const r = Q(t.current ? t.current[0] : void 0);
      !we(be(r), re.current) && t.current && kr(t.current);
    }
    n.current = !1;
  }, [
    t
  ]);
}
function Mb(t, e, n) {
  X(() => {
    if (e || n) return;
    let r = t.current;
    const i = Q(r ? r[0] : void 0);
    let l = (o) => {
      let a = J(o);
      we(a, t.current) ? re = t : ao(a) || (re = null);
    };
    return i.addEventListener("focusin", l, !1), r?.forEach((o) => o.addEventListener("focusin", l, !1)), () => {
      i.removeEventListener("focusin", l, !1), r?.forEach((o) => o.removeEventListener("focusin", l, !1));
    };
  }, [
    t,
    e,
    n
  ]);
}
function Gi(t) {
  let e = de.getTreeNode(re);
  for (; e && e.scopeRef !== t; ) {
    if (e.nodeToRestore) return !1;
    e = e.parent;
  }
  return e?.scopeRef === t;
}
function Ib(t, e, n) {
  const r = L(typeof document < "u" ? be(Q(t.current ? t.current[0] : void 0)) : null);
  X(() => {
    let i = t.current;
    const l = Q(i ? i[0] : void 0);
    if (!e || n) return;
    let o = () => {
      (!re || Ln(re, t)) && we(be(l), t.current) && (re = t);
    };
    return l.addEventListener("focusin", o, !1), i?.forEach((a) => a.addEventListener("focusin", o, !1)), () => {
      l.removeEventListener("focusin", o, !1), i?.forEach((a) => a.removeEventListener("focusin", o, !1));
    };
  }, [
    t,
    n
  ]), X(() => {
    const i = Q(t.current ? t.current[0] : void 0);
    if (!e) return;
    let l = (o) => {
      if (o.key !== "Tab" || o.altKey || o.ctrlKey || o.metaKey || !Ht(t) || o.isComposing) return;
      let a = i.activeElement;
      if (!Qe(a, t) || !Gi(t)) return;
      let s = de.getTreeNode(t);
      if (!s) return;
      let u = s.nodeToRestore, d = Ce(i.body, {
        tabbable: !0
      });
      d.currentNode = a;
      let c = o.shiftKey ? d.previousNode() : d.nextNode();
      if ((!u || !u.isConnected || u === i.body) && (u = void 0, s.nodeToRestore = void 0), (!c || !Qe(c, t)) && u) {
        d.currentNode = u;
        do
          c = o.shiftKey ? d.previousNode() : d.nextNode();
        while (Qe(c, t));
        o.preventDefault(), o.stopPropagation(), c ? He(c, !0) : ao(u) ? He(u, !0) : a.blur();
      }
    };
    return n || i.addEventListener("keydown", l, !0), () => {
      n || i.removeEventListener("keydown", l, !0);
    };
  }, [
    t,
    e,
    n
  ]), X(() => {
    const i = Q(t.current ? t.current[0] : void 0);
    if (!e) return;
    let l = de.getTreeNode(t);
    if (l) {
      var o;
      return l.nodeToRestore = (o = r.current) !== null && o !== void 0 ? o : void 0, () => {
        let a = de.getTreeNode(t);
        if (!a) return;
        let s = a.nodeToRestore, u = be(i);
        if (e && s && (u && Qe(u, t) || u === i.body && Gi(t))) {
          let d = de.clone();
          requestAnimationFrame(() => {
            if (i.activeElement === i.body) {
              let c = d.getTreeNode(t);
              for (; c; ) {
                if (c.nodeToRestore && c.nodeToRestore.isConnected) {
                  qi(c.nodeToRestore);
                  return;
                }
                c = c.parent;
              }
              for (c = d.getTreeNode(t); c; ) {
                if (c.scopeRef && c.scopeRef.current && de.getTreeNode(c.scopeRef)) {
                  let f = so(c.scopeRef.current, !0);
                  qi(f);
                  return;
                }
                c = c.parent;
              }
            }
          });
        }
      };
    }
  }, [
    t,
    e
  ]);
}
function qi(t) {
  t.dispatchEvent(new CustomEvent(Tr, {
    bubbles: !0,
    cancelable: !0
  })) && He(t);
}
function Ce(t, e, n) {
  let r = e?.tabbable ? Sv : Wr, i = t?.nodeType === Node.ELEMENT_NODE ? t : null, l = Q(i), o = Yf(l, t || l, NodeFilter.SHOW_ELEMENT, {
    acceptNode(a) {
      var s;
      return !(e == null || (s = e.from) === null || s === void 0) && s.contains(a) || e?.tabbable && a.tagName === "INPUT" && a.getAttribute("type") === "radio" && (!Bb(a) || o.currentNode.tagName === "INPUT" && o.currentNode.type === "radio" && o.currentNode.name === a.name) ? NodeFilter.FILTER_REJECT : r(a) && (!n || we(a, n)) && (!e?.accept || e.accept(a)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (o.currentNode = e.from), o;
}
class Zr {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, n, r) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let l = new Br({
      scopeRef: e
    });
    i.addChild(l), l.parent = i, this.fastMap.set(e, l), r && (l.nodeToRestore = r);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let n = this.fastMap.get(e);
    if (!n) return;
    let r = n.parent;
    for (let l of this.traverse()) l !== n && n.nodeToRestore && l.nodeToRestore && n.scopeRef && n.scopeRef.current && we(l.nodeToRestore, n.scopeRef.current) && (l.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    r && (r.removeChild(n), i.size > 0 && i.forEach((l) => r && r.addChild(l))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let n of e.children) yield* this.traverse(n);
  }
  clone() {
    var e;
    let n = new Zr();
    var r;
    for (let i of this.traverse()) n.addTreeNode(i.scopeRef, (r = (e = i.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && r !== void 0 ? r : null, i.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Br({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class Br {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
let de = new Zr();
function Ne(t = {}) {
  let { autoFocus: e = !1, isTextInput: n, within: r } = t, i = L({
    isFocused: !1,
    isFocusVisible: e || kt()
  }), [l, o] = W(!1), [a, s] = W(() => i.current.isFocused && i.current.isFocusVisible), u = j(() => s(i.current.isFocused && i.current.isFocusVisible), []), d = j((v) => {
    i.current.isFocused = v, o(v), u();
  }, [
    u
  ]);
  xb((v) => {
    i.current.isFocusVisible = v, u();
  }, [], {
    isTextInput: n
  });
  let { focusProps: c } = Un({
    isDisabled: r,
    onFocusChange: d
  }), { focusWithinProps: f } = ln({
    isDisabled: !r,
    onFocusWithinChange: d
  });
  return {
    isFocused: l,
    isFocusVisible: a,
    focusProps: r ? f : c
  };
}
function Ab(t, e) {
  let n = e?.isDisabled, [r, i] = W(!1);
  return X(() => {
    if (t?.current && !n) {
      let l = () => {
        if (t.current) {
          let a = Ce(t.current, {
            tabbable: !0
          });
          i(!!a.nextNode());
        }
      };
      l();
      let o = new MutationObserver(l);
      return o.observe(t.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        o.disconnect();
      };
    }
  }), n ? !1 : r;
}
function uo(t) {
  let e = Rb(Q(t));
  e !== t && (e && Nb(e, t), t && co(t, e));
}
function Nb(t, e) {
  t.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function co(t, e) {
  t.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function Rb(t) {
  let e = be(t), n = e?.getAttribute("aria-activedescendant");
  return n && t.getElementById(n) || e;
}
const Ke = [];
function fo(t, e) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: i, isDismissable: l = !1, isKeyboardDismissDisabled: o = !1, shouldCloseOnInteractOutside: a } = t;
  _(() => {
    if (i && !Ke.includes(e))
      return Ke.push(e), () => {
        let b = Ke.indexOf(e);
        b >= 0 && Ke.splice(b, 1);
      };
  }, [
    i,
    e
  ]);
  let s = () => {
    Ke[Ke.length - 1] === e && n && n();
  }, u = (b) => {
    (!a || a(b.target)) && Ke[Ke.length - 1] === e && (b.stopPropagation(), b.preventDefault());
  }, d = (b) => {
    (!a || a(b.target)) && (Ke[Ke.length - 1] === e && (b.stopPropagation(), b.preventDefault()), s());
  }, c = (b) => {
    b.key === "Escape" && !o && !b.nativeEvent.isComposing && (b.stopPropagation(), b.preventDefault(), s());
  };
  Cb({
    ref: e,
    onInteractOutside: l && i ? d : void 0,
    onInteractOutsideStart: u
  });
  let { focusWithinProps: f } = ln({
    isDisabled: !r,
    onBlurWithin: (b) => {
      !b.relatedTarget || Kb(b.relatedTarget) || (!a || a(b.relatedTarget)) && n?.();
    }
  }), v = (b) => {
    b.target === b.currentTarget && b.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: c,
      ...f
    },
    underlayProps: {
      onPointerDown: v
    }
  };
}
function vo(t, e, n) {
  let { type: r } = t, { isOpen: i } = e;
  _(() => {
    n && n.current && _l.set(n.current, e.close);
  });
  let l;
  r === "menu" ? l = !0 : r === "listbox" && (l = "listbox");
  let o = ae();
  return {
    triggerProps: {
      "aria-haspopup": l,
      "aria-expanded": i,
      "aria-controls": i ? o : void 0,
      onPress: e.toggle
    },
    overlayProps: {
      id: o
    }
  };
}
const jt = typeof document < "u" && window.visualViewport;
let hn = 0, ur;
function bo(t = {}) {
  let { isDisabled: e } = t;
  X(() => {
    if (!e)
      return hn++, hn === 1 && (nn() ? ur = Vb() : ur = Ob()), () => {
        hn--, hn === 0 && ur();
      };
  }, [
    e
  ]);
}
function Ob() {
  let t = window.innerWidth - document.documentElement.clientWidth;
  return Ue(t > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? dr(document.documentElement, "scrollbarGutter", "stable") : dr(document.documentElement, "paddingRight", `${t}px`)), dr(document.documentElement, "overflow", "hidden"));
}
function Vb() {
  let t, e = !1, n = (s) => {
    let u = s.target;
    t = bt(u) ? u : ze(u, !0), e = !1;
    let d = u.ownerDocument.defaultView.getSelection();
    d && !d.isCollapsed && d.containsNode(u, !0) && (e = !0), "selectionStart" in u && "selectionEnd" in u && u.selectionStart < u.selectionEnd && u.ownerDocument.activeElement === u && (e = !0);
  }, r = document.createElement("style");
  r.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(r);
  let i = (s) => {
    if (!(s.touches.length === 2 || e)) {
      if (!t || t === document.documentElement || t === document.body) {
        s.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && s.preventDefault();
    }
  }, l = (s) => {
    let u = s.target, d = s.relatedTarget;
    if (d && _t(d))
      d.focus({
        preventScroll: !0
      }), Yi(d, _t(u));
    else if (!d) {
      var c;
      let f = (c = u.parentElement) === null || c === void 0 ? void 0 : c.closest("[tabindex]");
      f?.focus({
        preventScroll: !0
      });
    }
  }, o = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(s) {
    let u = document.activeElement != null && _t(document.activeElement);
    o.call(this, {
      ...s,
      preventScroll: !0
    }), (!s || !s.preventScroll) && Yi(this, u);
  };
  let a = Ue(cr(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), cr(document, "touchmove", i, {
    passive: !1,
    capture: !0
  }), cr(document, "blur", l, !0));
  return () => {
    a(), r.remove(), HTMLElement.prototype.focus = o;
  };
}
function dr(t, e, n) {
  let r = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = r;
  };
}
function cr(t, e, n, r) {
  return t.addEventListener(e, n, r), () => {
    t.removeEventListener(e, n, r);
  };
}
function Yi(t, e) {
  e || !jt ? Xi(t) : jt.addEventListener("resize", () => Xi(t), {
    once: !0
  });
}
function Xi(t) {
  let e = document.scrollingElement || document.documentElement, n = t;
  for (; n && n !== e; ) {
    let r = ze(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let i = r.getBoundingClientRect(), l = n.getBoundingClientRect();
      if (l.top < i.top || l.bottom > i.top + n.clientHeight) {
        let o = i.bottom;
        jt && (o = Math.min(o, jt.offsetTop + jt.height));
        let a = l.top - i.top - ((o - i.top) / 2 - l.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + a)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
const zb = /* @__PURE__ */ O({});
function po() {
  var t;
  return (t = H(zb)) !== null && t !== void 0 ? t : {};
}
const Fr = /* @__PURE__ */ x.createContext(null);
function Hb(t) {
  let { children: e } = t, n = H(Fr), [r, i] = W(0), l = z(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      i((o) => o + 1), n && n.addModal();
    },
    removeModal() {
      i((o) => o - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ x.createElement(Fr.Provider, {
    value: l
  }, e);
}
function _b() {
  let t = H(Fr);
  return {
    modalProviderProps: {
      "aria-hidden": t && t.modalCount > 0 ? !0 : void 0
    }
  };
}
function Ub(t) {
  let { modalProviderProps: e } = _b();
  return /* @__PURE__ */ x.createElement("div", {
    "data-overlay-container": !0,
    ...t,
    ...e
  });
}
function jb(t) {
  return /* @__PURE__ */ x.createElement(Hb, null, /* @__PURE__ */ x.createElement(Ub, t));
}
function Wb(t) {
  let e = Me(), { portalContainer: n = e ? null : document.body, ...r } = t, { getContainer: i } = po();
  if (!t.portalContainer && i && (n = i()), x.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let l = /* @__PURE__ */ x.createElement(jb, r);
  return /* @__PURE__ */ Pl.createPortal(l, n);
}
var mo = {};
mo = {
  dismiss: "تجاهل"
};
var ho = {};
ho = {
  dismiss: "Отхвърляне"
};
var $o = {};
$o = {
  dismiss: "Odstranit"
};
var go = {};
go = {
  dismiss: "Luk"
};
var yo = {};
yo = {
  dismiss: "Schließen"
};
var xo = {};
xo = {
  dismiss: "Απόρριψη"
};
var Eo = {};
Eo = {
  dismiss: "Dismiss"
};
var Po = {};
Po = {
  dismiss: "Descartar"
};
var Do = {};
Do = {
  dismiss: "Lõpeta"
};
var So = {};
So = {
  dismiss: "Hylkää"
};
var Co = {};
Co = {
  dismiss: "Rejeter"
};
var wo = {};
wo = {
  dismiss: "התעלם"
};
var To = {};
To = {
  dismiss: "Odbaci"
};
var ko = {};
ko = {
  dismiss: "Elutasítás"
};
var Bo = {};
Bo = {
  dismiss: "Ignora"
};
var Fo = {};
Fo = {
  dismiss: "閉じる"
};
var Ko = {};
Ko = {
  dismiss: "무시"
};
var Lo = {};
Lo = {
  dismiss: "Atmesti"
};
var Mo = {};
Mo = {
  dismiss: "Nerādīt"
};
var Io = {};
Io = {
  dismiss: "Lukk"
};
var Ao = {};
Ao = {
  dismiss: "Negeren"
};
var No = {};
No = {
  dismiss: "Zignoruj"
};
var Ro = {};
Ro = {
  dismiss: "Descartar"
};
var Oo = {};
Oo = {
  dismiss: "Dispensar"
};
var Vo = {};
Vo = {
  dismiss: "Revocare"
};
var zo = {};
zo = {
  dismiss: "Пропустить"
};
var Ho = {};
Ho = {
  dismiss: "Zrušiť"
};
var _o = {};
_o = {
  dismiss: "Opusti"
};
var Uo = {};
Uo = {
  dismiss: "Odbaci"
};
var jo = {};
jo = {
  dismiss: "Avvisa"
};
var Wo = {};
Wo = {
  dismiss: "Kapat"
};
var Go = {};
Go = {
  dismiss: "Скасувати"
};
var qo = {};
qo = {
  dismiss: "取消"
};
var Yo = {};
Yo = {
  dismiss: "關閉"
};
var Xo = {};
Xo = {
  "ar-AE": mo,
  "bg-BG": ho,
  "cs-CZ": $o,
  "da-DK": go,
  "de-DE": yo,
  "el-GR": xo,
  "en-US": Eo,
  "es-ES": Po,
  "et-EE": Do,
  "fi-FI": So,
  "fr-FR": Co,
  "he-IL": wo,
  "hr-HR": To,
  "hu-HU": ko,
  "it-IT": Bo,
  "ja-JP": Fo,
  "ko-KR": Ko,
  "lt-LT": Lo,
  "lv-LV": Mo,
  "nb-NO": Io,
  "nl-NL": Ao,
  "pl-PL": No,
  "pt-BR": Ro,
  "pt-PT": Oo,
  "ro-RO": Vo,
  "ru-RU": zo,
  "sk-SK": Ho,
  "sl-SI": _o,
  "sr-SP": Uo,
  "sv-SE": jo,
  "tr-TR": Wo,
  "uk-UA": Go,
  "zh-CN": qo,
  "zh-TW": Yo
};
const Zi = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Gb(t = {}) {
  let { style: e, isFocusable: n } = t, [r, i] = W(!1), { focusWithinProps: l } = ln({
    isDisabled: !n,
    onFocusWithinChange: (a) => i(a)
  }), o = z(() => r ? e : e ? {
    ...Zi,
    ...e
  } : Zi, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...l,
      style: o
    }
  };
}
function Zo(t) {
  let { children: e, elementType: n = "div", isFocusable: r, style: i, ...l } = t, { visuallyHiddenProps: o } = Gb(t);
  return /* @__PURE__ */ x.createElement(n, R(l, o), e);
}
function qb(t) {
  return t && t.__esModule ? t.default : t;
}
function Kr(t) {
  let { onDismiss: e, ...n } = t, r = Ge(qb(Xo), "@react-aria/overlays"), i = Nl(n, r.format("dismiss")), l = () => {
    e && e();
  };
  return /* @__PURE__ */ x.createElement(Zo, null, /* @__PURE__ */ x.createElement("button", {
    ...i,
    tabIndex: -1,
    onClick: l,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const Yb = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
let Rt = /* @__PURE__ */ new WeakMap(), Ee = [];
function Jo(t, e) {
  let n = ge(t?.[0]), r = e instanceof n.Element ? {
    root: e
  } : e;
  var i;
  let l = (i = r?.root) !== null && i !== void 0 ? i : document.body, o = r?.shouldUseInert && Yb, a = new Set(t), s = /* @__PURE__ */ new Set(), u = (p) => o && p instanceof n.HTMLElement ? p.inert : p.getAttribute("aria-hidden") === "true", d = (p, h) => {
    o && p instanceof n.HTMLElement ? p.inert = h : h ? p.setAttribute("aria-hidden", "true") : (p.removeAttribute("aria-hidden"), p instanceof n.HTMLElement && (p.inert = !1));
  }, c = (p) => {
    for (let P of p.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) a.add(P);
    let h = (P) => {
      if (s.has(P) || a.has(P) || P.parentElement && s.has(P.parentElement) && P.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let S of a)
        if (P.contains(S)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, $ = document.createTreeWalker(p, NodeFilter.SHOW_ELEMENT, {
      acceptNode: h
    }), y = h(p);
    if (y === NodeFilter.FILTER_ACCEPT && f(p), y !== NodeFilter.FILTER_REJECT) {
      let P = $.nextNode();
      for (; P != null; )
        f(P), P = $.nextNode();
    }
  }, f = (p) => {
    var h;
    let $ = (h = Rt.get(p)) !== null && h !== void 0 ? h : 0;
    u(p) && $ === 0 || ($ === 0 && d(p, !0), s.add(p), Rt.set(p, $ + 1));
  };
  Ee.length && Ee[Ee.length - 1].disconnect(), c(l);
  let v = new MutationObserver((p) => {
    for (let h of p)
      if (h.type === "childList" && ![
        ...a,
        ...s
      ].some(($) => $.contains(h.target)))
        for (let $ of h.addedNodes)
          ($ instanceof HTMLElement || $ instanceof SVGElement) && ($.dataset.liveAnnouncer === "true" || $.dataset.reactAriaTopLayer === "true") ? a.add($) : $ instanceof Element && c($);
  });
  v.observe(l, {
    childList: !0,
    subtree: !0
  });
  let b = {
    visibleNodes: a,
    hiddenNodes: s,
    observe() {
      v.observe(l, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      v.disconnect();
    }
  };
  return Ee.push(b), () => {
    v.disconnect();
    for (let p of s) {
      let h = Rt.get(p);
      h != null && (h === 1 ? (d(p, !1), Rt.delete(p)) : Rt.set(p, h - 1));
    }
    b === Ee[Ee.length - 1] ? (Ee.pop(), Ee.length && Ee[Ee.length - 1].observe()) : Ee.splice(Ee.indexOf(b), 1);
  };
}
function Xb(t) {
  let e = Ee[Ee.length - 1];
  if (e && !e.visibleNodes.has(t))
    return e.visibleNodes.add(t), () => {
      e.visibleNodes.delete(t);
    };
}
function Zb(t, e) {
  let { triggerRef: n, popoverRef: r, groupRef: i, isNonModal: l, isKeyboardDismissDisabled: o, shouldCloseOnInteractOutside: a, ...s } = t, u = s.trigger === "SubmenuTrigger", { overlayProps: d, underlayProps: c } = fo({
    isOpen: e.isOpen,
    onClose: e.close,
    shouldCloseOnBlur: !0,
    isDismissable: !l || u,
    isKeyboardDismissDisabled: o,
    shouldCloseOnInteractOutside: a
  }, i ?? r), { overlayProps: f, arrowProps: v, placement: b, triggerAnchorPoint: p } = ql({
    ...s,
    targetRef: n,
    overlayRef: r,
    isOpen: e.isOpen,
    onClose: l && !u ? e.close : null
  });
  return bo({
    isDisabled: l || !e.isOpen
  }), _(() => {
    if (e.isOpen && r.current) {
      var h, $;
      return l ? Xb((h = i?.current) !== null && h !== void 0 ? h : r.current) : Jo([
        ($ = i?.current) !== null && $ !== void 0 ? $ : r.current
      ], {
        shouldUseInert: !0
      });
    }
  }, [
    l,
    e.isOpen,
    r,
    i
  ]), {
    popoverProps: R(d, f),
    arrowProps: v,
    underlayProps: c,
    placement: b,
    triggerAnchorPoint: p
  };
}
const Qo = /* @__PURE__ */ x.createContext(null);
function Lr(t) {
  let e = Me(), { portalContainer: n = e ? null : document.body, isExiting: r } = t, [i, l] = W(!1), o = z(() => ({
    contain: i,
    setContain: l
  }), [
    i,
    l
  ]), { getContainer: a } = po();
  if (!t.portalContainer && a && (n = a()), !n) return null;
  let s = t.children;
  return t.disableFocusManagement || (s = /* @__PURE__ */ x.createElement(oo, {
    restoreFocus: !0,
    contain: (t.shouldContainFocus || i) && !r
  }, s)), s = /* @__PURE__ */ x.createElement(Qo.Provider, {
    value: o
  }, /* @__PURE__ */ x.createElement(Db, null, s)), /* @__PURE__ */ Pl.createPortal(s, n);
}
function ea() {
  let t = H(Qo), e = t?.setContain;
  X(() => {
    e?.(!0);
  }, [
    e
  ]);
}
function Jb(t, e, n) {
  let { overlayProps: r, underlayProps: i } = fo({
    ...t,
    isOpen: e.isOpen,
    onClose: e.close
  }, n);
  return bo({
    isDisabled: !e.isOpen
  }), ea(), _(() => {
    if (e.isOpen && n.current) return Jo([
      n.current
    ], {
      shouldUseInert: !0
    });
  }, [
    e.isOpen,
    n
  ]), {
    modalProps: R(r),
    underlayProps: i
  };
}
function ta(t) {
  let { id: e, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: l = "label" } = t;
  e = ae(e);
  let o = ae(), a = {};
  n ? (r = r ? `${o} ${r}` : o, a = {
    id: o,
    htmlFor: l === "label" ? e : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let s = Nl({
    id: e,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: a,
    fieldProps: s
  };
}
function na(t) {
  let { description: e, errorMessage: n, isInvalid: r, validationState: i } = t, { labelProps: l, fieldProps: o } = ta(t), a = ft([
    !!e,
    !!n,
    r,
    i
  ]), s = ft([
    !!e,
    !!n,
    r,
    i
  ]);
  return o = R(o, {
    "aria-describedby": [
      a,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      s,
      t["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: o,
    descriptionProps: {
      id: a
    },
    errorMessageProps: {
      id: s
    }
  };
}
function Mr(t) {
  return lv() ? t.altKey : t.ctrlKey;
}
function xn(t, e) {
  var n, r;
  let i = `[data-key="${CSS.escape(String(e))}"]`, l = (n = t.current) === null || n === void 0 ? void 0 : n.dataset.collection;
  return l && (i = `[data-collection="${CSS.escape(l)}"]${i}`), (r = t.current) === null || r === void 0 ? void 0 : r.querySelector(i);
}
const ra = /* @__PURE__ */ new WeakMap();
function Qb(t) {
  let e = ae();
  return ra.set(t, e), e;
}
function ep(t) {
  return ra.get(t);
}
const tp = 1e3;
function np(t) {
  let { keyboardDelegate: e, selectionManager: n, onTypeSelect: r } = t, i = L({
    search: "",
    timeout: void 0
  }).current, l = (o) => {
    let a = rp(o.key);
    if (!(!a || o.ctrlKey || o.metaKey || !o.currentTarget.contains(o.target) || i.search.length === 0 && a === " ")) {
      if (a === " " && i.search.trim().length > 0 && (o.preventDefault(), "continuePropagation" in o || o.stopPropagation()), i.search += a, e.getKeyForSearch != null) {
        let s = e.getKeyForSearch(i.search, n.focusedKey);
        s == null && (s = e.getKeyForSearch(i.search)), s != null && (n.setFocusedKey(s), r && r(s));
      }
      clearTimeout(i.timeout), i.timeout = setTimeout(() => {
        i.search = "";
      }, tp);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? l : void 0
    }
  };
}
function rp(t) {
  return t.length === 1 || !/^[A-Z]/i.test(t) ? t : "";
}
function ip(t) {
  let { selectionManager: e, keyboardDelegate: n, ref: r, autoFocus: i = !1, shouldFocusWrap: l = !1, disallowEmptySelection: o = !1, disallowSelectAll: a = !1, escapeKeyBehavior: s = "clearSelection", selectOnFocus: u = e.selectionBehavior === "replace", disallowTypeAhead: d = !1, shouldUseVirtualFocus: c, allowsTabNavigation: f = !1, isVirtualized: v, scrollRef: b = r, linkBehavior: p = "action" } = t, { direction: h } = Ae(), $ = Bt(), y = (E) => {
    var k;
    if (E.altKey && E.key === "Tab" && E.preventDefault(), !(!((k = r.current) === null || k === void 0) && k.contains(E.target))) return;
    const V = (U, he) => {
      if (U != null) {
        if (e.isLink(U) && p === "selection" && u && !Mr(E)) {
          Nn(() => {
            e.setFocusedKey(U, he);
          });
          let ke = xn(r, U), it = e.getItemProps(U);
          ke && $.open(ke, E, it.href, it.routerOptions);
          return;
        }
        if (e.setFocusedKey(U, he), e.isLink(U) && p === "override") return;
        E.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(U) : u && !Mr(E) && e.replaceSelection(U);
      }
    };
    switch (E.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var C, Y, ne;
          let U = e.focusedKey != null ? (C = n.getKeyBelow) === null || C === void 0 ? void 0 : C.call(n, e.focusedKey) : (Y = n.getFirstKey) === null || Y === void 0 ? void 0 : Y.call(n);
          U == null && l && (U = (ne = n.getFirstKey) === null || ne === void 0 ? void 0 : ne.call(n, e.focusedKey)), U != null && (E.preventDefault(), V(U));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var G, fe, se;
          let U = e.focusedKey != null ? (G = n.getKeyAbove) === null || G === void 0 ? void 0 : G.call(n, e.focusedKey) : (fe = n.getLastKey) === null || fe === void 0 ? void 0 : fe.call(n);
          U == null && l && (U = (se = n.getLastKey) === null || se === void 0 ? void 0 : se.call(n, e.focusedKey)), U != null && (E.preventDefault(), V(U));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var me, Te, ye;
          let U = e.focusedKey != null ? (me = n.getKeyLeftOf) === null || me === void 0 ? void 0 : me.call(n, e.focusedKey) : null;
          U == null && l && (U = h === "rtl" ? (Te = n.getFirstKey) === null || Te === void 0 ? void 0 : Te.call(n, e.focusedKey) : (ye = n.getLastKey) === null || ye === void 0 ? void 0 : ye.call(n, e.focusedKey)), U != null && (E.preventDefault(), V(U, h === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var qe, Re, Ye;
          let U = e.focusedKey != null ? (qe = n.getKeyRightOf) === null || qe === void 0 ? void 0 : qe.call(n, e.focusedKey) : null;
          U == null && l && (U = h === "rtl" ? (Re = n.getLastKey) === null || Re === void 0 ? void 0 : Re.call(n, e.focusedKey) : (Ye = n.getFirstKey) === null || Ye === void 0 ? void 0 : Ye.call(n, e.focusedKey)), U != null && (E.preventDefault(), V(U, h === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (e.focusedKey === null && E.shiftKey) return;
          E.preventDefault();
          let U = n.getFirstKey(e.focusedKey, Pt(E));
          e.setFocusedKey(U), U != null && (Pt(E) && E.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(U) : u && e.replaceSelection(U));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (e.focusedKey === null && E.shiftKey) return;
          E.preventDefault();
          let U = n.getLastKey(e.focusedKey, Pt(E));
          e.setFocusedKey(U), U != null && (Pt(E) && E.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(U) : u && e.replaceSelection(U));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && e.focusedKey != null) {
          let U = n.getKeyPageBelow(e.focusedKey);
          U != null && (E.preventDefault(), V(U));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && e.focusedKey != null) {
          let U = n.getKeyPageAbove(e.focusedKey);
          U != null && (E.preventDefault(), V(U));
        }
        break;
      case "a":
        Pt(E) && e.selectionMode === "multiple" && a !== !0 && (E.preventDefault(), e.selectAll());
        break;
      case "Escape":
        s === "clearSelection" && !o && e.selectedKeys.size !== 0 && (E.stopPropagation(), E.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!f) {
          if (E.shiftKey) r.current.focus();
          else {
            let U = Ce(r.current, {
              tabbable: !0
            }), he, ke;
            do
              ke = U.lastChild(), ke && (he = ke);
            while (ke);
            he && !he.contains(document.activeElement) && ve(he);
          }
          break;
        }
    }
  }, P = L({
    top: 0,
    left: 0
  });
  dt(b, "scroll", v ? void 0 : () => {
    var E, k, V, C;
    P.current = {
      top: (V = (E = b.current) === null || E === void 0 ? void 0 : E.scrollTop) !== null && V !== void 0 ? V : 0,
      left: (C = (k = b.current) === null || k === void 0 ? void 0 : k.scrollLeft) !== null && C !== void 0 ? C : 0
    };
  });
  let S = (E) => {
    if (e.isFocused) {
      E.currentTarget.contains(E.target) || e.setFocused(!1);
      return;
    }
    if (E.currentTarget.contains(E.target)) {
      if (e.setFocused(!0), e.focusedKey == null) {
        var k, V;
        let ne = (fe) => {
          fe != null && (e.setFocusedKey(fe), u && !e.isSelected(fe) && e.replaceSelection(fe));
        }, G = E.relatedTarget;
        var C, Y;
        G && E.currentTarget.compareDocumentPosition(G) & Node.DOCUMENT_POSITION_FOLLOWING ? ne((C = e.lastSelectedKey) !== null && C !== void 0 ? C : (k = n.getLastKey) === null || k === void 0 ? void 0 : k.call(n)) : ne((Y = e.firstSelectedKey) !== null && Y !== void 0 ? Y : (V = n.getFirstKey) === null || V === void 0 ? void 0 : V.call(n));
      } else !v && b.current && (b.current.scrollTop = P.current.top, b.current.scrollLeft = P.current.left);
      if (e.focusedKey != null && b.current) {
        let ne = xn(r, e.focusedKey);
        ne instanceof HTMLElement && (!ne.contains(document.activeElement) && !c && ve(ne), Zt() === "keyboard" && Ze(ne, {
          containingElement: r.current
        }));
      }
    }
  }, A = (E) => {
    E.currentTarget.contains(E.relatedTarget) || e.setFocused(!1);
  }, w = L(!1);
  dt(r, gv, c ? (E) => {
    let { detail: k } = E;
    E.stopPropagation(), e.setFocused(!0), k?.focusStrategy === "first" && (w.current = !0);
  } : void 0);
  let M = te(() => {
    var E, k;
    let V = (k = (E = n.getFirstKey) === null || E === void 0 ? void 0 : E.call(n)) !== null && k !== void 0 ? k : null;
    if (V == null) {
      let C = be();
      uo(r.current), co(C, null), e.collection.size > 0 && (w.current = !1);
    } else
      e.setFocusedKey(V), w.current = !1;
  });
  $i(() => {
    w.current && M();
  }, [
    e.collection,
    M
  ]);
  let T = te(() => {
    e.collection.size > 0 && (w.current = !1);
  });
  $i(() => {
    T();
  }, [
    e.focusedKey,
    T
  ]), dt(r, $v, c ? (E) => {
    var k;
    E.stopPropagation(), e.setFocused(!1), !((k = E.detail) === null || k === void 0) && k.clearFocusKey && e.setFocusedKey(null);
  } : void 0);
  const N = L(i), I = L(!1);
  _(() => {
    if (N.current) {
      var E, k;
      let Y = null;
      var V;
      i === "first" && (Y = (V = (E = n.getFirstKey) === null || E === void 0 ? void 0 : E.call(n)) !== null && V !== void 0 ? V : null);
      var C;
      i === "last" && (Y = (C = (k = n.getLastKey) === null || k === void 0 ? void 0 : k.call(n)) !== null && C !== void 0 ? C : null);
      let ne = e.selectedKeys;
      if (ne.size) {
        for (let G of ne) if (e.canSelectItem(G)) {
          Y = G;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(Y), Y == null && !c && r.current && $e(r.current), e.collection.size > 0 && (N.current = !1, I.current = !0);
    }
  });
  let m = L(e.focusedKey), K = L(null);
  _(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== m.current || I.current) && b.current && r.current) {
      let E = Zt(), k = xn(r, e.focusedKey);
      if (!(k instanceof HTMLElement))
        return;
      (E === "keyboard" || I.current) && (K.current && cancelAnimationFrame(K.current), K.current = requestAnimationFrame(() => {
        b.current && (Rl(b.current, k), E !== "virtual" && Ze(k, {
          containingElement: r.current
        }));
      }));
    }
    !c && e.isFocused && e.focusedKey == null && m.current != null && r.current && $e(r.current), m.current = e.focusedKey, I.current = !1;
  }), _(() => () => {
    K.current && cancelAnimationFrame(K.current);
  }, []), dt(r, "react-aria-focus-scope-restore", (E) => {
    E.preventDefault(), e.setFocused(!0);
  });
  let B = {
    onKeyDown: y,
    onFocus: S,
    onBlur: A,
    onMouseDown(E) {
      b.current === E.target && E.preventDefault();
    }
  }, { typeSelectProps: D } = np({
    keyboardDelegate: n,
    selectionManager: e
  });
  d || (B = R(D, B));
  let F;
  c || (F = e.focusedKey == null ? 0 : -1);
  let g = Qb(e.collection);
  return {
    collectionProps: R(B, {
      tabIndex: F,
      "data-collection": g
    })
  };
}
function ia(t) {
  let { id: e, selectionManager: n, key: r, ref: i, shouldSelectOnPressUp: l, shouldUseVirtualFocus: o, focus: a, isDisabled: s, onAction: u, allowsDifferentPressOrigin: d, linkBehavior: c = "action" } = t, f = Bt();
  e = ae(e);
  let v = (C) => {
    if (C.pointerType === "keyboard" && Mr(C)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (c === "selection" && i.current) {
          let Y = n.getItemProps(r);
          f.open(i.current, C, Y.href, Y.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (c === "override" || c === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : C && C.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || C && (Pt(C) || C.pointerType === "touch" || C.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  _(() => {
    r === n.focusedKey && n.isFocused && (o ? uo(i.current) : a ? a() : document.activeElement !== i.current && i.current && $e(i.current));
  }, [
    i,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    o
  ]), s = s || n.isDisabled(r);
  let b = {};
  !o && !s ? b = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(C) {
      C.target === i.current && n.setFocusedKey(r);
    }
  } : s && (b.onMouseDown = (C) => {
    C.preventDefault();
  });
  let p = n.isLink(r) && c === "override", h = u && t.UNSTABLE_itemBehavior === "action", $ = n.isLink(r) && c !== "selection" && c !== "none", y = !s && n.canSelectItem(r) && !p && !h, P = (u || $) && !s, S = P && (n.selectionBehavior === "replace" ? !y : !y || n.isEmpty), A = P && y && n.selectionBehavior === "replace", w = S || A, M = L(null), T = w && y, N = L(!1), I = L(!1), m = n.getItemProps(r), K = (C) => {
    if (u) {
      var Y;
      u(), (Y = i.current) === null || Y === void 0 || Y.dispatchEvent(new CustomEvent("react-aria-item-action", {
        bubbles: !0
      }));
    }
    $ && i.current && f.open(i.current, C, m.href, m.routerOptions);
  }, B = {
    ref: i
  };
  if (l ? (B.onPressStart = (C) => {
    M.current = C.pointerType, N.current = T, C.pointerType === "keyboard" && (!w || Qi()) && v(C);
  }, d ? (B.onPressUp = S ? void 0 : (C) => {
    C.pointerType === "mouse" && y && v(C);
  }, B.onPress = S ? K : (C) => {
    C.pointerType !== "keyboard" && C.pointerType !== "mouse" && y && v(C);
  }) : B.onPress = (C) => {
    if (S || A && C.pointerType !== "mouse") {
      if (C.pointerType === "keyboard" && !Ji()) return;
      K(C);
    } else C.pointerType !== "keyboard" && y && v(C);
  }) : (B.onPressStart = (C) => {
    M.current = C.pointerType, N.current = T, I.current = S, y && (C.pointerType === "mouse" && !S || C.pointerType === "keyboard" && (!P || Qi())) && v(C);
  }, B.onPress = (C) => {
    (C.pointerType === "touch" || C.pointerType === "pen" || C.pointerType === "virtual" || C.pointerType === "keyboard" && w && Ji() || C.pointerType === "mouse" && I.current) && (w ? K(C) : y && v(C));
  }), b["data-collection"] = ep(n.collection), b["data-key"] = r, B.preventFocusOnPress = o, o && (B = R(B, {
    onPressStart(C) {
      C.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(C) {
      C.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), m)
    for (let C of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) m[C] && (B[C] = Ue(B[C], m[C]));
  let { pressProps: D, isPressed: F } = nt(B), g = A ? (C) => {
    M.current === "mouse" && (C.stopPropagation(), C.preventDefault(), K(C));
  } : void 0, { longPressProps: E } = lo({
    isDisabled: !T,
    onLongPress(C) {
      C.pointerType === "touch" && (v(C), n.setSelectionBehavior("toggle"));
    }
  }), k = (C) => {
    M.current === "touch" && N.current && C.preventDefault();
  }, V = c !== "none" && n.isLink(r) ? (C) => {
    tt.isOpening || C.preventDefault();
  } : void 0;
  return {
    itemProps: R(
      b,
      y || S || o && !s ? D : {},
      T ? E : {},
      {
        onDoubleClick: g,
        onDragStartCapture: k,
        onClick: V,
        id: e
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      o ? {
        onMouseDown: (C) => C.preventDefault()
      } : void 0
    ),
    isPressed: F,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: s,
    allowsSelection: y,
    hasAction: w
  };
}
function Ji() {
  let t = window.event;
  return t?.key === "Enter";
}
function Qi() {
  let t = window.event;
  return t?.key === " " || t?.code === "Space";
}
class el {
  getItemRect(e) {
    let n = this.ref.current;
    if (!n) return null;
    let r = e != null ? xn(this.ref, e) : null;
    if (!r) return null;
    let i = n.getBoundingClientRect(), l = r.getBoundingClientRect();
    return {
      x: l.left - i.left - n.clientLeft + n.scrollLeft,
      y: l.top - i.top - n.clientTop + n.scrollTop,
      width: l.width,
      height: l.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    var n, r;
    return {
      width: (n = e?.scrollWidth) !== null && n !== void 0 ? n : 0,
      height: (r = e?.scrollHeight) !== null && r !== void 0 ? r : 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    var n, r, i, l;
    return {
      x: (n = e?.scrollLeft) !== null && n !== void 0 ? n : 0,
      y: (r = e?.scrollTop) !== null && r !== void 0 ? r : 0,
      width: (i = e?.clientWidth) !== null && i !== void 0 ? i : 0,
      height: (l = e?.clientHeight) !== null && l !== void 0 ? l : 0
    };
  }
  constructor(e) {
    this.ref = e;
  }
}
class la {
  isDisabled(e) {
    var n;
    return this.disabledBehavior === "all" && (((n = e.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(e.key));
  }
  findNextNonDisabled(e, n) {
    let r = e;
    for (; r != null; ) {
      let i = this.collection.getItem(r);
      if (i?.type === "item" && !this.isDisabled(i)) return r;
      r = n(r);
    }
    return null;
  }
  getNextKey(e) {
    let n = e;
    return n = this.collection.getKeyAfter(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyAfter(r));
  }
  getPreviousKey(e) {
    let n = e;
    return n = this.collection.getKeyBefore(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyBefore(r));
  }
  findKey(e, n, r) {
    let i = e, l = this.layoutDelegate.getItemRect(i);
    if (!l || i == null) return null;
    let o = l;
    do {
      if (i = n(i), i == null) break;
      l = this.layoutDelegate.getItemRect(i);
    } while (l && r(o, l) && i != null);
    return i;
  }
  isSameRow(e, n) {
    return e.y === n.y || e.x !== n.x;
  }
  isSameColumn(e, n) {
    return e.x === n.x || e.y !== n.y;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, n) {
    return n ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    let n = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[n] ? (e = this.layoutDelegate[n](e), this.findNextNonDisabled(e, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (r) => this.getNextColumn(r, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    let n = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[n] ? (e = this.layoutDelegate[n](e), this.findNextNonDisabled(e, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (r) => this.getNextColumn(r, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(e) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(e);
    if (!r) return null;
    if (n && !bt(n)) return this.getFirstKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let l = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > l && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let l = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y > l && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(e);
    if (!r) return null;
    if (n && !bt(n)) return this.getLastKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let l = Math.min(this.layoutDelegate.getContentSize().width, r.y - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < l && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let l = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < l && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getLastKey();
  }
  getKeyForSearch(e, n) {
    if (!this.collator) return null;
    let r = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let l = r.getItem(i);
      if (!l) return null;
      let o = l.textValue.slice(0, e.length);
      if (l.textValue && this.collator.compare(o, e) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let n = e[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new el(n.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new el(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function oa(t) {
  let { selectionManager: e, collection: n, disabledKeys: r, ref: i, keyboardDelegate: l, layoutDelegate: o } = t, a = Gl({
    usage: "search",
    sensitivity: "base"
  }), s = e.disabledBehavior, u = z(() => l || new la({
    collection: n,
    disabledKeys: r,
    disabledBehavior: s,
    ref: i,
    collator: a,
    layoutDelegate: o
  }), [
    l,
    o,
    n,
    r,
    i,
    a,
    s
  ]), { collectionProps: d } = ip({
    ...t,
    ref: i,
    selectionManager: e,
    keyboardDelegate: u
  });
  return {
    listProps: d
  };
}
class lp {
  build(e, n) {
    return this.context = n, tl(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: n, items: r } = e;
    if (x.isValidElement(n) && n.type === x.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let l of r)
        yield* this.getFullNode({
          value: l,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      x.Children.forEach(n, (o) => {
        o && i.push(o);
      });
      let l = 0;
      for (let o of i) {
        let a = this.getFullNode({
          element: o,
          index: l
        }, {});
        for (let s of a)
          l++, yield s;
      }
    }
  }
  getKey(e, n, r, i) {
    if (e.key != null) return e.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let l = n.value;
    if (l != null) {
      var o;
      let a = (o = l.key) !== null && o !== void 0 ? o : l.id;
      if (a == null) throw new Error("No key found for item");
      return a;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(e, n) {
    return {
      renderer: n.renderer || e.renderer
    };
  }
  *getFullNode(e, n, r, i) {
    if (x.isValidElement(e.element) && e.element.type === x.Fragment) {
      let h = [];
      x.Children.forEach(e.element.props.children, (y) => {
        h.push(y);
      });
      var l;
      let $ = (l = e.index) !== null && l !== void 0 ? l : 0;
      for (const y of h) yield* this.getFullNode({
        element: y,
        index: $++
      }, n, r, i);
      return;
    }
    let o = e.element;
    if (!o && e.value && n && n.renderer) {
      let h = this.cache.get(e.value);
      if (h && (!h.shouldInvalidate || !h.shouldInvalidate(this.context))) {
        h.index = e.index, h.parentKey = i ? i.key : null, yield h;
        return;
      }
      o = n.renderer(e.value);
    }
    if (x.isValidElement(o)) {
      let h = o.type;
      if (typeof h != "function" && typeof h.getCollectionNode != "function") {
        let S = o.type;
        throw new Error(`Unknown element <${S}> in collection.`);
      }
      let $ = h.getCollectionNode(o.props, this.context);
      var a;
      let y = (a = e.index) !== null && a !== void 0 ? a : 0, P = $.next();
      for (; !P.done && P.value; ) {
        let S = P.value;
        e.index = y;
        var s;
        let A = (s = S.key) !== null && s !== void 0 ? s : null;
        A == null && (A = S.element ? null : this.getKey(o, e, n, r));
        let M = [
          ...this.getFullNode({
            ...S,
            key: A,
            index: y,
            wrapper: op(e.wrapper, S.wrapper)
          }, this.getChildState(n, S), r ? `${r}${o.key}` : o.key, i)
        ];
        for (let T of M) {
          var u, d;
          T.value = (d = (u = S.value) !== null && u !== void 0 ? u : e.value) !== null && d !== void 0 ? d : null, T.value && this.cache.set(T.value, T);
          var c;
          if (e.type && T.type !== e.type) throw new Error(`Unsupported type <${fr(T.type)}> in <${fr((c = i?.type) !== null && c !== void 0 ? c : "unknown parent type")}>. Only <${fr(e.type)}> is supported.`);
          y++, yield T;
        }
        P = $.next(M);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let f = this;
    var v, b;
    let p = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: i ? i.key : null,
      value: (v = e.value) !== null && v !== void 0 ? v : null,
      level: i ? i.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: (b = e.textValue) !== null && b !== void 0 ? b : "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: tl(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let h = 0;
        for (let $ of e.childNodes()) {
          $.key != null && ($.key = `${p.key}${$.key}`);
          let y = f.getFullNode({
            ...$,
            index: h
          }, f.getChildState(n, $), p.key, p);
          for (let P of y)
            h++, yield P;
        }
      })
    };
    yield p;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function tl(t) {
  let e = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of e) yield r;
      n || (n = t());
      for (let r of n)
        e.push(r), yield r;
    }
  };
}
function op(t, e) {
  if (t && e) return (n) => t(e(n));
  if (t) return t;
  if (e) return e;
}
function fr(t) {
  return t[0].toUpperCase() + t.slice(1);
}
function aa(t, e, n) {
  let r = z(() => new lp(), []), { children: i, items: l, collection: o } = t;
  return z(() => {
    if (o) return o;
    let s = r.build({
      children: i,
      items: l
    }, n);
    return e(s);
  }, [
    r,
    i,
    l,
    o,
    n,
    e
  ]);
}
function sa(t, e) {
  return typeof e.getChildren == "function" ? e.getChildren(t.key) : t.childNodes;
}
function ap(t) {
  return sp(t);
}
function sp(t, e) {
  for (let n of t)
    return n;
}
function vr(t, e, n) {
  if (e.parentKey === n.parentKey) return e.index - n.index;
  let r = [
    ...nl(t, e),
    e
  ], i = [
    ...nl(t, n),
    n
  ], l = r.slice(0, i.length).findIndex((o, a) => o !== i[a]);
  return l !== -1 ? (e = r[l], n = i[l], e.index - n.index) : r.findIndex((o) => o === n) >= 0 ? 1 : (i.findIndex((o) => o === e) >= 0, -1);
}
function nl(t, e) {
  let n = [], r = e;
  for (; r?.parentKey != null; )
    r = t.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const rl = /* @__PURE__ */ new WeakMap();
function up(t) {
  let e = rl.get(t);
  if (e != null) return e;
  let n = 0, r = (i) => {
    for (let l of i)
      l.type === "section" ? r(sa(l, t)) : l.type === "item" && n++;
  };
  return r(t), rl.set(t, n), n;
}
const ua = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, da = {
  ...ua,
  customError: !0,
  valid: !1
}, Dt = {
  isInvalid: !1,
  validationDetails: ua,
  validationErrors: []
}, dp = O({}), Jt = "__formValidationState" + Date.now();
function jn(t) {
  if (t[Jt]) {
    let { realtimeValidation: e, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: l } = t[Jt];
    return {
      realtimeValidation: e,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: l
    };
  }
  return cp(t);
}
function cp(t) {
  let { isInvalid: e, validationState: n, name: r, value: i, builtinValidation: l, validate: o, validationBehavior: a = "aria" } = t;
  n && (e || (e = n === "invalid"));
  let s = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: da
  } : null, u = z(() => {
    if (!o || i == null) return null;
    let I = fp(o, i);
    return il(I);
  }, [
    o,
    i
  ]);
  l?.validationDetails.valid && (l = void 0);
  let d = H(dp), c = z(() => r ? Array.isArray(r) ? r.flatMap((I) => Ir(d[I])) : Ir(d[r]) : [], [
    d,
    r
  ]), [f, v] = W(d), [b, p] = W(!1);
  d !== f && (v(d), p(!1));
  let h = z(() => il(b ? [] : c), [
    b,
    c
  ]), $ = L(Dt), [y, P] = W(Dt), S = L(Dt), A = () => {
    if (!w) return;
    M(!1);
    let I = u || l || $.current;
    br(I, S.current) || (S.current = I, P(I));
  }, [w, M] = W(!1);
  return _(A), {
    realtimeValidation: s || h || u || l || Dt,
    displayValidation: a === "native" ? s || h || y : s || h || u || l || y,
    updateValidation(I) {
      a === "aria" && !br(y, I) ? P(I) : $.current = I;
    },
    resetValidation() {
      let I = Dt;
      br(I, S.current) || (S.current = I, P(I)), a === "native" && M(!1), p(!0);
    },
    commitValidation() {
      a === "native" && M(!0), p(!0);
    }
  };
}
function Ir(t) {
  return t ? Array.isArray(t) ? t : [
    t
  ] : [];
}
function fp(t, e) {
  if (typeof t == "function") {
    let n = t(e);
    if (n && typeof n != "boolean") return Ir(n);
  }
  return [];
}
function il(t) {
  return t.length ? {
    isInvalid: !0,
    validationErrors: t,
    validationDetails: da
  } : null;
}
function br(t, e) {
  return t === e ? !0 : !!t && !!e && t.isInvalid === e.isInvalid && t.validationErrors.length === e.validationErrors.length && t.validationErrors.every((n, r) => n === e.validationErrors[r]) && Object.entries(t.validationDetails).every(([n, r]) => e.validationDetails[n] === r);
}
var ca = {};
ca = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var fa = {};
fa = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var va = {};
va = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var ba = {};
ba = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var pa = {};
pa = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var ma = {};
ma = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var ha = {};
ha = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var $a = {};
$a = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var ga = {};
ga = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var ya = {};
ya = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var xa = {};
xa = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Ea = {};
Ea = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Pa = {};
Pa = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Da = {};
Da = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Sa = {};
Sa = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var Ca = {};
Ca = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var wa = {};
wa = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var Ta = {};
Ta = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var ka = {};
ka = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var Ba = {};
Ba = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var Fa = {};
Fa = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var Ka = {};
Ka = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var La = {};
La = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var Ma = {};
Ma = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var Ia = {};
Ia = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var Aa = {};
Aa = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var Na = {};
Na = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var Ra = {};
Ra = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var Oa = {};
Oa = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var Va = {};
Va = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var za = {};
za = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var Ha = {};
Ha = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var _a = {};
_a = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var Ua = {};
Ua = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var ja = {};
ja = {
  "ar-AE": ca,
  "bg-BG": fa,
  "cs-CZ": va,
  "da-DK": ba,
  "de-DE": pa,
  "el-GR": ma,
  "en-US": ha,
  "es-ES": $a,
  "et-EE": ga,
  "fi-FI": ya,
  "fr-FR": xa,
  "he-IL": Ea,
  "hr-HR": Pa,
  "hu-HU": Da,
  "it-IT": Sa,
  "ja-JP": Ca,
  "ko-KR": wa,
  "lt-LT": Ta,
  "lv-LV": ka,
  "nb-NO": Ba,
  "nl-NL": Fa,
  "pl-PL": Ka,
  "pt-BR": La,
  "pt-PT": Ma,
  "ro-RO": Ia,
  "ru-RU": Aa,
  "sk-SK": Na,
  "sl-SI": Ra,
  "sr-SP": Oa,
  "sv-SE": Va,
  "tr-TR": za,
  "uk-UA": Ha,
  "zh-CN": _a,
  "zh-TW": Ua
};
function vp(t) {
  return t && t.__esModule ? t.default : t;
}
function bp(t, e, n) {
  let { type: r = "menu", isDisabled: i, trigger: l = "press" } = t, o = ae(), { triggerProps: a, overlayProps: s } = vo({
    type: r
  }, e, n), u = (v) => {
    if (!i && !(l === "longPress" && !v.altKey) && n && n.current)
      switch (v.key) {
        case "Enter":
        case " ":
          if (l === "longPress" || v.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in v || v.stopPropagation(), v.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in v || v.stopPropagation(), v.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in v && v.continuePropagation();
      }
  }, d = Ge(vp(ja), "@react-aria/menu"), { longPressProps: c } = lo({
    isDisabled: i || l !== "longPress",
    accessibilityDescription: d.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), f = {
    preventFocusOnPress: !0,
    onPressStart(v) {
      v.pointerType !== "touch" && v.pointerType !== "keyboard" && !i && (ve(v.target), e.open(v.pointerType === "virtual" ? "first" : null));
    },
    onPress(v) {
      v.pointerType === "touch" && !i && (ve(v.target), e.toggle());
    }
  };
  return delete a.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...a,
      ...l === "press" ? f : c,
      id: o,
      onKeyDown: u
    },
    menuProps: {
      ...s,
      "aria-labelledby": o,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
const Wa = /* @__PURE__ */ new WeakMap();
function pp(t, e, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: i, onKeyUp: l, ...o } = t;
  !t["aria-label"] && !t["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let a = q(t, {
    labelable: !0
  }), { listProps: s } = oa({
    ...o,
    ref: n,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return Wa.set(e, {
    onClose: t.onClose,
    onAction: t.onAction,
    shouldUseVirtualFocus: t.shouldUseVirtualFocus
  }), {
    menuProps: R(a, {
      onKeyDown: i,
      onKeyUp: l
    }, {
      role: "menu",
      ...s,
      onKeyDown: (u) => {
        var d;
        (u.key !== "Escape" || t.shouldUseVirtualFocus) && ((d = s.onKeyDown) === null || d === void 0 || d.call(s, u));
      }
    })
  };
}
function mp(t, e, n) {
  let { id: r, key: i, closeOnSelect: l, isVirtualized: o, "aria-haspopup": a, onPressStart: s, onPressUp: u, onPress: d, onPressChange: c, onPressEnd: f, onClick: v, onHoverStart: b, onHoverChange: p, onHoverEnd: h, onKeyDown: $, onKeyUp: y, onFocus: P, onFocusChange: S, onBlur: A, selectionManager: w = e.selectionManager } = t, M = !!a, T = M && t["aria-expanded"] === "true";
  var N;
  let I = (N = t.isDisabled) !== null && N !== void 0 ? N : w.isDisabled(i);
  var m;
  let K = (m = t.isSelected) !== null && m !== void 0 ? m : w.isSelected(i), B = Wa.get(e), D = e.collection.getItem(i), F = t.onClose || B.onClose, g = Bt(), E = () => {
    var Z;
    if (!M && (!(D == null || (Z = D.props) === null || Z === void 0) && Z.onAction ? D.props.onAction() : t.onAction && t.onAction(i), B.onAction)) {
      let lt = B.onAction;
      lt(i);
    }
  }, k = "menuitem";
  M || (w.selectionMode === "single" ? k = "menuitemradio" : w.selectionMode === "multiple" && (k = "menuitemcheckbox"));
  let V = ft(), C = ft(), Y = ft(), ne = {
    id: r,
    "aria-disabled": I || void 0,
    role: k,
    "aria-label": t["aria-label"],
    "aria-labelledby": V,
    "aria-describedby": [
      C,
      Y
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": t["aria-controls"],
    "aria-haspopup": a,
    "aria-expanded": t["aria-expanded"]
  };
  w.selectionMode !== "none" && !M && (ne["aria-checked"] = K), o && (ne["aria-posinset"] = D?.index, ne["aria-setsize"] = up(e.collection));
  let G = L(!1), fe = (Z) => {
    c?.(Z), G.current = Z;
  }, se = L(null), me = (Z) => {
    Z.pointerType !== "keyboard" && (se.current = {
      pointerType: Z.pointerType
    }), Z.pointerType === "mouse" && (G.current || Z.target.click()), u?.(Z);
  }, Te = (Z) => {
    var lt, Nt;
    v?.(Z), E(), Il(Z, g, D.props.href, D?.props.routerOptions);
    let yt = ((lt = se.current) === null || lt === void 0 ? void 0 : lt.pointerType) === "keyboard" ? ((Nt = se.current) === null || Nt === void 0 ? void 0 : Nt.key) === "Enter" || w.selectionMode === "none" || w.isLink(i) : w.selectionMode !== "multiple" || w.isLink(i);
    yt = l ?? yt, F && !M && yt && F(), se.current = null;
  }, { itemProps: ye, isFocused: qe } = ia({
    id: r,
    selectionManager: w,
    key: i,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: B.shouldUseVirtualFocus
  }), { pressProps: Re, isPressed: Ye } = nt({
    onPressStart: s,
    onPress: d,
    onPressUp: me,
    onPressChange: fe,
    onPressEnd: f,
    isDisabled: I
  }), { hoverProps: U } = Fe({
    isDisabled: I,
    onHoverStart(Z) {
      !kt() && !(T && a) && (w.setFocused(!0), w.setFocusedKey(i)), b?.(Z);
    },
    onHoverChange: p,
    onHoverEnd: h
  }), { keyboardProps: he } = ro({
    onKeyDown: (Z) => {
      if (Z.repeat) {
        Z.continuePropagation();
        return;
      }
      switch (Z.key) {
        case " ":
          se.current = {
            pointerType: "keyboard",
            key: " "
          }, Z.target.click();
          break;
        case "Enter":
          se.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, Z.target.tagName !== "A" && Z.target.click();
          break;
        default:
          M || Z.continuePropagation(), $?.(Z);
          break;
      }
    },
    onKeyUp: y
  }), { focusProps: ke } = Un({
    onBlur: A,
    onFocus: P,
    onFocusChange: S
  }), it = q(D?.props);
  delete it.id;
  let un = Ml(D?.props);
  return {
    menuItemProps: {
      ...ne,
      ...R(
        it,
        un,
        M ? {
          onFocus: ye.onFocus,
          "data-collection": ye["data-collection"],
          "data-key": ye["data-key"]
        } : ye,
        Re,
        U,
        he,
        ke,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        B.shouldUseVirtualFocus || M ? {
          onMouseDown: (Z) => Z.preventDefault()
        } : void 0,
        I ? void 0 : {
          onClick: Te
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: ye.tabIndex != null && T && !B.shouldUseVirtualFocus ? -1 : ye.tabIndex
    },
    labelProps: {
      id: V
    },
    descriptionProps: {
      id: C
    },
    keyboardShortcutProps: {
      id: Y
    },
    isFocused: qe,
    isFocusVisible: qe && w.isFocused && kt() && !T,
    isSelected: K,
    isPressed: Ye,
    isDisabled: I
  };
}
function hp(t) {
  let { heading: e, "aria-label": n } = t, r = ae();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": e ? r : void 0
    }
  };
}
const $n = 2, $p = 50, gp = 1e3, ll = Math.PI / 12;
function yp(t) {
  let { menuRef: e, submenuRef: n, isOpen: r, isDisabled: i } = t, l = L(void 0), o = L(void 0), a = L(0), s = L(void 0), u = L(void 0), d = L(void 0), c = L(2), [f, v] = W(!1);
  Wt({
    ref: n,
    onResize: () => {
      n.current && (o.current = n.current.getBoundingClientRect(), d.current = void 0);
    }
  });
  let p = () => {
    v(!1), c.current = $n, l.current = void 0;
  }, h = Xr(), $ = te((y) => {
    f && y.preventDefault();
  });
  _(() => {
    f && e.current ? e.current.style.pointerEvents = "none" : e.current.style.pointerEvents = "";
  }, [
    e,
    f
  ]), _(() => {
    let y = n.current, P = e.current;
    if (i || !y || !r || h !== "pointer" || !P) {
      p();
      return;
    }
    o.current = y.getBoundingClientRect();
    let S = (A) => {
      if (A.pointerType === "touch" || A.pointerType === "pen") return;
      let w = Date.now();
      if (w - a.current < $p) return;
      clearTimeout(s.current), clearTimeout(u.current);
      let { clientX: M, clientY: T } = A;
      if (!l.current) {
        l.current = {
          x: M,
          y: T
        };
        return;
      }
      if (!o.current) return;
      if (d.current || (d.current = M > o.current.right ? "left" : "right"), M < P.getBoundingClientRect().left || M > P.getBoundingClientRect().right || T < P.getBoundingClientRect().top || T > P.getBoundingClientRect().bottom) {
        p();
        return;
      }
      let N = l.current.x, I = l.current.y, m = d.current === "right" ? o.current.left - N : N - o.current.right, K = Math.atan2(I - o.current.top, m) + ll, B = Math.atan2(I - o.current.bottom, m) - ll, D = Math.atan2(I - T, d.current === "left" ? -(M - N) : M - N), F = D < K && D > B;
      c.current = F ? Math.min(c.current + 1, $n) : Math.max(c.current - 1, 0), c.current >= $n ? v(!0) : v(!1), a.current = w, l.current = {
        x: M,
        y: T
      }, F && (s.current = setTimeout(() => {
        p(), u.current = setTimeout(() => {
          let g = document.elementFromPoint(M, T);
          g && P.contains(g) && g.dispatchEvent(new PointerEvent("pointerover", {
            bubbles: !0,
            cancelable: !0
          }));
        }, 100);
      }, gp));
    };
    return window.addEventListener("pointermove", S), process.env.NODE_ENV !== "test" && window.addEventListener("pointerdown", $, !0), () => {
      window.removeEventListener("pointermove", S), process.env.NODE_ENV !== "test" && window.removeEventListener("pointerdown", $, !0), clearTimeout(s.current), clearTimeout(u.current), c.current = $n;
    };
  }, [
    i,
    r,
    e,
    h,
    v,
    $,
    n
  ]);
}
function xp(t, e, n) {
  let { parentMenuRef: r, submenuRef: i, type: l = "menu", isDisabled: o, delay: a = 200, shouldUseVirtualFocus: s } = t, u = ae(), d = ae(), { direction: c } = Ae(), f = L(void 0), v = j(() => {
    f.current && (clearTimeout(f.current), f.current = void 0);
  }, [
    f
  ]), b = te((T) => {
    v(), e.open(T);
  }), p = te(() => {
    v(), e.close();
  });
  X(() => () => {
    v();
  }, [
    v
  ]);
  let h = (T) => {
    if (T.currentTarget.contains(document.activeElement))
      switch (T.key) {
        case "ArrowLeft":
          c === "ltr" && T.currentTarget.contains(T.target) && (T.preventDefault(), T.stopPropagation(), p(), !s && n.current && ve(n.current));
          break;
        case "ArrowRight":
          c === "rtl" && T.currentTarget.contains(T.target) && (T.preventDefault(), T.stopPropagation(), p(), !s && n.current && ve(n.current));
          break;
        case "Escape":
          var N;
          !((N = i.current) === null || N === void 0) && N.contains(T.target) && (T.stopPropagation(), p(), !s && n.current && ve(n.current));
          break;
      }
  };
  var $;
  let y = {
    id: d,
    "aria-labelledby": u,
    submenuLevel: e.submenuLevel,
    ...l === "menu" && {
      onClose: e.closeAll,
      autoFocus: ($ = e.focusStrategy) !== null && $ !== void 0 ? $ : void 0,
      onKeyDown: h
    }
  }, P = (T) => {
    switch (T.key) {
      case "ArrowRight":
        o || (c === "ltr" ? (T.preventDefault(), e.isOpen || b("first"), l === "menu" && i?.current && document.activeElement === n?.current && ve(i.current)) : e.isOpen ? p() : T.continuePropagation());
        break;
      case "ArrowLeft":
        o || (c === "rtl" ? (T.preventDefault(), e.isOpen || b("first"), l === "menu" && i?.current && document.activeElement === n?.current && ve(i.current)) : e.isOpen ? p() : T.continuePropagation());
        break;
      default:
        T.continuePropagation();
        break;
    }
  }, S = (T) => {
    !o && (T.pointerType === "virtual" || T.pointerType === "keyboard") && b("first");
  }, A = (T) => {
    !o && (T.pointerType === "touch" || T.pointerType === "mouse") && b();
  }, w = (T) => {
    o || (T && !e.isOpen ? f.current || (f.current = setTimeout(() => {
      b();
    }, a)) : T || v());
  };
  dt(r, "focusin", (T) => {
    var N;
    e.isOpen && (!((N = r.current) === null || N === void 0) && N.contains(T.target)) && T.target !== n.current && p();
  });
  let M = (T) => T !== n.current;
  return yp({
    menuRef: r,
    submenuRef: i,
    isOpen: e.isOpen,
    isDisabled: o
  }), {
    submenuTriggerProps: {
      id: u,
      "aria-controls": e.isOpen ? d : void 0,
      "aria-haspopup": o ? void 0 : l,
      "aria-expanded": e.isOpen ? "true" : "false",
      onPressStart: S,
      onPress: A,
      onHoverChange: w,
      onKeyDown: P,
      isOpen: e.isOpen
    },
    submenuProps: y,
    popoverProps: {
      isNonModal: !0,
      shouldCloseOnInteractOutside: M
    }
  };
}
function Ga(t, e, n) {
  let { validationBehavior: r, focus: i } = t;
  X(() => {
    if (r === "native" && n?.current && !n.current.disabled) {
      let u = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation(Pp(n.current));
    }
  });
  let l = L(!1), o = te(() => {
    l.current || e.resetValidation();
  }), a = te((u) => {
    var d;
    e.displayValidation.isInvalid || e.commitValidation();
    let c = n == null || (d = n.current) === null || d === void 0 ? void 0 : d.form;
    if (!u.defaultPrevented && n && c && Dp(c) === n.current) {
      var f;
      i ? i() : (f = n.current) === null || f === void 0 || f.focus(), $b("keyboard");
    }
    u.preventDefault();
  }), s = te(() => {
    e.commitValidation();
  });
  _(() => {
    let u = n?.current;
    if (!u) return;
    let d = u.form, c = d?.reset;
    return d && (d.reset = () => {
      l.current = !window.event || window.event.type === "message" && window.event.target instanceof MessagePort, c?.call(d), l.current = !1;
    }), u.addEventListener("invalid", a), u.addEventListener("change", s), d?.addEventListener("reset", o), () => {
      u.removeEventListener("invalid", a), u.removeEventListener("change", s), d?.removeEventListener("reset", o), d && (d.reset = c);
    };
  }, [
    n,
    a,
    s,
    o,
    r
  ]);
}
function Ep(t) {
  let e = t.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function Pp(t) {
  return {
    isInvalid: !t.validity.valid,
    validationDetails: Ep(t),
    validationErrors: t.validationMessage ? [
      t.validationMessage
    ] : []
  };
}
function Dp(t) {
  for (let e = 0; e < t.elements.length; e++) {
    let n = t.elements[e];
    if (!n.validity.valid) return n;
  }
  return null;
}
function Jr(t, e) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: i = !1, isReadOnly: l = !1, type: o = "text", validationBehavior: a = "aria" } = t, [s, u] = We(t.value, t.defaultValue || "", t.onChange), { focusableProps: d } = ht(t, e), c = jn({
    ...t,
    value: s
  }), { isInvalid: f, validationErrors: v, validationDetails: b } = c.displayValidation, { labelProps: p, fieldProps: h, descriptionProps: $, errorMessageProps: y } = na({
    ...t,
    isInvalid: f,
    errorMessage: t.errorMessage || v
  }), P = q(t, {
    labelable: !0
  });
  const S = {
    type: o,
    pattern: t.pattern
  };
  let [A] = W(s);
  var w;
  return _r(e, (w = t.defaultValue) !== null && w !== void 0 ? w : A, u), Ga(t, c, e), _(() => {
    if (e.current instanceof ge(e.current).HTMLTextAreaElement) {
      let M = e.current;
      Object.defineProperty(M, "defaultValue", {
        get: () => M.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    e
  ]), {
    labelProps: p,
    inputProps: R(P, n === "input" ? S : void 0, {
      disabled: r,
      readOnly: l,
      required: i && a === "native",
      "aria-required": i && a === "aria" || void 0,
      "aria-invalid": f || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-activedescendant": t["aria-activedescendant"],
      "aria-autocomplete": t["aria-autocomplete"],
      "aria-haspopup": t["aria-haspopup"],
      "aria-controls": t["aria-controls"],
      value: s,
      onChange: (M) => u(M.target.value),
      autoComplete: t.autoComplete,
      autoCapitalize: t.autoCapitalize,
      maxLength: t.maxLength,
      minLength: t.minLength,
      name: t.name,
      form: t.form,
      placeholder: t.placeholder,
      inputMode: t.inputMode,
      autoCorrect: t.autoCorrect,
      spellCheck: t.spellCheck,
      [parseInt(x.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: t.enterKeyHint,
      // Clipboard events
      onCopy: t.onCopy,
      onCut: t.onCut,
      onPaste: t.onPaste,
      // Composition events
      onCompositionEnd: t.onCompositionEnd,
      onCompositionStart: t.onCompositionStart,
      onCompositionUpdate: t.onCompositionUpdate,
      // Selection events
      onSelect: t.onSelect,
      // Input events
      onBeforeInput: t.onBeforeInput,
      onInput: t.onInput,
      ...d,
      ...h
    }),
    descriptionProps: $,
    errorMessageProps: y,
    isInvalid: f,
    validationErrors: v,
    validationDetails: b
  };
}
function ol() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function Sp(t, e, n) {
  let r = te((c) => {
    let f = n.current;
    if (!f) return;
    let v = null;
    switch (c.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        v = f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentForward":
        v = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd + 1) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentBackward":
        v = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart - 1) + f.value.slice(f.selectionStart) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        v = f.value.slice(f.selectionStart);
        break;
      default:
        c.data != null && (v = f.value.slice(0, f.selectionStart) + c.data + f.value.slice(f.selectionEnd));
        break;
    }
    (v == null || !e.validate(v)) && c.preventDefault();
  });
  _(() => {
    if (!ol() || !n.current) return;
    let c = n.current;
    return c.addEventListener("beforeinput", r, !1), () => {
      c.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n,
    r
  ]);
  let i = ol() ? null : (c) => {
    let f = c.target.value.slice(0, c.target.selectionStart) + c.data + c.target.value.slice(c.target.selectionEnd);
    e.validate(f) || c.preventDefault();
  }, { labelProps: l, inputProps: o, descriptionProps: a, errorMessageProps: s, ...u } = Jr(t, n), d = L(null);
  return {
    inputProps: R(o, {
      onBeforeInput: i,
      onCompositionStart() {
        let { value: c, selectionStart: f, selectionEnd: v } = n.current;
        d.current = {
          value: c,
          selectionStart: f,
          selectionEnd: v
        };
      },
      onCompositionEnd() {
        if (n.current && !e.validate(n.current.value)) {
          let { value: c, selectionStart: f, selectionEnd: v } = d.current;
          n.current.value = c, n.current.setSelectionRange(f, v), e.setInputValue(c);
        }
      }
    }),
    labelProps: l,
    descriptionProps: a,
    errorMessageProps: s,
    ...u
  };
}
var qa = {};
qa = {
  "Clear search": "مسح البحث"
};
var Ya = {};
Ya = {
  "Clear search": "Изчистване на търсене"
};
var Xa = {};
Xa = {
  "Clear search": "Vymazat hledání"
};
var Za = {};
Za = {
  "Clear search": "Ryd søgning"
};
var Ja = {};
Ja = {
  "Clear search": "Suche zurücksetzen"
};
var Qa = {};
Qa = {
  "Clear search": "Απαλοιφή αναζήτησης"
};
var es = {};
es = {
  "Clear search": "Clear search"
};
var ts = {};
ts = {
  "Clear search": "Borrar búsqueda"
};
var ns = {};
ns = {
  "Clear search": "Tühjenda otsing"
};
var rs = {};
rs = {
  "Clear search": "Tyhjennä haku"
};
var is = {};
is = {
  "Clear search": "Effacer la recherche"
};
var ls = {};
ls = {
  "Clear search": "נקה חיפוש"
};
var os = {};
os = {
  "Clear search": "Obriši pretragu"
};
var as = {};
as = {
  "Clear search": "Keresés törlése"
};
var ss = {};
ss = {
  "Clear search": "Cancella ricerca"
};
var us = {};
us = {
  "Clear search": "検索をクリア"
};
var ds = {};
ds = {
  "Clear search": "검색 지우기"
};
var cs = {};
cs = {
  "Clear search": "Išvalyti iešką"
};
var fs = {};
fs = {
  "Clear search": "Notīrīt meklēšanu"
};
var vs = {};
vs = {
  "Clear search": "Tøm søk"
};
var bs = {};
bs = {
  "Clear search": "Zoekactie wissen"
};
var ps = {};
ps = {
  "Clear search": "Wyczyść zawartość wyszukiwania"
};
var ms = {};
ms = {
  "Clear search": "Limpar pesquisa"
};
var hs = {};
hs = {
  "Clear search": "Limpar pesquisa"
};
var $s = {};
$s = {
  "Clear search": "Ştergeţi căutarea"
};
var gs = {};
gs = {
  "Clear search": "Очистить поиск"
};
var ys = {};
ys = {
  "Clear search": "Vymazať vyhľadávanie"
};
var xs = {};
xs = {
  "Clear search": "Počisti iskanje"
};
var Es = {};
Es = {
  "Clear search": "Obriši pretragu"
};
var Ps = {};
Ps = {
  "Clear search": "Rensa sökning"
};
var Ds = {};
Ds = {
  "Clear search": "Aramayı temizle"
};
var Ss = {};
Ss = {
  "Clear search": "Очистити пошук"
};
var Cs = {};
Cs = {
  "Clear search": "清除搜索"
};
var ws = {};
ws = {
  "Clear search": "清除搜尋條件"
};
var Ts = {};
Ts = {
  "ar-AE": qa,
  "bg-BG": Ya,
  "cs-CZ": Xa,
  "da-DK": Za,
  "de-DE": Ja,
  "el-GR": Qa,
  "en-US": es,
  "es-ES": ts,
  "et-EE": ns,
  "fi-FI": rs,
  "fr-FR": is,
  "he-IL": ls,
  "hr-HR": os,
  "hu-HU": as,
  "it-IT": ss,
  "ja-JP": us,
  "ko-KR": ds,
  "lt-LT": cs,
  "lv-LV": fs,
  "nb-NO": vs,
  "nl-NL": bs,
  "pl-PL": ps,
  "pt-BR": ms,
  "pt-PT": hs,
  "ro-RO": $s,
  "ru-RU": gs,
  "sk-SK": ys,
  "sl-SI": xs,
  "sr-SP": Es,
  "sv-SE": Ps,
  "tr-TR": Ds,
  "uk-UA": Ss,
  "zh-CN": Cs,
  "zh-TW": ws
};
function Cp(t) {
  return t && t.__esModule ? t.default : t;
}
function wp(t, e, n) {
  let r = Ge(Cp(Ts), "@react-aria/searchfield"), { isDisabled: i, isReadOnly: l, onSubmit: o, onClear: a, type: s = "search" } = t, u = ($) => {
    const y = $.key;
    y === "Enter" && (i || l) && $.preventDefault(), !(i || l) && (y === "Enter" && o && ($.preventDefault(), o(e.value)), y === "Escape" && (e.value === "" && (!n.current || n.current.value === "") ? $.continuePropagation() : ($.preventDefault(), e.setValue(""), a && a())));
  }, d = () => {
    e.setValue(""), a && a();
  }, c = () => {
    var $;
    ($ = n.current) === null || $ === void 0 || $.focus();
  }, { labelProps: f, inputProps: v, descriptionProps: b, errorMessageProps: p, ...h } = Jr({
    ...t,
    value: e.value,
    onChange: e.setValue,
    onKeyDown: l ? t.onKeyDown : Ue(u, t.onKeyDown),
    type: s
  }, n);
  return {
    labelProps: f,
    inputProps: {
      ...v,
      // already handled by useSearchFieldState
      defaultValue: void 0
    },
    clearButtonProps: {
      "aria-label": r.format("Clear search"),
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      isDisabled: i || l,
      onPress: d,
      onPressStart: c
    },
    descriptionProps: b,
    errorMessageProps: p,
    ...h
  };
}
class $t {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new this.constructor(this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e.colSpan = this.colSpan, e.colIndex = this.colIndex, e;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  filter(e, n, r) {
    let i = this.clone();
    return n.addDescendants(i, e), i;
  }
  constructor(e) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = e;
  }
}
class ks extends $t {
  filter(e, n, r) {
    let [i, l] = Ls(e, n, this.firstChildKey, r), o = this.clone();
    return o.firstChildKey = i, o.lastChildKey = l, o;
  }
}
class Bs extends $t {
}
Bs.type = "header";
class Fs extends $t {
}
Fs.type = "loader";
class Qr extends ks {
  filter(e, n, r) {
    if (r(this.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, e), i;
    }
    return null;
  }
}
Qr.type = "item";
class Ks extends ks {
  filter(e, n, r) {
    let i = super.filter(e, n, r);
    if (i && i.lastChildKey !== null) {
      let l = e.getItem(i.lastChildKey);
      if (l && l.type !== "header") return i;
    }
    return null;
  }
}
Ks.type = "section";
class Tp {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(e), i = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      var r;
      return (r = n?.key) !== null && r !== void 0 ? r : null;
    }
    return n.parentKey;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  getItem(e) {
    var n;
    return (n = this.keyMap.get(e)) !== null && n !== void 0 ? n : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, n = new e();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    e.type === "item" && this.keyMap.get(e.key) == null && this.itemCount++, this.keyMap.set(e.key, e);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(e, n) {
    this.addNode(e);
    let r = n.getChildren(e.key);
    for (let i of r) this.addDescendants(i, n);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(e);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(e);
  }
  commit(e, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = n, this.frozen = !r;
  }
  filter(e) {
    let n = new this.constructor(), [r, i] = Ls(this, n, this.firstKey, e);
    return n?.commit(r, i), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function Ls(t, e, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let i = null, l = null, o = t.getItem(n);
  for (; o != null; ) {
    let u = o.filter(t, e, r);
    u != null && (u.nextKey = null, l && (u.prevKey = l.key, l.nextKey = u.key), i == null && (i = u), e.addNode(u), l = u), o = o.nextKey ? t.getItem(o.nextKey) : null;
  }
  if (l && l.type === "separator") {
    let u = l.prevKey;
    e.removeNode(l.key), u ? (l = e.getItem(u), l.nextKey = null) : l = null;
  }
  var a, s;
  return [
    (a = i?.key) !== null && a !== void 0 ? a : null,
    (s = l?.key) !== null && s !== void 0 ? s : null
  ];
}
class Ms {
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var e;
    return ((e = this.parentNode) === null || e === void 0 ? void 0 : e.isConnected) || !1;
  }
  invalidateChildIndices(e) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || e.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = e, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let e = this._minInvalidChildIndex;
    for (; e; )
      e.index = e.previousSibling ? e.previousSibling.index + 1 : 0, e = e.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(e) {
    e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(e, n) {
    if (n == null) return this.appendChild(e);
    e.parentNode && e.parentNode.removeChild(e), e.nextSibling = n, e.previousSibling = n.previousSibling, e.index = n.index - 1, this.firstChild === n ? this.firstChild = e : n.previousSibling && (n.previousSibling.nextSibling = e), n.previousSibling = e, e.parentNode = n.parentNode, this.invalidateChildIndices(e), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    e.parentNode === this && (this._minInvalidChildIndex === e && (this._minInvalidChildIndex = null), e.nextSibling && (this.invalidateChildIndices(e.nextSibling), e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.markDirty(e), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let e = this.previousSibling;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
  get nextVisibleSibling() {
    let e = this.nextSibling;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get firstVisibleChild() {
    let e = this.firstChild;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get lastVisibleChild() {
    let e = this.lastChild;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = e;
  }
}
class Tt extends Ms {
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    var e;
    return this.parentNode instanceof Tt ? this.parentNode.level + (((e = this.node) === null || e === void 0 ? void 0 : e.type) === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    var e, n, r, i, l, o, a, s;
    let u = this.nextVisibleSibling, d = this.getMutableNode();
    if (d != null) {
      d.index = this.index, d.level = this.level;
      var c;
      d.parentKey = this.parentNode instanceof Tt && (c = (e = this.parentNode.node) === null || e === void 0 ? void 0 : e.key) !== null && c !== void 0 ? c : null;
      var f;
      d.prevKey = (f = (r = this.previousVisibleSibling) === null || r === void 0 || (n = r.node) === null || n === void 0 ? void 0 : n.key) !== null && f !== void 0 ? f : null;
      var v;
      d.nextKey = (v = u == null || (i = u.node) === null || i === void 0 ? void 0 : i.key) !== null && v !== void 0 ? v : null, d.hasChildNodes = !!this.firstChild;
      var b;
      d.firstChildKey = (b = (o = this.firstVisibleChild) === null || o === void 0 || (l = o.node) === null || l === void 0 ? void 0 : l.key) !== null && b !== void 0 ? b : null;
      var p;
      if (d.lastChildKey = (p = (s = this.lastVisibleChild) === null || s === void 0 || (a = s.node) === null || a === void 0 ? void 0 : a.key) !== null && p !== void 0 ? p : null, (d.colSpan != null || d.colIndex != null) && u) {
        var h, $;
        let y = ((h = d.colIndex) !== null && h !== void 0 ? h : d.index) + (($ = d.colSpan) !== null && $ !== void 0 ? $ : 1);
        if (u.node != null && y !== u.node.colIndex) {
          let P = u.getMutableNode();
          P.colIndex = y;
        }
      }
    }
  }
  setProps(e, n, r, i, l) {
    let o, { value: a, textValue: s, id: u, ...d } = e;
    if (this.node == null ? (o = new r(u ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = o) : o = this.getMutableNode(), d.ref = n, o.props = d, o.rendered = i, o.render = l, o.value = a, o.textValue = s || (typeof d.children == "string" ? d.children : "") || e["aria-label"] || "", u != null && u !== o.key) throw new Error("Cannot change the id of an item");
    d.colSpan != null && (o.colSpan = d.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let e = this;
    return {
      get display() {
        return e.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (e.isHidden !== r) {
          var i, l;
          (((i = e.parentNode) === null || i === void 0 ? void 0 : i.firstVisibleChild) === e || ((l = e.parentNode) === null || l === void 0 ? void 0 : l.lastVisibleChild) === e) && e.ownerDocument.markDirty(e.parentNode);
          let o = e.previousVisibleSibling, a = e.nextVisibleSibling;
          o && e.ownerDocument.markDirty(o), a && e.ownerDocument.markDirty(a), e.isHidden = r, e.ownerDocument.markDirty(e);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(e, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
}
class kp extends Ms {
  get isConnected() {
    return !0;
  }
  createElement(e) {
    return new Tt(e, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  addNode(e) {
    if (e.isHidden || e.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(e.node.key)) for (let r of e) this.addNode(r);
    n.addNode(e.node);
  }
  removeNode(e) {
    for (let n of e) this.removeNode(n);
    e.node && this.getMutableCollection().removeNode(e.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection.clone() : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let a of this.dirtyNodes) a instanceof Tt && (!a.isConnected || a.isHidden) ? this.removeNode(a) : a.updateChildIndices();
    for (let a of this.dirtyNodes) a instanceof Tt ? (a.isConnected && !a.isHidden && (a.updateNode(), this.addNode(a)), a.node && this.dirtyNodes.delete(a), a.isMutated = !1) : this.dirtyNodes.delete(a);
    if (this.nextCollection) {
      var e, n, r, i, l, o;
      this.nextCollection.commit((l = (n = this.firstVisibleChild) === null || n === void 0 || (e = n.node) === null || e === void 0 ? void 0 : e.key) !== null && l !== void 0 ? l : null, (o = (i = this.lastVisibleChild) === null || i === void 0 || (r = i.node) === null || r === void 0 ? void 0 : r.key) !== null && o !== void 0 ? o : null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null);
    }
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0;
      for (let e of this.subscriptions) e();
      this.inSubscription = !1;
    }
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = e, this.nextCollection = e;
  }
}
function Is(t) {
  let { children: e, items: n, idScope: r, addIdAndValue: i, dependencies: l = [] } = t, o = z(() => /* @__PURE__ */ new WeakMap(), l);
  return z(() => {
    if (n && typeof e == "function") {
      let u = [];
      for (let d of n) {
        let c = o.get(d);
        if (!c) {
          c = e(d);
          var a, s;
          let f = (s = (a = c.props.id) !== null && a !== void 0 ? a : d.key) !== null && s !== void 0 ? s : d.id;
          if (f == null) throw new Error("Could not determine key for item");
          r && (f = r + ":" + f), c = El(c, i ? {
            key: f,
            id: f,
            value: d
          } : {
            key: f
          }), o.set(d, c);
        }
        u.push(c);
      }
      return u;
    } else if (typeof e != "function") return e;
  }, [
    e,
    n,
    o,
    r,
    i
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const t = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : t.call(this);
    }
  });
}
const Mn = /* @__PURE__ */ O(!1);
function Bp(t) {
  if (H(Mn))
    return /* @__PURE__ */ x.createElement(x.Fragment, null, t.children);
  let n = /* @__PURE__ */ x.createElement(Mn.Provider, {
    value: !0
  }, t.children);
  return /* @__PURE__ */ x.createElement("template", {
    "data-react-aria-hidden": !0
  }, n);
}
function on(t) {
  let e = (n, r) => H(Mn) ? null : t(n, r);
  return e.displayName = t.displayName || t.name, ie(e);
}
function Fp() {
  return H(Mn);
}
var gn = { exports: {} }, pr = {};
var al;
function Kp() {
  if (al) return pr;
  al = 1;
  var t = x;
  function e(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, l = t.useLayoutEffect, o = t.useDebugValue;
  function a(c, f) {
    var v = f(), b = r({ inst: { value: v, getSnapshot: f } }), p = b[0].inst, h = b[1];
    return l(
      function() {
        p.value = v, p.getSnapshot = f, s(p) && h({ inst: p });
      },
      [c, v, f]
    ), i(
      function() {
        return s(p) && h({ inst: p }), c(function() {
          s(p) && h({ inst: p });
        });
      },
      [c]
    ), o(v), v;
  }
  function s(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var v = f();
      return !n(c, v);
    } catch {
      return !0;
    }
  }
  function u(c, f) {
    return f();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : a;
  return pr.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, pr;
}
var mr = {};
var sl;
function Lp() {
  return sl || (sl = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(v, b) {
      return v === b && (v !== 0 || 1 / v === 1 / b) || v !== v && b !== b;
    }
    function e(v, b) {
      d || i.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var p = b();
      if (!c) {
        var h = b();
        l(p, h) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      h = o({
        inst: { value: p, getSnapshot: b }
      });
      var $ = h[0].inst, y = h[1];
      return s(
        function() {
          $.value = p, $.getSnapshot = b, n($) && y({ inst: $ });
        },
        [v, p, b]
      ), a(
        function() {
          return n($) && y({ inst: $ }), v(function() {
            n($) && y({ inst: $ });
          });
        },
        [v]
      ), u(p), p;
    }
    function n(v) {
      var b = v.getSnapshot;
      v = v.value;
      try {
        var p = b();
        return !l(v, p);
      } catch {
        return !0;
      }
    }
    function r(v, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = x, l = typeof Object.is == "function" ? Object.is : t, o = i.useState, a = i.useEffect, s = i.useLayoutEffect, u = i.useDebugValue, d = !1, c = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    mr.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), mr;
}
var ul;
function Mp() {
  return ul || (ul = 1, process.env.NODE_ENV === "production" ? gn.exports = Kp() : gn.exports = Lp()), gn.exports;
}
var Ip = Mp();
const As = /* @__PURE__ */ O(!1), Qt = /* @__PURE__ */ O(null);
function ei(t) {
  if (H(Qt))
    return t.content;
  let { collection: n, document: r } = Op(t.createCollection);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Bp, null, /* @__PURE__ */ x.createElement(Qt.Provider, {
    value: r
  }, t.content)), /* @__PURE__ */ x.createElement(Ap, {
    render: t.children,
    collection: n
  }));
}
function Ap({ collection: t, render: e }) {
  return e(t);
}
function Np(t, e, n) {
  let r = Me(), i = L(r);
  i.current = r;
  let l = j(() => i.current ? n() : e(), [
    e,
    n
  ]);
  return Ip.useSyncExternalStore(t, l);
}
const Rp = typeof x.useSyncExternalStore == "function" ? x.useSyncExternalStore : Np;
function Op(t) {
  let [e] = W(() => new kp(t?.() || new Tp())), n = j((o) => e.subscribe(o), [
    e
  ]), r = j(() => {
    let o = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), o;
  }, [
    e
  ]), i = j(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]);
  return {
    collection: Rp(n, r, i),
    document: e
  };
}
const Ar = /* @__PURE__ */ O(null);
function Vp(t) {
  var e;
  return e = class extends $t {
  }, e.type = t, e;
}
function Ns(t, e, n, r, i, l) {
  typeof t == "string" && (t = Vp(t));
  let o = j((s) => {
    s?.setProps(e, n, t, r, l);
  }, [
    e,
    n,
    r,
    l,
    t
  ]), a = H(Ar);
  if (a) {
    let s = a.ownerDocument.nodesByProps.get(e);
    return s || (s = a.ownerDocument.createElement(t.type), s.setProps(e, n, t, r, l), a.appendChild(s), a.ownerDocument.updateCollection(), a.ownerDocument.nodesByProps.set(e, s)), i ? /* @__PURE__ */ x.createElement(Ar.Provider, {
      value: s
    }, i) : null;
  }
  return /* @__PURE__ */ x.createElement(t.type, {
    ref: o
  }, i);
}
function Kt(t, e) {
  let n = ({ node: i }) => e(i.props, i.props.ref, i), r = ie((i, l) => {
    let o = H(Fn);
    if (!H(As)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(i, l);
    }
    return Ns(t, i, l, "children" in i ? i.children : null, null, (s) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ x.createElement(Fn.Provider, {
        value: o
      }, /* @__PURE__ */ x.createElement(n, {
        node: s
      }))
    ));
  });
  return r.displayName = e.name, r;
}
function Rs(t, e, n = Os) {
  let r = ({ node: l }) => e(l.props, l.props.ref, l), i = ie((l, o) => {
    let a = n(l);
    var s;
    return (s = Ns(t, l, o, null, a, (u) => /* @__PURE__ */ x.createElement(r, {
      node: u
    }))) !== null && s !== void 0 ? s : /* @__PURE__ */ x.createElement(x.Fragment, null);
  });
  return i.displayName = e.name, i;
}
function Os(t) {
  return Is({
    ...t,
    addIdAndValue: !0
  });
}
const dl = /* @__PURE__ */ O(null);
function ti(t) {
  let e = H(dl), n = (e?.dependencies || []).concat(t.dependencies), r = t.idScope || e?.idScope, i = Os({
    ...t,
    idScope: r,
    dependencies: n
  });
  return H(Qt) && (i = /* @__PURE__ */ x.createElement(zp, null, i)), e = z(() => ({
    dependencies: n,
    idScope: r
  }), [
    r,
    ...n
  ]), /* @__PURE__ */ x.createElement(dl.Provider, {
    value: e
  }, i);
}
function zp({ children: t }) {
  let e = H(Qt), n = z(() => /* @__PURE__ */ x.createElement(Qt.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(As.Provider, {
    value: !0
  }, t)), [
    t
  ]);
  return Me() ? /* @__PURE__ */ x.createElement(Ar.Provider, {
    value: e
  }, n) : /* @__PURE__ */ Bf(n, e);
}
const Hp = /* @__PURE__ */ O(null), Vs = {
  CollectionRoot({ collection: t, renderDropIndicator: e }) {
    return cl(t, null, e);
  },
  CollectionBranch({ collection: t, parent: e, renderDropIndicator: n }) {
    return cl(t, e, n);
  }
};
function cl(t, e, n) {
  return Is({
    items: e ? t.getChildren(e.key) : t,
    dependencies: [
      n
    ],
    children(r) {
      let i = r.render(r);
      return !n || r.type !== "item" ? i : /* @__PURE__ */ x.createElement(x.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), i, _p(t, r, n));
    }
  });
}
function _p(t, e, n) {
  let r = e.key, i = t.getKeyAfter(r), l = i != null ? t.getItem(i) : null;
  for (; l != null && l.type !== "item"; )
    i = t.getKeyAfter(l.key), l = i != null ? t.getItem(i) : null;
  let o = e.nextKey != null ? t.getItem(e.nextKey) : null;
  for (; o != null && o.type !== "item"; ) o = o.nextKey != null ? t.getItem(o.nextKey) : null;
  let a = [];
  if (o == null) {
    let s = e;
    for (; s && (!l || s.parentKey !== l.parentKey && l.level < s.level); ) {
      let u = n({
        type: "item",
        key: s.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ kf(u) && a.push(/* @__PURE__ */ El(u, {
        key: `${s.key}-after`
      })), s = s.parentKey != null ? t.getItem(s.parentKey) : null;
    }
  }
  return a;
}
const Lt = /* @__PURE__ */ O(Vs);
function zs(t) {
  return z(() => t != null ? /* @__PURE__ */ new Set([
    t
  ]) : null, [
    t
  ]);
}
function Up(t, e) {
  let { elementType: n = "a", onPress: r, onPressStart: i, onPressEnd: l, onClick: o, isDisabled: a, ...s } = t, u = {};
  n !== "a" && (u = {
    role: "link",
    tabIndex: a ? void 0 : 0
  });
  let { focusableProps: d } = ht(t, e), { pressProps: c, isPressed: f } = nt({
    onPress: r,
    onPressStart: i,
    onPressEnd: l,
    onClick: o,
    isDisabled: a,
    ref: e
  }), v = q(s, {
    labelable: !0
  }), b = R(d, c), p = Bt(), h = Ml(t);
  return {
    isPressed: f,
    linkProps: R(v, h, {
      ...b,
      ...u,
      "aria-disabled": a || void 0,
      "aria-current": t["aria-current"],
      onClick: ($) => {
        var y;
        (y = c.onClick) === null || y === void 0 || y.call(c, $), Il($, p, t.href, t.routerOptions);
      }
    })
  };
}
var Hs = {};
Hs = {
  breadcrumbs: "عناصر الواجهة"
};
var _s = {};
_s = {
  breadcrumbs: "Трохи хляб"
};
var Us = {};
Us = {
  breadcrumbs: "Popis cesty"
};
var js = {};
js = {
  breadcrumbs: "Brødkrummer"
};
var Ws = {};
Ws = {
  breadcrumbs: "Breadcrumbs"
};
var Gs = {};
Gs = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var qs = {};
qs = {
  breadcrumbs: "Breadcrumbs"
};
var Ys = {};
Ys = {
  breadcrumbs: "Migas de pan"
};
var Xs = {};
Xs = {
  breadcrumbs: "Lingiread"
};
var Zs = {};
Zs = {
  breadcrumbs: "Navigointilinkit"
};
var Js = {};
Js = {
  breadcrumbs: "Chemin de navigation"
};
var Qs = {};
Qs = {
  breadcrumbs: "שבילי ניווט"
};
var eu = {};
eu = {
  breadcrumbs: "Navigacijski putovi"
};
var tu = {};
tu = {
  breadcrumbs: "Morzsamenü"
};
var nu = {};
nu = {
  breadcrumbs: "Breadcrumb"
};
var ru = {};
ru = {
  breadcrumbs: "パンくずリスト"
};
var iu = {};
iu = {
  breadcrumbs: "탐색 표시"
};
var lu = {};
lu = {
  breadcrumbs: "Naršymo kelias"
};
var ou = {};
ou = {
  breadcrumbs: "Atpakaļceļi"
};
var au = {};
au = {
  breadcrumbs: "Navigasjonsstier"
};
var su = {};
su = {
  breadcrumbs: "Broodkruimels"
};
var uu = {};
uu = {
  breadcrumbs: "Struktura nawigacyjna"
};
var du = {};
du = {
  breadcrumbs: "Caminho detalhado"
};
var cu = {};
cu = {
  breadcrumbs: "Categorias"
};
var fu = {};
fu = {
  breadcrumbs: "Miez de pâine"
};
var vu = {};
vu = {
  breadcrumbs: "Навигация"
};
var bu = {};
bu = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var pu = {};
pu = {
  breadcrumbs: "Drobtine"
};
var mu = {};
mu = {
  breadcrumbs: "Putanje navigacije"
};
var hu = {};
hu = {
  breadcrumbs: "Sökvägar"
};
var $u = {};
$u = {
  breadcrumbs: "İçerik haritaları"
};
var gu = {};
gu = {
  breadcrumbs: "Навігаційна стежка"
};
var yu = {};
yu = {
  breadcrumbs: "导航栏"
};
var xu = {};
xu = {
  breadcrumbs: "導覽列"
};
var Eu = {};
Eu = {
  "ar-AE": Hs,
  "bg-BG": _s,
  "cs-CZ": Us,
  "da-DK": js,
  "de-DE": Ws,
  "el-GR": Gs,
  "en-US": qs,
  "es-ES": Ys,
  "et-EE": Xs,
  "fi-FI": Zs,
  "fr-FR": Js,
  "he-IL": Qs,
  "hr-HR": eu,
  "hu-HU": tu,
  "it-IT": nu,
  "ja-JP": ru,
  "ko-KR": iu,
  "lt-LT": lu,
  "lv-LV": ou,
  "nb-NO": au,
  "nl-NL": su,
  "pl-PL": uu,
  "pt-BR": du,
  "pt-PT": cu,
  "ro-RO": fu,
  "ru-RU": vu,
  "sk-SK": bu,
  "sl-SI": pu,
  "sr-SP": mu,
  "sv-SE": hu,
  "tr-TR": $u,
  "uk-UA": gu,
  "zh-CN": yu,
  "zh-TW": xu
};
function jp(t) {
  return t && t.__esModule ? t.default : t;
}
function Wp(t) {
  let { "aria-label": e, ...n } = t, r = Ge(jp(Eu), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...q(n, {
        labelable: !0
      }),
      "aria-label": e || r.format("breadcrumbs")
    }
  };
}
function Pu(t, e) {
  let { elementType: n = "button", isDisabled: r, onPress: i, onPressStart: l, onPressEnd: o, onPressUp: a, onPressChange: s, preventFocusOnPress: u, allowFocusWhenDisabled: d, onClick: c, href: f, target: v, rel: b, type: p = "button" } = t, h;
  n === "button" ? h = {
    type: p,
    disabled: r,
    form: t.form,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formMethod: t.formMethod,
    formNoValidate: t.formNoValidate,
    formTarget: t.formTarget,
    name: t.name,
    value: t.value
  } : h = {
    role: "button",
    href: n === "a" && !r ? f : void 0,
    target: n === "a" ? v : void 0,
    type: n === "input" ? p : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? b : void 0
  };
  let { pressProps: $, isPressed: y } = nt({
    onPressStart: l,
    onPressEnd: o,
    onPressChange: s,
    onPress: i,
    onPressUp: a,
    onClick: c,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: e
  }), { focusableProps: P } = ht(t, e);
  d && (P.tabIndex = r ? -1 : P.tabIndex);
  let S = R(P, $, q(t, {
    labelable: !0
  }));
  return {
    isPressed: y,
    buttonProps: R(h, S, {
      "aria-haspopup": t["aria-haspopup"],
      "aria-expanded": t["aria-expanded"],
      "aria-controls": t["aria-controls"],
      "aria-pressed": t["aria-pressed"],
      "aria-current": t["aria-current"],
      "aria-disabled": t["aria-disabled"]
    })
  };
}
function Du(t, e, n) {
  const { isSelected: r } = e, { isPressed: i, buttonProps: l } = Pu({
    ...t,
    onPress: Ue(e.toggle, t.onPress)
  }, n);
  return {
    isPressed: i,
    isSelected: r,
    isDisabled: t.isDisabled || !1,
    buttonProps: R(l, {
      "aria-pressed": r
    })
  };
}
function Gp(t, e, n) {
  let r = {
    isSelected: e.selectedKeys.has(t.id),
    defaultSelected: !1,
    setSelected(s) {
      e.setSelected(t.id, s);
    },
    toggle() {
      e.toggleKey(t.id);
    }
  }, { isPressed: i, isSelected: l, isDisabled: o, buttonProps: a } = Du({
    ...t,
    id: void 0,
    isDisabled: t.isDisabled || e.isDisabled
  }, r, n);
  return e.selectionMode === "single" && (a.role = "radio", a["aria-checked"] = r.isSelected, delete a["aria-pressed"]), {
    isPressed: i,
    isSelected: l,
    isDisabled: o,
    buttonProps: a
  };
}
function qp(t, e, n) {
  let { isDisabled: r = !1, isReadOnly: i = !1, value: l, name: o, form: a, children: s, "aria-label": u, "aria-labelledby": d, validationState: c = "valid", isInvalid: f, onPressStart: v, onPressEnd: b, onPressChange: p, onPress: h, onPressUp: $, onClick: y } = t, P = (B) => {
    B.stopPropagation(), e.setSelected(B.target.checked);
  }, S = s != null, A = u != null || d != null;
  !S && !A && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: w, isPressed: M } = nt({
    onPressStart: v,
    onPressEnd: b,
    onPressChange: p,
    onPress: h,
    onPressUp: $,
    onClick: y,
    isDisabled: r
  }), { pressProps: T, isPressed: N } = nt({
    onPressStart: v,
    onPressEnd: b,
    onPressChange: p,
    onPressUp: $,
    onClick: y,
    onPress(B) {
      var D;
      h?.(B), e.toggle(), (D = n.current) === null || D === void 0 || D.focus();
    },
    isDisabled: r || i
  }), { focusableProps: I } = ht(t, n), m = R(w, I), K = q(t, {
    labelable: !0
  });
  return _r(n, e.defaultSelected, e.setSelected), {
    labelProps: R(T, {
      onClick: (B) => B.preventDefault()
    }),
    inputProps: R(K, {
      "aria-invalid": f || c === "invalid" || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-controls": t["aria-controls"],
      "aria-readonly": i || void 0,
      onChange: P,
      disabled: r,
      ...l == null ? {} : {
        value: l
      },
      name: o,
      form: a,
      type: "checkbox",
      ...m
    }),
    isSelected: e.isSelected,
    isPressed: M || N,
    isDisabled: r,
    isReadOnly: i,
    isInvalid: f || c === "invalid"
  };
}
function Su(t, e, n) {
  let r = jn({
    ...t,
    value: e.isSelected
  }), { isInvalid: i, validationErrors: l, validationDetails: o } = r.displayValidation, { labelProps: a, inputProps: s, isSelected: u, isPressed: d, isDisabled: c, isReadOnly: f } = qp({
    ...t,
    isInvalid: i
  }, e, n);
  Ga(t, r, n);
  let { isIndeterminate: v, isRequired: b, validationBehavior: p = "aria" } = t;
  _(() => {
    n.current && (n.current.indeterminate = !!v);
  });
  let { pressProps: h } = nt({
    isDisabled: c || f,
    onPress() {
      let { [Jt]: $ } = t, { commitValidation: y } = $ || r;
      y();
    }
  });
  return {
    labelProps: R(a, h, z(() => ({
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: ($) => $.preventDefault()
    }), [])),
    inputProps: {
      ...s,
      checked: u,
      "aria-required": b && p === "aria" || void 0,
      required: b && p === "native"
    },
    isSelected: u,
    isPressed: d,
    isDisabled: c,
    isReadOnly: f,
    isInvalid: i,
    validationErrors: l,
    validationDetails: o
  };
}
const Yp = /* @__PURE__ */ new WeakMap();
function ni(t = {}) {
  let { isReadOnly: e } = t, [n, r] = We(t.isSelected, t.defaultSelected || !1, t.onChange), [i] = W(n);
  function l(s) {
    e || r(s);
  }
  function o() {
    e || r(!n);
  }
  var a;
  return {
    isSelected: n,
    defaultSelected: (a = t.defaultSelected) !== null && a !== void 0 ? a : i,
    setSelected: l,
    toggle: o
  };
}
function Xp(t, e, n) {
  const r = ni({
    isReadOnly: t.isReadOnly || e.isReadOnly,
    isSelected: e.isSelected(t.value),
    defaultSelected: e.defaultValue.includes(t.value),
    onChange($) {
      $ ? e.addValue(t.value) : e.removeValue(t.value), t.onChange && t.onChange($);
    }
  });
  let { name: i, form: l, descriptionId: o, errorMessageId: a, validationBehavior: s } = Yp.get(e);
  var u;
  s = (u = t.validationBehavior) !== null && u !== void 0 ? u : s;
  let { realtimeValidation: d } = jn({
    ...t,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), c = L(Dt), f = () => {
    e.setInvalid(t.value, d.isInvalid ? d : c.current);
  };
  _(f);
  let v = e.realtimeValidation.isInvalid ? e.realtimeValidation : d, b = s === "native" ? e.displayValidation : v;
  var p;
  let h = Su({
    ...t,
    isReadOnly: t.isReadOnly || e.isReadOnly,
    isDisabled: t.isDisabled || e.isDisabled,
    name: t.name || i,
    form: t.form || l,
    isRequired: (p = t.isRequired) !== null && p !== void 0 ? p : e.isRequired,
    validationBehavior: s,
    [Jt]: {
      realtimeValidation: v,
      displayValidation: b,
      resetValidation: e.resetValidation,
      commitValidation: e.commitValidation,
      updateValidation($) {
        c.current = $, f();
      }
    }
  }, r, n);
  return {
    ...h,
    inputProps: {
      ...h.inputProps,
      "aria-describedby": [
        t["aria-describedby"],
        e.isInvalid ? a : null,
        o
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
function Zp(t) {
  let { minValue: e, maxValue: n, step: r, formatOptions: i, value: l, defaultValue: o = NaN, onChange: a, locale: s, isDisabled: u, isReadOnly: d } = t;
  l === null && (l = NaN), l !== void 0 && !isNaN(l) && (r !== void 0 && !isNaN(r) ? l = Oe(l, e, n, r) : l = et(l, e, n)), isNaN(o) || (r !== void 0 && !isNaN(r) ? o = Oe(o, e, n, r) : o = et(o, e, n));
  let [c, f] = We(l, isNaN(o) ? NaN : o, a), [v] = W(c), [b, p] = W(() => isNaN(c) ? "" : new wn(s, i).format(c)), h = z(() => new Wl(s, i), [
    s,
    i
  ]), $ = z(() => h.getNumberingSystem(b), [
    h,
    b
  ]), y = z(() => new wn(s, {
    ...i,
    numberingSystem: $
  }), [
    s,
    i,
    $
  ]), P = z(() => y.resolvedOptions(), [
    y
  ]), S = j((G) => isNaN(G) || G === null ? "" : y.format(G), [
    y
  ]), A = jn({
    ...t,
    value: c
  }), w = r !== void 0 && !isNaN(r) ? r : 1;
  P.style === "percent" && (r === void 0 || isNaN(r)) && (w = 0.01);
  let [M, T] = W(c), [N, I] = W(s), [m, K] = W(i);
  (!Object.is(c, M) || s !== N || i !== m) && (p(S(c)), T(c), I(s), K(i));
  let B = z(() => h.parse(b), [
    h,
    b
  ]), D = () => {
    if (!b.length) {
      f(NaN), p(l === void 0 ? "" : S(c));
      return;
    }
    if (isNaN(B)) {
      p(S(c));
      return;
    }
    let G;
    r === void 0 || isNaN(r) ? G = et(B, e, n) : G = Oe(B, e, n, r), G = h.parse(S(G)), f(G), p(S(l === void 0 ? G : c)), A.commitValidation();
  }, F = (G, fe = 0) => {
    let se = B;
    if (isNaN(se)) {
      let me = isNaN(fe) ? 0 : fe;
      return Oe(me, e, n, w);
    } else {
      let me = Oe(se, e, n, w);
      return G === "+" && me > se || G === "-" && me < se ? me : Oe(hr(G, se, w), e, n, w);
    }
  }, g = () => {
    let G = F("+", e);
    G === c && p(S(G)), f(G), A.commitValidation();
  }, E = () => {
    let G = F("-", n);
    G === c && p(S(G)), f(G), A.commitValidation();
  }, k = () => {
    n != null && (f(Oe(n, e, n, w)), A.commitValidation());
  }, V = () => {
    e != null && (f(e), A.commitValidation());
  }, C = z(() => !u && !d && (isNaN(B) || n === void 0 || isNaN(n) || Oe(B, e, n, w) > B || hr("+", B, w) <= n), [
    u,
    d,
    e,
    n,
    w,
    B
  ]), Y = z(() => !u && !d && (isNaN(B) || e === void 0 || isNaN(e) || Oe(B, e, n, w) < B || hr("-", B, w) >= e), [
    u,
    d,
    e,
    n,
    w,
    B
  ]);
  return {
    ...A,
    validate: (G) => h.isValidPartialNumber(G, e, n),
    increment: g,
    incrementToMax: k,
    decrement: E,
    decrementToMin: V,
    canIncrement: C,
    canDecrement: Y,
    minValue: e,
    maxValue: n,
    numberValue: B,
    defaultNumberValue: isNaN(o) ? v : o,
    setNumberValue: f,
    setInputValue: p,
    inputValue: b,
    commit: D
  };
}
function hr(t, e, n) {
  let r = t === "+" ? e + n : e - n;
  if (e % 1 !== 0 || n % 1 !== 0) {
    const i = e.toString().split("."), l = n.toString().split("."), o = i[1] && i[1].length || 0, a = l[1] && l[1].length || 0, s = Math.pow(10, Math.max(o, a));
    e = Math.round(e * s), n = Math.round(n * s), r = t === "+" ? e + n : e - n, r /= s;
  }
  return r;
}
var Cu = {};
Cu = {
  Empty: "فارغ"
};
var wu = {};
wu = {
  Empty: "Изпразни"
};
var Tu = {};
Tu = {
  Empty: "Prázdné"
};
var ku = {};
ku = {
  Empty: "Tom"
};
var Bu = {};
Bu = {
  Empty: "Leer"
};
var Fu = {};
Fu = {
  Empty: "Άδειο"
};
var Ku = {};
Ku = {
  Empty: "Empty"
};
var Lu = {};
Lu = {
  Empty: "Vacío"
};
var Mu = {};
Mu = {
  Empty: "Tühjenda"
};
var Iu = {};
Iu = {
  Empty: "Tyhjä"
};
var Au = {};
Au = {
  Empty: "Vide"
};
var Nu = {};
Nu = {
  Empty: "ריק"
};
var Ru = {};
Ru = {
  Empty: "Prazno"
};
var Ou = {};
Ou = {
  Empty: "Üres"
};
var Vu = {};
Vu = {
  Empty: "Vuoto"
};
var zu = {};
zu = {
  Empty: "空"
};
var Hu = {};
Hu = {
  Empty: "비어 있음"
};
var _u = {};
_u = {
  Empty: "Tuščias"
};
var Uu = {};
Uu = {
  Empty: "Tukšs"
};
var ju = {};
ju = {
  Empty: "Tom"
};
var Wu = {};
Wu = {
  Empty: "Leeg"
};
var Gu = {};
Gu = {
  Empty: "Pusty"
};
var qu = {};
qu = {
  Empty: "Vazio"
};
var Yu = {};
Yu = {
  Empty: "Vazio"
};
var Xu = {};
Xu = {
  Empty: "Gol"
};
var Zu = {};
Zu = {
  Empty: "Не заполнено"
};
var Ju = {};
Ju = {
  Empty: "Prázdne"
};
var Qu = {};
Qu = {
  Empty: "Prazen"
};
var ed = {};
ed = {
  Empty: "Prazno"
};
var td = {};
td = {
  Empty: "Tomt"
};
var nd = {};
nd = {
  Empty: "Boş"
};
var rd = {};
rd = {
  Empty: "Пусто"
};
var id = {};
id = {
  Empty: "空"
};
var ld = {};
ld = {
  Empty: "空白"
};
var od = {};
od = {
  "ar-AE": Cu,
  "bg-BG": wu,
  "cs-CZ": Tu,
  "da-DK": ku,
  "de-DE": Bu,
  "el-GR": Fu,
  "en-US": Ku,
  "es-ES": Lu,
  "et-EE": Mu,
  "fi-FI": Iu,
  "fr-FR": Au,
  "he-IL": Nu,
  "hr-HR": Ru,
  "hu-HU": Ou,
  "it-IT": Vu,
  "ja-JP": zu,
  "ko-KR": Hu,
  "lt-LT": _u,
  "lv-LV": Uu,
  "nb-NO": ju,
  "nl-NL": Wu,
  "pl-PL": Gu,
  "pt-BR": qu,
  "pt-PT": Yu,
  "ro-RO": Xu,
  "ru-RU": Zu,
  "sk-SK": Ju,
  "sl-SI": Qu,
  "sr-SP": ed,
  "sv-SE": td,
  "tr-TR": nd,
  "uk-UA": rd,
  "zh-CN": id,
  "zh-TW": ld
};
function Jp(t) {
  return t && t.__esModule ? t.default : t;
}
function Qp(t) {
  const e = L(void 0);
  let { value: n, textValue: r, minValue: i, maxValue: l, isDisabled: o, isReadOnly: a, isRequired: s, onIncrement: u, onIncrementPage: d, onDecrement: c, onDecrementPage: f, onDecrementToMin: v, onIncrementToMax: b } = t;
  const p = Ge(Jp(od), "@react-aria/spinbutton"), h = () => clearTimeout(e.current);
  _(() => () => h(), []);
  let $ = (m) => {
    if (!(m.ctrlKey || m.metaKey || m.shiftKey || m.altKey || a || m.nativeEvent.isComposing))
      switch (m.key) {
        case "PageUp":
          if (d) {
            m.preventDefault(), d?.();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          u && (m.preventDefault(), u?.());
          break;
        case "PageDown":
          if (f) {
            m.preventDefault(), f?.();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          c && (m.preventDefault(), c?.());
          break;
        case "Home":
          v && (m.preventDefault(), v?.());
          break;
        case "End":
          b && (m.preventDefault(), b?.());
          break;
      }
  }, y = L(!1), P = () => {
    y.current = !0;
  }, S = () => {
    y.current = !1;
  }, A = r === "" ? p.format("Empty") : (r || `${n}`).replace("-", "−");
  _(() => {
    y.current && (Cv("assertive"), Dn(A, "assertive"));
  }, [
    A
  ]);
  const w = te((m) => {
    h(), u?.(), e.current = window.setTimeout(() => {
      (l === void 0 || isNaN(l) || n === void 0 || isNaN(n) || n < l) && w(60);
    }, m);
  }), M = te((m) => {
    h(), c?.(), e.current = window.setTimeout(() => {
      (i === void 0 || isNaN(i) || n === void 0 || isNaN(n) || n > i) && M(60);
    }, m);
  });
  let T = (m) => {
    m.preventDefault();
  }, { addGlobalListener: N, removeAllGlobalListeners: I } = rn();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": A,
      "aria-valuemin": i,
      "aria-valuemax": l,
      "aria-disabled": o || void 0,
      "aria-readonly": a || void 0,
      "aria-required": s || void 0,
      onKeyDown: $,
      onFocus: P,
      onBlur: S
    },
    incrementButtonProps: {
      onPressStart: () => {
        w(400), N(window, "contextmenu", T);
      },
      onPressEnd: () => {
        h(), I();
      },
      onFocus: P,
      onBlur: S
    },
    decrementButtonProps: {
      onPressStart: () => {
        M(400), N(window, "contextmenu", T);
      },
      onPressEnd: () => {
        h(), I();
      },
      onFocus: P,
      onBlur: S
    }
  };
}
var ad = {};
ad = {
  decrease: (t) => `خفض ${t.fieldLabel}`,
  increase: (t) => `زيادة ${t.fieldLabel}`,
  numberField: "حقل رقمي"
};
var sd = {};
sd = {
  decrease: (t) => `Намаляване ${t.fieldLabel}`,
  increase: (t) => `Усилване ${t.fieldLabel}`,
  numberField: "Номер на полето"
};
var ud = {};
ud = {
  decrease: (t) => `Snížit ${t.fieldLabel}`,
  increase: (t) => `Zvýšit ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var dd = {};
dd = {
  decrease: (t) => `Reducer ${t.fieldLabel}`,
  increase: (t) => `Øg ${t.fieldLabel}`,
  numberField: "Talfelt"
};
var cd = {};
cd = {
  decrease: (t) => `${t.fieldLabel} verringern`,
  increase: (t) => `${t.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var fd = {};
fd = {
  decrease: (t) => `Μείωση ${t.fieldLabel}`,
  increase: (t) => `Αύξηση ${t.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var vd = {};
vd = {
  decrease: (t) => `Decrease ${t.fieldLabel}`,
  increase: (t) => `Increase ${t.fieldLabel}`,
  numberField: "Number field"
};
var bd = {};
bd = {
  decrease: (t) => `Reducir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var pd = {};
pd = {
  decrease: (t) => `Vähenda ${t.fieldLabel}`,
  increase: (t) => `Suurenda ${t.fieldLabel}`,
  numberField: "Numbri väli"
};
var md = {};
md = {
  decrease: (t) => `Vähennä ${t.fieldLabel}`,
  increase: (t) => `Lisää ${t.fieldLabel}`,
  numberField: "Numerokenttä"
};
var hd = {};
hd = {
  decrease: (t) => `Diminuer ${t.fieldLabel}`,
  increase: (t) => `Augmenter ${t.fieldLabel}`,
  numberField: "Champ de nombre"
};
var $d = {};
$d = {
  decrease: (t) => `הקטן ${t.fieldLabel}`,
  increase: (t) => `הגדל ${t.fieldLabel}`,
  numberField: "שדה מספר"
};
var gd = {};
gd = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var yd = {};
yd = {
  decrease: (t) => `${t.fieldLabel} csökkentése`,
  increase: (t) => `${t.fieldLabel} növelése`,
  numberField: "Számmező"
};
var xd = {};
xd = {
  decrease: (t) => `Riduci ${t.fieldLabel}`,
  increase: (t) => `Aumenta ${t.fieldLabel}`,
  numberField: "Campo numero"
};
var Ed = {};
Ed = {
  decrease: (t) => `${t.fieldLabel}を縮小`,
  increase: (t) => `${t.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var Pd = {};
Pd = {
  decrease: (t) => `${t.fieldLabel} 감소`,
  increase: (t) => `${t.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Dd = {};
Dd = {
  decrease: (t) => `Sumažinti ${t.fieldLabel}`,
  increase: (t) => `Padidinti ${t.fieldLabel}`,
  numberField: "Numerio laukas"
};
var Sd = {};
Sd = {
  decrease: (t) => `Samazināšana ${t.fieldLabel}`,
  increase: (t) => `Palielināšana ${t.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var Cd = {};
Cd = {
  decrease: (t) => `Reduser ${t.fieldLabel}`,
  increase: (t) => `Øk ${t.fieldLabel}`,
  numberField: "Tallfelt"
};
var wd = {};
wd = {
  decrease: (t) => `${t.fieldLabel} verlagen`,
  increase: (t) => `${t.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Td = {};
Td = {
  decrease: (t) => `Zmniejsz ${t.fieldLabel}`,
  increase: (t) => `Zwiększ ${t.fieldLabel}`,
  numberField: "Pole numeru"
};
var kd = {};
kd = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var Bd = {};
Bd = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo numérico"
};
var Fd = {};
Fd = {
  decrease: (t) => `Scădere ${t.fieldLabel}`,
  increase: (t) => `Creștere ${t.fieldLabel}`,
  numberField: "Câmp numeric"
};
var Kd = {};
Kd = {
  decrease: (t) => `Уменьшение ${t.fieldLabel}`,
  increase: (t) => `Увеличение ${t.fieldLabel}`,
  numberField: "Числовое поле"
};
var Ld = {};
Ld = {
  decrease: (t) => `Znížiť ${t.fieldLabel}`,
  increase: (t) => `Zvýšiť ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var Md = {};
Md = {
  decrease: (t) => `Upadati ${t.fieldLabel}`,
  increase: (t) => `Povečajte ${t.fieldLabel}`,
  numberField: "Številčno polje"
};
var Id = {};
Id = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var Ad = {};
Ad = {
  decrease: (t) => `Minska ${t.fieldLabel}`,
  increase: (t) => `Öka ${t.fieldLabel}`,
  numberField: "Nummerfält"
};
var Nd = {};
Nd = {
  decrease: (t) => `${t.fieldLabel} azalt`,
  increase: (t) => `${t.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var Rd = {};
Rd = {
  decrease: (t) => `Зменшити ${t.fieldLabel}`,
  increase: (t) => `Збільшити ${t.fieldLabel}`,
  numberField: "Поле номера"
};
var Od = {};
Od = {
  decrease: (t) => `降低 ${t.fieldLabel}`,
  increase: (t) => `提高 ${t.fieldLabel}`,
  numberField: "数字字段"
};
var Vd = {};
Vd = {
  decrease: (t) => `縮小 ${t.fieldLabel}`,
  increase: (t) => `放大 ${t.fieldLabel}`,
  numberField: "數字欄位"
};
var zd = {};
zd = {
  "ar-AE": ad,
  "bg-BG": sd,
  "cs-CZ": ud,
  "da-DK": dd,
  "de-DE": cd,
  "el-GR": fd,
  "en-US": vd,
  "es-ES": bd,
  "et-EE": pd,
  "fi-FI": md,
  "fr-FR": hd,
  "he-IL": $d,
  "hr-HR": gd,
  "hu-HU": yd,
  "it-IT": xd,
  "ja-JP": Ed,
  "ko-KR": Pd,
  "lt-LT": Dd,
  "lv-LV": Sd,
  "nb-NO": Cd,
  "nl-NL": wd,
  "pl-PL": Td,
  "pt-BR": kd,
  "pt-PT": Bd,
  "ro-RO": Fd,
  "ru-RU": Kd,
  "sk-SK": Ld,
  "sl-SI": Md,
  "sr-SP": Id,
  "sv-SE": Ad,
  "tr-TR": Nd,
  "uk-UA": Rd,
  "zh-CN": Od,
  "zh-TW": Vd
};
function em(t) {
  return t && t.__esModule ? t.default : t;
}
function tm(t, e, n) {
  let { id: r, decrementAriaLabel: i, incrementAriaLabel: l, isDisabled: o, isReadOnly: a, isRequired: s, minValue: u, maxValue: d, autoFocus: c, label: f, formatOptions: v, onBlur: b = () => {
  }, onFocus: p, onFocusChange: h, onKeyDown: $, onKeyUp: y, description: P, errorMessage: S, isWheelDisabled: A, ...w } = t, { increment: M, incrementToMax: T, decrement: N, decrementToMin: I, numberValue: m, inputValue: K, commit: B, commitValidation: D } = e;
  const F = Ge(em(zd), "@react-aria/numberfield");
  let g = ae(r), { focusProps: E } = Un({
    onBlur() {
      B();
    }
  }), k = Dr(v), V = z(() => k.resolvedOptions(), [
    k
  ]), C = Dr({
    ...v,
    currencySign: void 0
  }), Y = z(() => isNaN(m) ? "" : C.format(m), [
    C,
    m
  ]), { spinButtonProps: ne, incrementButtonProps: G, decrementButtonProps: fe } = Qp({
    isDisabled: o,
    isReadOnly: a,
    isRequired: s,
    maxValue: d,
    minValue: u,
    onIncrement: M,
    onIncrementToMax: T,
    onDecrement: N,
    onDecrementToMin: I,
    value: m,
    textValue: Y
  }), [se, me] = W(!1), { focusWithinProps: Te } = ln({
    isDisabled: o,
    onFocusWithinChange: me
  }), ye = j((xe) => {
    Math.abs(xe.deltaY) <= Math.abs(xe.deltaX) || (xe.deltaY > 0 ? M() : xe.deltaY < 0 && N());
  }, [
    N,
    M
  ]);
  wb({
    onScroll: ye,
    isDisabled: A || o || a || !se
  }, n);
  var Re;
  let Ye = ((Re = V.maximumFractionDigits) !== null && Re !== void 0 ? Re : 0) > 0, U = e.minValue === void 0 || isNaN(e.minValue) || e.minValue < 0, he = "numeric";
  wl() ? U ? he = "text" : Ye && (he = "decimal") : Vn() && (U ? he = "numeric" : Ye && (he = "decimal"));
  let ke = (xe) => {
    e.validate(xe) && e.setInputValue(xe);
  }, it = q(t), un = j((xe) => {
    xe.nativeEvent.isComposing || (xe.key === "Enter" ? (B(), D()) : xe.continuePropagation());
  }, [
    B,
    D
  ]), { isInvalid: Z, validationErrors: lt, validationDetails: Nt } = e.displayValidation, { labelProps: yt, inputProps: Pf, descriptionProps: Df, errorMessageProps: Sf } = Sp({
    ...w,
    ...it,
    // These props are added to a hidden input rather than the formatted textfield.
    name: void 0,
    form: void 0,
    label: f,
    autoFocus: c,
    isDisabled: o,
    isReadOnly: a,
    isRequired: s,
    validate: void 0,
    [Jt]: e,
    value: K,
    defaultValue: "!",
    autoComplete: "off",
    "aria-label": t["aria-label"] || void 0,
    "aria-labelledby": t["aria-labelledby"] || void 0,
    id: g,
    type: "text",
    inputMode: he,
    onChange: ke,
    onBlur: b,
    onFocus: p,
    onFocusChange: h,
    onKeyDown: z(() => Ue(un, $), [
      un,
      $
    ]),
    onKeyUp: y,
    description: P,
    errorMessage: S
  }, e, n);
  _r(n, e.defaultNumberValue, e.setNumberValue);
  let ci = R(ne, E, Pf, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": nn() ? null : F.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  t.validationBehavior === "native" && (ci["aria-required"] = void 0);
  let fi = (xe) => {
    var Qn;
    document.activeElement !== n.current && (xe.pointerType === "mouse" ? (Qn = n.current) === null || Qn === void 0 || Qn.focus() : xe.target.focus());
  }, Jn = t["aria-label"] || (typeof t.label == "string" ? t.label : ""), ot;
  Jn || (ot = t.label != null ? yt.id : t["aria-labelledby"]);
  let vi = ae(), bi = ae(), Cf = R(G, {
    "aria-label": l || F.format("increase", {
      fieldLabel: Jn
    }).trim(),
    id: ot && !l ? vi : null,
    "aria-labelledby": ot && !l ? `${vi} ${ot}` : null,
    "aria-controls": g,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canIncrement,
    onPressStart: fi
  }), wf = R(fe, {
    "aria-label": i || F.format("decrease", {
      fieldLabel: Jn
    }).trim(),
    id: ot && !i ? bi : null,
    "aria-labelledby": ot && !i ? `${bi} ${ot}` : null,
    "aria-controls": g,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canDecrement,
    onPressStart: fi
  });
  return {
    groupProps: {
      ...Te,
      role: "group",
      "aria-disabled": o,
      "aria-invalid": Z ? "true" : void 0
    },
    labelProps: yt,
    inputProps: ci,
    incrementButtonProps: Cf,
    decrementButtonProps: wf,
    errorMessageProps: Sf,
    descriptionProps: Df,
    isInvalid: Z,
    validationErrors: lt,
    validationDetails: Nt
  };
}
function nm(t, e) {
  let { role: n = "dialog" } = t, r = ft();
  r = t["aria-label"] ? void 0 : r;
  let i = L(!1);
  return _(() => {
    if (e.current && !e.current.contains(document.activeElement)) {
      $e(e.current);
      let l = setTimeout(() => {
        (document.activeElement === e.current || document.activeElement === document.body) && (i.current = !0, e.current && (e.current.blur(), $e(e.current)), i.current = !1);
      }, 500);
      return () => {
        clearTimeout(l);
      };
    }
  }, [
    e
  ]), ea(), {
    dialogProps: {
      ...q(t, {
        labelable: !0
      }),
      role: n,
      tabIndex: -1,
      "aria-labelledby": t["aria-labelledby"] || r,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (l) => {
        i.current && l.stopPropagation();
      }
    },
    titleProps: {
      id: r
    }
  };
}
function rm(t, e, n) {
  let { isDisabled: r } = t, i = ae(), l = ae(), o = Me(), a = L(null), s = j(() => {
    a.current = requestAnimationFrame(() => {
      n.current && n.current.setAttribute("hidden", "until-found");
    }), Nn(() => {
      e.toggle();
    });
  }, [
    n,
    e
  ]);
  dt(n, "beforematch", s);
  let u = L(null);
  return X(() => {
    if (a.current && cancelAnimationFrame(a.current), n.current && !r && !o) {
      let d = n.current;
      u.current == null || typeof d.getAnimations != "function" ? e.isExpanded ? (d.removeAttribute("hidden"), d.style.setProperty("--disclosure-panel-width", "auto"), d.style.setProperty("--disclosure-panel-height", "auto")) : (d.setAttribute("hidden", "until-found"), d.style.setProperty("--disclosure-panel-width", "0px"), d.style.setProperty("--disclosure-panel-height", "0px")) : e.isExpanded !== u.current && (e.isExpanded ? (d.removeAttribute("hidden"), d.style.setProperty("--disclosure-panel-width", d.scrollWidth + "px"), d.style.setProperty("--disclosure-panel-height", d.scrollHeight + "px"), Promise.all(d.getAnimations().map((c) => c.finished)).then(() => {
        d.style.setProperty("--disclosure-panel-width", "auto"), d.style.setProperty("--disclosure-panel-height", "auto");
      }).catch(() => {
      })) : (d.style.setProperty("--disclosure-panel-width", d.scrollWidth + "px"), d.style.setProperty("--disclosure-panel-height", d.scrollHeight + "px"), window.getComputedStyle(d).height, d.style.setProperty("--disclosure-panel-width", "0px"), d.style.setProperty("--disclosure-panel-height", "0px"), Promise.all(d.getAnimations().map((c) => c.finished)).then(() => d.setAttribute("hidden", "until-found")).catch(() => {
      }))), u.current = e.isExpanded;
    }
  }, [
    r,
    n,
    e.isExpanded,
    o
  ]), _(() => () => {
    a.current && cancelAnimationFrame(a.current);
  }, []), {
    buttonProps: {
      id: i,
      "aria-expanded": e.isExpanded,
      "aria-controls": l,
      onPress: (d) => {
        !r && d.pointerType !== "keyboard" && e.toggle();
      },
      isDisabled: r,
      onPressStart(d) {
        d.pointerType === "keyboard" && !r && e.toggle();
      }
    },
    panelProps: {
      id: l,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": i,
      "aria-hidden": !e.isExpanded,
      hidden: o || r ? r || !e.isExpanded : void 0
    }
  };
}
const ri = /* @__PURE__ */ new WeakMap();
function fl(t, e) {
  var n;
  let { id: r } = (n = ri.get(t)) !== null && n !== void 0 ? n : {};
  if (!r) throw new Error("Unknown list");
  return `${r}-${im(e)}`;
}
function im(t) {
  return typeof t == "string" ? t.replace(/\s*/g, "") : "" + t;
}
var Hd = {};
Hd = {
  deselectedItem: (t) => `${t.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${e.number(t.count)} عنصر محدد`,
    other: () => `${e.number(t.count)} عنصر محدد`
  })}.`,
  selectedItem: (t) => `${t.item} المحدد`
};
var _d = {};
_d = {
  deselectedItem: (t) => `${t.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Няма избрани елементи",
    one: () => `${e.number(t.count)} избран елемент`,
    other: () => `${e.number(t.count)} избрани елементи`
  })}.`,
  selectedItem: (t) => `${t.item} избран.`
};
var Ud = {};
Ud = {
  deselectedItem: (t) => `Položka ${t.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${e.number(t.count)} položka`,
    other: () => `Vybráno ${e.number(t.count)} položek`
  })}.`,
  selectedItem: (t) => `Vybrána položka ${t.item}.`
};
var jd = {};
jd = {
  deselectedItem: (t) => `${t.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${e.number(t.count)} element valgt`,
    other: () => `${e.number(t.count)} elementer valgt`
  })}.`,
  selectedItem: (t) => `${t.item} valgt.`
};
var Wd = {};
Wd = {
  deselectedItem: (t) => `${t.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${e.number(t.count)} Element ausgewählt`,
    other: () => `${e.number(t.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (t) => `${t.item} ausgewählt.`
};
var Gd = {};
Gd = {
  deselectedItem: (t) => `Δεν επιλέχθηκε το στοιχείο ${t.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${e.number(t.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${e.number(t.count)} στοιχεία`
  })}.`,
  selectedItem: (t) => `Επιλέχθηκε το στοιχείο ${t.item}.`
};
var qd = {};
qd = {
  deselectedItem: (t) => `${t.item} not selected.`,
  select: "Select",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "No items selected",
    one: () => `${e.number(t.count)} item selected`,
    other: () => `${e.number(t.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (t) => `${t.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var Yd = {};
Yd = {
  deselectedItem: (t) => `${t.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${e.number(t.count)} elemento seleccionado`,
    other: () => `${e.number(t.count)} elementos seleccionados`
  })}.`,
  selectedItem: (t) => `${t.item} seleccionado.`
};
var Xd = {};
Xd = {
  deselectedItem: (t) => `${t.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${e.number(t.count)} üksus valitud`,
    other: () => `${e.number(t.count)} üksust valitud`
  })}.`,
  selectedItem: (t) => `${t.item} valitud.`
};
var Zd = {};
Zd = {
  deselectedItem: (t) => `Kohdetta ${t.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${e.number(t.count)} kohde valittu`,
    other: () => `${e.number(t.count)} kohdetta valittu`
  })}.`,
  selectedItem: (t) => `${t.item} valittu.`
};
var Jd = {};
Jd = {
  deselectedItem: (t) => `${t.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${e.number(t.count)} élément sélectionné`,
    other: () => `${e.number(t.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (t) => `${t.item} sélectionné.`
};
var Qd = {};
Qd = {
  deselectedItem: (t) => `${t.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${e.number(t.count)} נבחר`,
    other: () => `${e.number(t.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (t) => `${t.item} נבחר.`
};
var ec = {};
ec = {
  deselectedItem: (t) => `Stavka ${t.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${e.number(t.count)} stavka`,
    other: () => `Odabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `Stavka ${t.item} je odabrana.`
};
var tc = {};
tc = {
  deselectedItem: (t) => `${t.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${e.number(t.count)} elem kijelölve`,
    other: () => `${e.number(t.count)} elem kijelölve`
  })}.`,
  selectedItem: (t) => `${t.item} kijelölve.`
};
var nc = {};
nc = {
  deselectedItem: (t) => `${t.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${e.number(t.count)} elemento selezionato`,
    other: () => `${e.number(t.count)} elementi selezionati`
  })}.`,
  selectedItem: (t) => `${t.item} selezionato.`
};
var rc = {};
rc = {
  deselectedItem: (t) => `${t.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "項目が選択されていません",
    one: () => `${e.number(t.count)} 項目を選択しました`,
    other: () => `${e.number(t.count)} 項目を選択しました`
  })}。`,
  selectedItem: (t) => `${t.item} を選択しました。`
};
var ic = {};
ic = {
  deselectedItem: (t) => `${t.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${e.number(t.count)}개 항목이 선택되었습니다`,
    other: () => `${e.number(t.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (t) => `${t.item}이(가) 선택되었습니다.`
};
var lc = {};
lc = {
  deselectedItem: (t) => `${t.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${e.number(t.count)} elementas`,
    other: () => `Pasirinkta elementų: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Pasirinkta: ${t.item}.`
};
var oc = {};
oc = {
  deselectedItem: (t) => `Vienums ${t.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`,
    other: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Atlasīts vienums ${t.item}.`
};
var ac = {};
ac = {
  deselectedItem: (t) => `${t.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${e.number(t.count)} element er valgt`,
    other: () => `${e.number(t.count)} elementer er valgt`
  })}.`,
  selectedItem: (t) => `${t.item} er valgt.`
};
var sc = {};
sc = {
  deselectedItem: (t) => `${t.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${e.number(t.count)} item geselecteerd`,
    other: () => `${e.number(t.count)} items geselecteerd`
  })}.`,
  selectedItem: (t) => `${t.item} geselecteerd.`
};
var uc = {};
uc = {
  deselectedItem: (t) => `Nie zaznaczono ${t.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${e.number(t.count)} zaznaczony element`,
    other: () => `${e.number(t.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (t) => `Zaznaczono ${t.item}.`
};
var dc = {};
dc = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var cc = {};
cc = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var fc = {};
fc = {
  deselectedItem: (t) => `${t.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Niciun element selectat",
    one: () => `${e.number(t.count)} element selectat`,
    other: () => `${e.number(t.count)} elemente selectate`
  })}.`,
  selectedItem: (t) => `${t.item} selectat.`
};
var vc = {};
vc = {
  deselectedItem: (t) => `${t.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${e.number(t.count)} элемент выбран`,
    other: () => `${e.number(t.count)} элементов выбрано`
  })}.`,
  selectedItem: (t) => `${t.item} выбрано.`
};
var bc = {};
bc = {
  deselectedItem: (t) => `Nevybraté položky: ${t.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${e.number(t.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Vybraté položky: ${t.item}.`
};
var pc = {};
pc = {
  deselectedItem: (t) => `Element ${t.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Noben element ni izbran",
    one: () => `${e.number(t.count)} element je izbran`,
    other: () => `${e.number(t.count)} elementov je izbranih`
  })}.`,
  selectedItem: (t) => `Element ${t.item} je izbran.`
};
var mc = {};
mc = {
  deselectedItem: (t) => `${t.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${e.number(t.count)} stavka`,
    other: () => `Izabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `${t.item} je izabrano.`
};
var hc = {};
hc = {
  deselectedItem: (t) => `${t.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Inga markerade objekt",
    one: () => `${e.number(t.count)} markerat objekt`,
    other: () => `${e.number(t.count)} markerade objekt`
  })}.`,
  selectedItem: (t) => `${t.item} markerat.`
};
var $c = {};
$c = {
  deselectedItem: (t) => `${t.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${e.number(t.count)} öge seçildi`,
    other: () => `${e.number(t.count)} öge seçildi`
  })}.`,
  selectedItem: (t) => `${t.item} seçildi.`
};
var gc = {};
gc = {
  deselectedItem: (t) => `${t.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${e.number(t.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `${t.item} вибрано.`
};
var yc = {};
yc = {
  deselectedItem: (t) => `未选择 ${t.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${e.number(t.count)} 个项目`,
    other: () => `已选择 ${e.number(t.count)} 个项目`
  })}。`,
  selectedItem: (t) => `已选择 ${t.item}。`
};
var xc = {};
xc = {
  deselectedItem: (t) => `未選取「${t.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${e.number(t.count)} 個項目`,
    other: () => `已選取 ${e.number(t.count)} 個項目`
  })}。`,
  selectedItem: (t) => `已選取「${t.item}」。`
};
var ii = {};
ii = {
  "ar-AE": Hd,
  "bg-BG": _d,
  "cs-CZ": Ud,
  "da-DK": jd,
  "de-DE": Wd,
  "el-GR": Gd,
  "en-US": qd,
  "es-ES": Yd,
  "et-EE": Xd,
  "fi-FI": Zd,
  "fr-FR": Jd,
  "he-IL": Qd,
  "hr-HR": ec,
  "hu-HU": tc,
  "it-IT": nc,
  "ja-JP": rc,
  "ko-KR": ic,
  "lt-LT": lc,
  "lv-LV": oc,
  "nb-NO": ac,
  "nl-NL": sc,
  "pl-PL": uc,
  "pt-BR": dc,
  "pt-PT": cc,
  "ro-RO": fc,
  "ru-RU": vc,
  "sk-SK": bc,
  "sl-SI": pc,
  "sr-SP": mc,
  "sv-SE": hc,
  "tr-TR": $c,
  "uk-UA": gc,
  "zh-CN": yc,
  "zh-TW": xc
};
function lm(t) {
  return t && t.__esModule ? t.default : t;
}
function om(t, e) {
  let { getRowText: n = (a) => {
    var s, u, d, c;
    return (c = (s = (u = e.collection).getTextValue) === null || s === void 0 ? void 0 : s.call(u, a)) !== null && c !== void 0 ? c : (d = e.collection.getItem(a)) === null || d === void 0 ? void 0 : d.textValue;
  } } = t, r = Ge(lm(ii), "@react-aria/grid"), i = e.selectionManager.rawSelection, l = L(i), o = te(() => {
    var a;
    if (!e.selectionManager.isFocused || i === l.current) {
      l.current = i;
      return;
    }
    let s = vl(i, l.current), u = vl(l.current, i), d = e.selectionManager.selectionBehavior === "replace", c = [];
    if (e.selectionManager.selectedKeys.size === 1 && d) {
      let f = e.selectionManager.selectedKeys.keys().next().value;
      if (f != null && e.collection.getItem(f)) {
        let v = n(f);
        v && c.push(r.format("selectedItem", {
          item: v
        }));
      }
    } else if (s.size === 1 && u.size === 0) {
      let f = s.keys().next().value;
      if (f != null) {
        let v = n(f);
        v && c.push(r.format("selectedItem", {
          item: v
        }));
      }
    } else if (u.size === 1 && s.size === 0) {
      let f = u.keys().next().value;
      if (f != null && e.collection.getItem(f)) {
        let v = n(f);
        v && c.push(r.format("deselectedItem", {
          item: v
        }));
      }
    }
    e.selectionManager.selectionMode === "multiple" && (c.length === 0 || i === "all" || i.size > 1 || l.current === "all" || ((a = l.current) === null || a === void 0 ? void 0 : a.size) > 1) && c.push(i === "all" ? r.format("selectedAll") : r.format("selectedCount", {
      count: i.size
    })), c.length > 0 && Dn(c.join(" ")), l.current = i;
  });
  uv(() => {
    if (e.selectionManager.isFocused) o();
    else {
      let a = requestAnimationFrame(o);
      return () => cancelAnimationFrame(a);
    }
  }, [
    i,
    e.selectionManager.isFocused
  ]);
}
function vl(t, e) {
  let n = /* @__PURE__ */ new Set();
  if (t === "all" || e === "all") return n;
  for (let r of t.keys()) e.has(r) || n.add(r);
  return n;
}
function am(t) {
  return t && t.__esModule ? t.default : t;
}
function sm(t) {
  let e = Ge(am(ii), "@react-aria/grid"), n = Xr(), r = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, i = z(() => {
    let o = t.selectionManager.selectionMode, a = t.selectionManager.selectionBehavior, s;
    return r && (s = e.format("longPressToSelect")), a === "replace" && o !== "none" && t.hasItemActions ? s : void 0;
  }, [
    t.selectionManager.selectionMode,
    t.selectionManager.selectionBehavior,
    t.hasItemActions,
    e,
    r
  ]);
  return Hr(i);
}
function um(t, e, n) {
  let { isVirtualized: r, keyboardDelegate: i, layoutDelegate: l, onAction: o, disallowTypeAhead: a, linkBehavior: s = "action", keyboardNavigationBehavior: u = "arrow", escapeKeyBehavior: d = "clearSelection", shouldSelectOnPressUp: c } = t;
  !t["aria-label"] && !t["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: f } = oa({
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    ref: n,
    keyboardDelegate: i,
    layoutDelegate: l,
    isVirtualized: r,
    selectOnFocus: e.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: t.shouldFocusWrap,
    linkBehavior: s,
    disallowTypeAhead: a,
    autoFocus: t.autoFocus,
    escapeKeyBehavior: d
  }), v = ae(t.id);
  ri.set(e, {
    id: v,
    onAction: o,
    linkBehavior: s,
    keyboardNavigationBehavior: u,
    shouldSelectOnPressUp: c
  });
  let b = sm({
    selectionManager: e.selectionManager,
    hasItemActions: !!o
  }), p = Ab(n, {
    isDisabled: e.collection.size !== 0
  }), h = q(t, {
    labelable: !0
  }), $ = R(
    h,
    {
      role: "grid",
      id: v,
      "aria-multiselectable": e.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    e.collection.size === 0 ? {
      tabIndex: p ? -1 : 0
    } : f,
    b
  );
  return r && ($["aria-rowcount"] = e.collection.size, $["aria-colcount"] = 1), om({}, e), {
    gridProps: $
  };
}
const bl = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function dm(t, e, n) {
  var r, i;
  let { node: l, isVirtualized: o } = t, { direction: a } = Ae(), { onAction: s, linkBehavior: u, keyboardNavigationBehavior: d, shouldSelectOnPressUp: c } = ri.get(e), f = ft(), v = L(null), b = () => {
    var F;
    n.current !== null && (v.current != null && l.key !== v.current || !(!((F = n.current) === null || F === void 0) && F.contains(document.activeElement))) && $e(n.current);
  }, p = {}, h = t.hasChildItems, $ = e.selectionManager.isLink(l.key);
  if (l != null && "expandedKeys" in e) {
    var y, P;
    let F = (y = (P = e.collection).getChildren) === null || y === void 0 ? void 0 : y.call(P, l.key);
    h = h || [
      ...F ?? []
    ].length > 1, s == null && !$ && e.selectionManager.selectionMode === "none" && h && (s = () => e.toggleKey(l.key));
    let g = h ? e.expandedKeys.has(l.key) : void 0, E = 1;
    if (l.level > 0 && l?.parentKey != null) {
      let k = e.collection.getItem(l.parentKey);
      if (k) {
        var S, A;
        E = [
          ...(S = (A = e.collection).getChildren) === null || S === void 0 ? void 0 : S.call(A, k.key)
        ].filter((C) => C.type === "item").length;
      }
    } else E = [
      ...e.collection
    ].filter((k) => k.level === 0 && k.type === "item").length;
    p = {
      "aria-expanded": g,
      "aria-level": l.level + 1,
      "aria-posinset": l?.index + 1,
      "aria-setsize": E
    };
  }
  let { itemProps: w, ...M } = ia({
    selectionManager: e.selectionManager,
    key: l.key,
    ref: n,
    isVirtualized: o,
    shouldSelectOnPressUp: t.shouldSelectOnPressUp || c,
    onAction: s || !((r = l.props) === null || r === void 0) && r.onAction ? Ue((i = l.props) === null || i === void 0 ? void 0 : i.onAction, s ? () => s(l.key) : void 0) : void 0,
    focus: b,
    linkBehavior: u
  }), T = (F) => {
    if (!F.currentTarget.contains(F.target) || !n.current || !document.activeElement) return;
    let g = Ce(n.current);
    if (g.currentNode = document.activeElement, "expandedKeys" in e && document.activeElement === n.current) {
      if (F.key === bl.expand[a] && e.selectionManager.focusedKey === l.key && h && !e.expandedKeys.has(l.key)) {
        e.toggleKey(l.key), F.stopPropagation();
        return;
      } else if (F.key === bl.collapse[a] && e.selectionManager.focusedKey === l.key && h && e.expandedKeys.has(l.key)) {
        e.toggleKey(l.key), F.stopPropagation();
        return;
      }
    }
    switch (F.key) {
      case "ArrowLeft":
        if (d === "arrow") {
          let k = a === "rtl" ? g.nextNode() : g.previousNode();
          if (k)
            F.preventDefault(), F.stopPropagation(), $e(k), Ze(k, {
              containingElement: ze(n.current)
            });
          else if (F.preventDefault(), F.stopPropagation(), a === "rtl")
            $e(n.current), Ze(n.current, {
              containingElement: ze(n.current)
            });
          else {
            g.currentNode = n.current;
            let V = pl(g);
            V && ($e(V), Ze(V, {
              containingElement: ze(n.current)
            }));
          }
        }
        break;
      case "ArrowRight":
        if (d === "arrow") {
          let k = a === "rtl" ? g.previousNode() : g.nextNode();
          if (k)
            F.preventDefault(), F.stopPropagation(), $e(k), Ze(k, {
              containingElement: ze(n.current)
            });
          else if (F.preventDefault(), F.stopPropagation(), a === "ltr")
            $e(n.current), Ze(n.current, {
              containingElement: ze(n.current)
            });
          else {
            g.currentNode = n.current;
            let V = pl(g);
            V && ($e(V), Ze(V, {
              containingElement: ze(n.current)
            }));
          }
        }
        break;
      case "ArrowUp":
      case "ArrowDown":
        if (!F.altKey && n.current.contains(F.target)) {
          var E;
          F.stopPropagation(), F.preventDefault(), (E = n.current.parentElement) === null || E === void 0 || E.dispatchEvent(new KeyboardEvent(F.nativeEvent.type, F.nativeEvent));
        }
        break;
    }
  }, N = (F) => {
    if (v.current = l.key, F.target !== n.current) {
      kt() || e.selectionManager.setFocusedKey(l.key);
      return;
    }
  }, I = (F) => {
    if (!(!F.currentTarget.contains(F.target) || !n.current || !document.activeElement))
      switch (F.key) {
        case "Tab":
          if (d === "tab") {
            let g = Ce(n.current, {
              tabbable: !0
            });
            g.currentNode = document.activeElement, (F.shiftKey ? g.previousNode() : g.nextNode()) && F.stopPropagation();
          }
      }
  }, m = Ll(l.props), K = M.hasAction ? m : {}, B = R(w, K, {
    role: "row",
    onKeyDownCapture: T,
    onKeyDown: I,
    onFocus: N,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": l.textValue || void 0,
    "aria-selected": e.selectionManager.canSelectItem(l.key) ? e.selectionManager.isSelected(l.key) : void 0,
    "aria-disabled": e.selectionManager.isDisabled(l.key) || void 0,
    "aria-labelledby": f && l.textValue ? `${fl(e, l.key)} ${f}` : void 0,
    id: fl(e, l.key)
  });
  if (o) {
    let { collection: F } = e, g = [
      ...F
    ];
    B["aria-rowindex"] = g.find((E) => E.type === "section") ? [
      ...F.getKeys()
    ].filter((E) => {
      var k;
      return ((k = F.getItem(E)) === null || k === void 0 ? void 0 : k.type) !== "section";
    }).findIndex((E) => E === l.key) + 1 : l.index + 1;
  }
  let D = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ...R(B, p)
    },
    gridCellProps: D,
    descriptionProps: {
      id: f
    },
    ...M
  };
}
function pl(t) {
  let e = null, n = null;
  do
    n = t.lastChild(), n && (e = n);
  while (n);
  return e;
}
function cm(t) {
  let { value: e = 0, minValue: n = 0, maxValue: r = 100, valueLabel: i, isIndeterminate: l, formatOptions: o = {
    style: "percent"
  } } = t, a = q(t, {
    labelable: !0
  }), { labelProps: s, fieldProps: u } = ta({
    ...t,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  e = et(e, n, r);
  let d = (e - n) / (r - n), c = Dr(o);
  if (!l && !i) {
    let f = o.style === "percent" ? d : e;
    i = c.format(f);
  }
  return {
    progressBarProps: R(a, {
      ...u,
      "aria-valuenow": l ? void 0 : e,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": l ? void 0 : i,
      role: "progressbar"
    }),
    labelProps: s
  };
}
function fm(t) {
  let e = q(t, {
    labelable: !0
  }), n;
  return t.orientation === "vertical" && (n = "vertical"), t.elementType !== "hr" ? {
    separatorProps: {
      ...e,
      role: "separator",
      "aria-orientation": n
    }
  } : {
    separatorProps: e
  };
}
const Ec = /* @__PURE__ */ new WeakMap();
function vm(t, e, n) {
  let { direction: r } = Ae(), i = t.keyboardDelegate || new la({
    collection: e.collection,
    ref: n,
    orientation: "horizontal",
    direction: r,
    disabledKeys: e.disabledKeys,
    disabledBehavior: e.selectionManager.disabledBehavior
  }), { labelProps: l, fieldProps: o, descriptionProps: a, errorMessageProps: s } = na({
    ...t,
    labelElementType: "span"
  }), { gridProps: u } = um({
    ...t,
    ...o,
    keyboardDelegate: i,
    shouldFocusWrap: !0,
    linkBehavior: "override",
    keyboardNavigationBehavior: "tab"
  }, e, n), [d, c] = W(!1), { focusWithinProps: f } = ln({
    onFocusWithinChange: c
  }), v = q(t), b = L(e.collection.size);
  return _(() => {
    n.current && b.current > 0 && e.collection.size === 0 && d && n.current.focus(), b.current = e.collection.size;
  }, [
    e.collection.size,
    d,
    n
  ]), Ec.set(e, {
    onRemove: t.onRemove
  }), {
    gridProps: R(u, v, {
      role: e.collection.size ? "grid" : "group",
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": d ? "polite" : "off",
      ...f,
      ...o
    }),
    labelProps: l,
    descriptionProps: a,
    errorMessageProps: s
  };
}
var Pc = {};
Pc = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var Dc = {};
Dc = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var Sc = {};
Sc = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var Cc = {};
Cc = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var wc = {};
wc = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var Tc = {};
Tc = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var kc = {};
kc = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var Bc = {};
Bc = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var Fc = {};
Fc = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var Kc = {};
Kc = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var Lc = {};
Lc = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var Mc = {};
Mc = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var Ic = {};
Ic = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var Ac = {};
Ac = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var Nc = {};
Nc = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var Rc = {};
Rc = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var Oc = {};
Oc = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var Vc = {};
Vc = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var zc = {};
zc = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var Hc = {};
Hc = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var _c = {};
_c = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var Uc = {};
Uc = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var jc = {};
jc = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var Wc = {};
Wc = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var Gc = {};
Gc = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var qc = {};
qc = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var Yc = {};
Yc = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var Xc = {};
Xc = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var Zc = {};
Zc = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var Jc = {};
Jc = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var Qc = {};
Qc = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var ef = {};
ef = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var tf = {};
tf = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var nf = {};
nf = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var rf = {};
rf = {
  "ar-AE": Pc,
  "bg-BG": Dc,
  "cs-CZ": Sc,
  "da-DK": Cc,
  "de-DE": wc,
  "el-GR": Tc,
  "en-US": kc,
  "es-ES": Bc,
  "et-EE": Fc,
  "fi-FI": Kc,
  "fr-FR": Lc,
  "he-IL": Mc,
  "hr-HR": Ic,
  "hu-HU": Ac,
  "it-IT": Nc,
  "ja-JP": Rc,
  "ko-KR": Oc,
  "lt-LT": Vc,
  "lv-LV": zc,
  "nb-NO": Hc,
  "nl-NL": _c,
  "pl-PL": Uc,
  "pt-BR": jc,
  "pt-PT": Wc,
  "ro-RO": Gc,
  "ru-RU": qc,
  "sk-SK": Yc,
  "sl-SI": Xc,
  "sr-SP": Zc,
  "sv-SE": Jc,
  "tr-TR": Qc,
  "uk-UA": ef,
  "zh-CN": tf,
  "zh-TW": nf
};
function bm(t) {
  return t && t.__esModule ? t.default : t;
}
function pm(t, e, n) {
  let { item: r } = t, i = Ge(bm(rf), "@react-aria/tag"), l = ae(), { onRemove: o } = Ec.get(e) || {}, { rowProps: a, gridCellProps: s, ...u } = dm({
    node: r
  }, e, n), { descriptionProps: d, ...c } = u, f = e.disabledKeys.has(r.key) || r.props.isDisabled, v = (M) => {
    if (M.key === "Delete" || M.key === "Backspace") {
      if (f) return;
      M.preventDefault(), e.selectionManager.isSelected(r.key) ? o?.(new Set(e.selectionManager.selectedKeys)) : o?.(/* @__PURE__ */ new Set([
        r.key
      ]));
    }
  }, b = Xr();
  b === "virtual" && typeof window < "u" && "ontouchstart" in window && (b = "pointer");
  let p = o && (b === "keyboard" || b === "virtual") ? i.format("removeDescription") : "", h = Hr(p), $ = r.key === e.selectionManager.focusedKey, y = e.selectionManager.focusedKey != null, P = -1;
  !f && ($ || !y) && (P = 0);
  let S = q(r.props), A = Ll(r.props), { focusableProps: w } = ht({
    isDisabled: f
  }, n);
  return {
    removeButtonProps: {
      "aria-label": i.format("removeButtonLabel"),
      "aria-labelledby": `${l} ${a.id}`,
      isDisabled: f,
      id: l,
      onPress: () => o ? o(/* @__PURE__ */ new Set([
        r.key
      ])) : null
    },
    rowProps: R(w, a, S, A, {
      tabIndex: P,
      onKeyDown: o ? v : void 0,
      "aria-describedby": h["aria-describedby"]
    }),
    gridCellProps: R(s, {
      "aria-errormessage": t["aria-errormessage"],
      "aria-label": t["aria-label"]
    }),
    ...c,
    allowsRemoving: !!o
  };
}
function mm(t, e) {
  let n = q(t, {
    labelable: !0
  }), { hoverProps: r } = Fe({
    onHoverStart: () => e?.open(!0),
    onHoverEnd: () => e?.close()
  });
  return {
    tooltipProps: R(n, r, {
      role: "tooltip"
    })
  };
}
function hm(t, e, n) {
  let { isDisabled: r, trigger: i } = t, l = ae(), o = L(!1), a = L(!1), s = () => {
    (o.current || a.current) && e.open(a.current);
  }, u = ($) => {
    !o.current && !a.current && e.close($);
  };
  _(() => {
    let $ = (y) => {
      n && n.current && y.key === "Escape" && (y.stopPropagation(), e.close(!0));
    };
    if (e.isOpen)
      return document.addEventListener("keydown", $, !0), () => {
        document.removeEventListener("keydown", $, !0);
      };
  }, [
    n,
    e
  ]);
  let d = () => {
    i !== "focus" && (Zt() === "pointer" ? o.current = !0 : o.current = !1, s());
  }, c = () => {
    i !== "focus" && (a.current = !1, o.current = !1, u());
  }, f = () => {
    a.current = !1, o.current = !1, u(!0);
  }, v = () => {
    kt() && (a.current = !0, s());
  }, b = () => {
    a.current = !1, o.current = !1, u(!0);
  }, { hoverProps: p } = Fe({
    isDisabled: r,
    onHoverStart: d,
    onHoverEnd: c
  }), { focusableProps: h } = ht({
    isDisabled: r,
    onFocus: v,
    onBlur: b
  }, n);
  return {
    triggerProps: {
      "aria-describedby": e.isOpen ? l : void 0,
      ...R(h, p, {
        onPointerDown: f,
        onKeyDown: f
      }),
      tabIndex: void 0
    },
    tooltipProps: {
      id: l
    }
  };
}
const lf = /* @__PURE__ */ O(null), u0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, lf);
  let r = e.href && !e.isDisabled ? "a" : "span", { linkProps: i, isPressed: l } = Up({
    ...e,
    elementType: r
  }, n), { hoverProps: o, isHovered: a } = Fe(e), { focusProps: s, isFocused: u, isFocusVisible: d } = Ne(), c = le({
    ...e,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!e["aria-current"],
      isDisabled: e.isDisabled || !1,
      isPressed: l,
      isHovered: a,
      isFocused: u,
      isFocusVisible: d
    }
  }), f = q(e, {
    global: !0
  });
  return delete f.onClick, /* @__PURE__ */ x.createElement(r, {
    ref: n,
    slot: e.slot || void 0,
    ...R(f, c, i, o, s),
    "data-focused": u || void 0,
    "data-hovered": a || void 0,
    "data-pressed": l || void 0,
    "data-focus-visible": d || void 0,
    "data-current": !!e["aria-current"] || void 0,
    "data-disabled": e.isDisabled || void 0
  }, c.children);
}), Nr = /* @__PURE__ */ O(null), d0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, Nr);
  let { CollectionRoot: r } = H(Lt), { navProps: i } = Wp(e), l = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement(ei, {
    content: /* @__PURE__ */ x.createElement(ti, e)
  }, (o) => {
    var a;
    return /* @__PURE__ */ x.createElement("ol", {
      ref: n,
      ...R(l, i),
      slot: e.slot || void 0,
      style: e.style,
      className: (a = e.className) !== null && a !== void 0 ? a : "react-aria-Breadcrumbs"
    }, /* @__PURE__ */ x.createElement(Nr.Provider, {
      value: e
    }, /* @__PURE__ */ x.createElement(r, {
      collection: o
    })));
  });
});
class of extends $t {
}
of.type = "item";
const c0 = /* @__PURE__ */ Kt(of, function(e, n, r) {
  let i = r.nextKey == null, { isDisabled: l, onAction: o } = mt(Nr), a = {
    "aria-current": i ? "page" : null,
    isDisabled: l || i,
    onPress: () => o?.(r.key)
  }, s = le({
    ...r.props,
    children: r.rendered,
    values: {
      isDisabled: l || i,
      isCurrent: i
    },
    defaultClassName: "react-aria-Breadcrumb"
  }), u = q(e, {
    global: !0
  });
  return delete u.id, /* @__PURE__ */ x.createElement("li", {
    ...u,
    ...s,
    ref: n,
    "data-disabled": l || i || void 0,
    "data-current": i || void 0
  }, /* @__PURE__ */ x.createElement(lf.Provider, {
    value: a
  }, s.children));
}), Mt = /* @__PURE__ */ O({}), f0 = /* @__PURE__ */ on(function(e, n) {
  [e, n] = ee(e, n, Mt);
  let { elementType: r = "label", ...i } = e;
  return /* @__PURE__ */ x.createElement(r, {
    className: "react-aria-Label",
    ...i,
    ref: n
  });
}), af = /* @__PURE__ */ O(null), v0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, af);
  let { value: r = 0, minValue: i = 0, maxValue: l = 100, isIndeterminate: o = !1 } = e;
  r = et(r, i, l);
  let [a, s] = Ft(!e["aria-label"] && !e["aria-labelledby"]), { progressBarProps: u, labelProps: d } = cm({
    ...e,
    label: s
  }), c = o ? void 0 : (r - i) / (l - i) * 100, f = le({
    ...e,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: c,
      valueText: u["aria-valuetext"],
      isIndeterminate: o
    }
  }), v = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...R(v, f, u),
    ref: n,
    slot: e.slot || void 0
  }, /* @__PURE__ */ x.createElement(Mt.Provider, {
    value: {
      ...d,
      ref: a,
      elementType: "span"
    }
  }, f.children));
}), gt = /* @__PURE__ */ O({}), b0 = /* @__PURE__ */ on(function(e, n) {
  [e, n] = ee(e, n, gt);
  let r = e, { isPending: i } = r, { buttonProps: l, isPressed: o } = Pu(e, n);
  l = $m(l, i);
  let { focusProps: a, isFocused: s, isFocusVisible: u } = Ne(e), { hoverProps: d, isHovered: c } = Fe({
    ...e,
    isDisabled: e.isDisabled || i
  }), f = {
    isHovered: c,
    isPressed: (r.isPressed || o) && !i,
    isFocused: s,
    isFocusVisible: u,
    isDisabled: e.isDisabled || !1,
    isPending: i ?? !1
  }, v = le({
    ...e,
    values: f,
    defaultClassName: "react-aria-Button"
  }), b = ae(l.id), p = ae(), h = l["aria-labelledby"];
  i && (h ? h = `${h} ${p}` : l["aria-label"] && (h = `${b} ${p}`));
  let $ = L(i);
  _(() => {
    let P = {
      "aria-labelledby": h || b
    };
    (!$.current && s && i || $.current && s && !i) && Dn(P, "assertive"), $.current = i;
  }, [
    i,
    s,
    h,
    b
  ]);
  let y = q(e, {
    global: !0
  });
  return delete y.onClick, /* @__PURE__ */ x.createElement("button", {
    ...R(y, v, l, a, d),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: l.type === "submit" && i ? "button" : l.type,
    id: b,
    ref: n,
    "aria-labelledby": h,
    slot: e.slot || void 0,
    "aria-disabled": i ? "true" : l["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": c || void 0,
    "data-focused": s || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ x.createElement(af.Provider, {
    value: {
      id: p
    }
  }, v.children));
});
function $m(t, e) {
  if (e) {
    for (const n in t) n.startsWith("on") && !(n.includes("Focus") || n.includes("Blur")) && (t[n] = void 0);
    t.href = void 0, t.target = void 0;
  }
  return t;
}
const It = /* @__PURE__ */ O({}), gm = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, It);
  let { elementType: r = "span", ...i } = e;
  return /* @__PURE__ */ x.createElement(r, {
    className: "react-aria-Text",
    ...i,
    ref: n
  });
});
class ml {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var n;
    return (n = this.keyMap.get(e)) !== null && n !== void 0 ? n : null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  getChildren(e) {
    let n = this.keyMap.get(e);
    return n?.childNodes || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let n = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && a.type === "section") for (let s of a.childNodes) n(s);
    };
    for (let a of e) n(a);
    let r = null, i = 0, l = 0;
    for (let [a, s] of this.keyMap)
      r ? (r.nextKey = a, s.prevKey = r.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = i++), (s.type === "section" || s.type === "item") && l++, r = s, r.nextKey = void 0;
    this._size = l;
    var o;
    this.lastKey = (o = r?.key) !== null && o !== void 0 ? o : null;
  }
}
class Be extends Set {
  constructor(e, n, r) {
    super(e), e instanceof Be ? (this.anchorKey = n ?? e.anchorKey, this.currentKey = r ?? e.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function ym(t, e) {
  if (t.size !== e.size) return !1;
  for (let n of t)
    if (!e.has(n)) return !1;
  return !0;
}
function li(t) {
  let { selectionMode: e = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: l = "all" } = t, o = L(!1), [, a] = W(!1), s = L(null), u = L(null), [, d] = W(null), c = z(() => hl(t.selectedKeys), [
    t.selectedKeys
  ]), f = z(() => hl(t.defaultSelectedKeys, new Be()), [
    t.defaultSelectedKeys
  ]), [v, b] = We(c, f, t.onSelectionChange), p = z(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), [h, $] = W(i);
  i === "replace" && h === "toggle" && typeof v == "object" && v.size === 0 && $("replace");
  let y = L(i);
  return _(() => {
    i !== y.current && ($(i), y.current = i);
  }, [
    i
  ]), {
    selectionMode: e,
    disallowEmptySelection: n,
    selectionBehavior: h,
    setSelectionBehavior: $,
    get isFocused() {
      return o.current;
    },
    setFocused(P) {
      o.current = P, a(P);
    },
    get focusedKey() {
      return s.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(P, S = "first") {
      s.current = P, u.current = S, d(P);
    },
    selectedKeys: v,
    setSelectedKeys(P) {
      (r || !ym(P, v)) && b(P);
    },
    disabledKeys: p,
    disabledBehavior: l
  };
}
function hl(t, e) {
  return t ? t === "all" ? "all" : new Be(t) : e;
}
class an {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, n) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(e);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = e.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!e || i && vr(this.collection, i, e) < 0) && (e = i);
    }
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!e || i && vr(this.collection, i, e) > 0) && (e = i);
    }
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new Be([
      n
    ], n, n);
    else {
      let o = this.state.selectedKeys;
      var i;
      let a = (i = o.anchorKey) !== null && i !== void 0 ? i : n;
      r = new Be(o, a, n);
      var l;
      for (let s of this.getKeyRange(a, (l = o.currentKey) !== null && l !== void 0 ? l : n)) r.delete(s);
      for (let s of this.getKeyRange(n, a)) this.canSelectItem(s) && r.add(s);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(e, n) {
    let r = this.collection.getItem(e), i = this.collection.getItem(n);
    return r && i ? vr(this.collection, r, i) <= 0 ? this.getKeyRangeInternal(e, n) : this.getKeyRangeInternal(n, e) : [];
  }
  getKeyRangeInternal(e, n) {
    var r;
    if (!((r = this.layoutDelegate) === null || r === void 0) && r.getKeyRange) return this.layoutDelegate.getKeyRange(e, n);
    let i = [], l = e;
    for (; l != null; ) {
      let o = this.collection.getItem(l);
      if (o && (o.type === "item" || o.type === "cell" && this.allowsCellSelection) && i.push(l), l === n) return i;
      l = this.collection.getKeyAfter(l);
    }
    return [];
  }
  getKey(e) {
    let n = this.collection.getItem(e);
    if (!n || n.type === "cell" && this.allowsCellSelection) return e;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let r = new Be(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(e);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new Be([
      n
    ], n, n) : new Be();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let n = new Be();
    for (let r of e) {
      let i = this.getKey(r);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let e = [], n = (r) => {
      for (; r != null; ) {
        if (this.canSelectItem(r)) {
          var i;
          let o = this.collection.getItem(r);
          o?.type === "item" && e.push(r);
          var l;
          o?.hasChildNodes && (this.allowsCellSelection || o.type !== "item") && n((l = (i = ap(sa(o, this.collection))) === null || i === void 0 ? void 0 : i.key) !== null && l !== void 0 ? l : null);
        }
        r = this.collection.getKeyAfter(r);
      }
    };
    return n(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new Be());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (e.size !== n.size) return !1;
    for (let r of e)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!e.has(r)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var n;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let r = this.collection.getItem(e);
    return !(!r || !(r == null || (n = r.props) === null || n === void 0) && n.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var n, r;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((r = this.collection.getItem(e)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.isDisabled));
  }
  isLink(e) {
    var n, r;
    return !!(!((r = this.collection.getItem(e)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.href);
  }
  getItemProps(e) {
    var n;
    return (n = this.collection.getItem(e)) === null || n === void 0 ? void 0 : n.props;
  }
  withCollection(e) {
    return new an(e, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0
    });
  }
  constructor(e, n, r) {
    this.collection = e, this.state = n;
    var i;
    this.allowsCellSelection = (i = r?.allowsCellSelection) !== null && i !== void 0 ? i : !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null;
  }
}
function xm(t) {
  let { filter: e, layoutDelegate: n } = t, r = li(t), i = z(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), l = j((u) => e ? new ml(e(u)) : new ml(u), [
    e
  ]), o = z(() => ({
    suppressTextValueWarning: t.suppressTextValueWarning
  }), [
    t.suppressTextValueWarning
  ]), a = aa(t, l, o), s = z(() => new an(a, r, {
    layoutDelegate: n
  }), [
    a,
    r,
    n
  ]);
  return sf(a, s), {
    collection: a,
    disabledKeys: i,
    selectionManager: s
  };
}
function Em(t, e) {
  let n = z(() => e ? t.collection.filter(e) : t.collection, [
    t.collection,
    e
  ]), r = t.selectionManager.withCollection(n);
  return sf(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: t.disabledKeys
  };
}
function sf(t, e) {
  const n = L(null);
  _(() => {
    if (e.focusedKey != null && !t.getItem(e.focusedKey) && n.current) {
      const d = n.current.getItem(e.focusedKey), c = [
        ...n.current.getKeys()
      ].map(($) => {
        const y = n.current.getItem($);
        return y?.type === "item" ? y : null;
      }).filter(($) => $ !== null), f = [
        ...t.getKeys()
      ].map(($) => {
        const y = t.getItem($);
        return y?.type === "item" ? y : null;
      }).filter(($) => $ !== null);
      var r, i;
      const v = ((r = c?.length) !== null && r !== void 0 ? r : 0) - ((i = f?.length) !== null && i !== void 0 ? i : 0);
      var l, o, a;
      let b = Math.min(v > 1 ? Math.max(((l = d?.index) !== null && l !== void 0 ? l : 0) - v + 1, 0) : (o = d?.index) !== null && o !== void 0 ? o : 0, ((a = f?.length) !== null && a !== void 0 ? a : 0) - 1), p = null, h = !1;
      for (; b >= 0; ) {
        if (!e.isDisabled(f[b].key)) {
          p = f[b];
          break;
        }
        if (b < f.length - 1 && !h) b++;
        else {
          h = !0;
          var s, u;
          b > ((s = d?.index) !== null && s !== void 0 ? s : 0) && (b = (u = d?.index) !== null && u !== void 0 ? u : 0), b--;
        }
      }
      e.setFocusedKey(p ? p.key : null);
    }
    n.current = t;
  }, [
    t,
    e
  ]);
}
function Wn(t) {
  let [e, n] = We(t.isOpen, t.defaultOpen || !1, t.onOpenChange);
  const r = j(() => {
    n(!0);
  }, [
    n
  ]), i = j(() => {
    n(!1);
  }, [
    n
  ]), l = j(() => {
    n(!e);
  }, [
    n,
    e
  ]);
  return {
    isOpen: e,
    setOpen: n,
    open: r,
    close: i,
    toggle: l
  };
}
function Pm(t) {
  let [e, n] = We(t.isExpanded, t.defaultExpanded || !1, t.onExpandedChange);
  const r = j(() => {
    n(!0);
  }, [
    n
  ]), i = j(() => {
    n(!1);
  }, [
    n
  ]), l = j(() => {
    n(!e);
  }, [
    n,
    e
  ]);
  return {
    isExpanded: e,
    setExpanded: n,
    expand: r,
    collapse: i,
    toggle: l
  };
}
function Dm(t) {
  let { allowsMultipleExpanded: e = !1, isDisabled: n = !1 } = t, [r, i] = We(z(() => t.expandedKeys ? new Set(t.expandedKeys) : void 0, [
    t.expandedKeys
  ]), z(() => t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    t.defaultExpandedKeys
  ]), t.onExpandedChange);
  return _(() => {
    if (!e && r.size > 1) {
      let l = r.values().next().value;
      l != null && i(/* @__PURE__ */ new Set([
        l
      ]));
    }
  }), {
    allowsMultipleExpanded: e,
    isDisabled: n,
    expandedKeys: r,
    setExpandedKeys: i,
    toggleKey(l) {
      let o;
      e ? (o = new Set(r), o.has(l) ? o.delete(l) : o.add(l)) : o = new Set(r.has(l) ? [] : [
        l
      ]), i(o);
    }
  };
}
function oi(t) {
  let e = Wn(t), [n, r] = W(null), [i, l] = W([]), o = () => {
    l([]), e.close();
  };
  return {
    focusStrategy: n,
    ...e,
    open(u = null) {
      r(u), e.open();
    },
    toggle(u = null) {
      r(u), e.toggle();
    },
    close() {
      o();
    },
    expandedKeysStack: i,
    openSubmenu: (u, d) => {
      l((c) => d > c.length ? c : [
        ...c.slice(0, d),
        u
      ]);
    },
    closeSubmenu: (u, d) => {
      l((c) => c[d] === u ? c.slice(0, d) : c);
    }
  };
}
function Sm(t, e) {
  let { triggerKey: n } = t, { expandedKeysStack: r, openSubmenu: i, closeSubmenu: l, close: o } = e, [a] = W(r?.length), s = z(() => r[a] === n, [
    r,
    n,
    a
  ]), [u, d] = W(null), c = j((b) => {
    d(b ?? null), i(n, a);
  }, [
    i,
    a,
    n
  ]), f = j(() => {
    d(null), l(n, a);
  }, [
    l,
    a,
    n
  ]), v = j((b) => {
    d(b ?? null), s ? f() : c(b);
  }, [
    f,
    c,
    s
  ]);
  return z(() => ({
    focusStrategy: u,
    isOpen: s,
    open: c,
    close: f,
    closeAll: o,
    submenuLevel: a,
    // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
    // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
    setOpen: () => {
    },
    toggle: v
  }), [
    s,
    c,
    f,
    o,
    u,
    v,
    a
  ]);
}
function Cm(t) {
  let [e, n] = We($l(t.value), $l(t.defaultValue) || "", t.onChange);
  return {
    value: e,
    setValue: n
  };
}
function $l(t) {
  if (t != null)
    return t.toString();
}
const wm = 1500, gl = 500;
let st = {}, Tm = 0, Ot = !1, Ve = null, ut = null;
function uf(t = {}) {
  let { delay: e = wm, closeDelay: n = gl } = t, { isOpen: r, open: i, close: l } = Wn(t), o = z(() => `${++Tm}`, []), a = L(null), s = L(l), u = () => {
    st[o] = f;
  }, d = () => {
    for (let b in st) b !== o && (st[b](!0), delete st[b]);
  }, c = () => {
    a.current && clearTimeout(a.current), a.current = null, d(), u(), Ot = !0, i(), Ve && (clearTimeout(Ve), Ve = null), ut && (clearTimeout(ut), ut = null);
  }, f = (b) => {
    b || n <= 0 ? (a.current && clearTimeout(a.current), a.current = null, s.current()) : a.current || (a.current = setTimeout(() => {
      a.current = null, s.current();
    }, n)), Ve && (clearTimeout(Ve), Ve = null), Ot && (ut && clearTimeout(ut), ut = setTimeout(() => {
      delete st[o], ut = null, Ot = !1;
    }, Math.max(gl, n)));
  }, v = () => {
    d(), u(), !r && !Ve && !Ot ? Ve = setTimeout(() => {
      Ve = null, Ot = !0, c();
    }, e) : r || c();
  };
  return _(() => {
    s.current = l;
  }, [
    l
  ]), _(() => () => {
    a.current && clearTimeout(a.current), st[o] && delete st[o];
  }, [
    o
  ]), {
    isOpen: r,
    open: (b) => {
      !b && e > 0 && !a.current ? v() : c();
    },
    close: f
  };
}
class km {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var n;
    return (n = this.keyMap.get(e)) !== null && n !== void 0 ? n : null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  constructor(e, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e, n = n || /* @__PURE__ */ new Set();
    let r = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && (a.type === "section" || n.has(a.key))) for (let s of a.childNodes) r(s);
    };
    for (let a of e) r(a);
    let i = null, l = 0;
    for (let [a, s] of this.keyMap)
      i ? (i.nextKey = a, s.prevKey = i.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = l++), i = s, i.nextKey = void 0;
    var o;
    this.lastKey = (o = i?.key) !== null && o !== void 0 ? o : null;
  }
}
function Bm(t) {
  let { onExpandedChange: e } = t, [n, r] = We(t.expandedKeys ? new Set(t.expandedKeys) : void 0, t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e), i = li(t), l = z(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), o = aa(t, j((s) => new km(s, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return _(() => {
    i.focusedKey != null && !o.getItem(i.focusedKey) && i.setFocusedKey(null);
  }, [
    o,
    i.focusedKey
  ]), {
    collection: o,
    expandedKeys: n,
    disabledKeys: l,
    toggleKey: (s) => {
      r(Fm(n, s));
    },
    setExpandedKeys: r,
    selectionManager: new an(o, i)
  };
}
function Fm(t, e) {
  let n = new Set(t);
  return n.has(e) ? n.delete(e) : n.add(e), n;
}
const sn = /* @__PURE__ */ O(null), p0 = /* @__PURE__ */ ie(function(e, n) {
  let r = H(sn);
  return r?.isInvalid ? /* @__PURE__ */ x.createElement(Km, {
    ...e,
    ref: n
  }) : null;
}), Km = /* @__PURE__ */ ie((t, e) => {
  let n = H(sn), r = q(t, {
    global: !0
  }), i = le({
    ...t,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return i.children == null ? null : /* @__PURE__ */ x.createElement(gm, {
    slot: "errorMessage",
    ...r,
    ...i,
    ref: e
  });
}), Gn = /* @__PURE__ */ O(null), Lm = /* @__PURE__ */ O(null), m0 = /* @__PURE__ */ ie(function(e, n) {
  let { inputRef: r = null, ...i } = e;
  [e, n] = ee(i, n, Ff);
  let { validationBehavior: l } = mt(Gn) || {};
  var o, a;
  let s = (a = (o = e.validationBehavior) !== null && o !== void 0 ? o : l) !== null && a !== void 0 ? a : "native", u = H(Lm), d = Ie(z(() => tn(r, e.inputRef !== void 0 ? e.inputRef : null), [
    r,
    e.inputRef
  ])), { labelProps: c, inputProps: f, isSelected: v, isDisabled: b, isReadOnly: p, isPressed: h, isInvalid: $ } = u ? Xp({
    ...qt(e),
    // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
    // it's passed explicitly here to avoid typescript error (requires ignore).
    // @ts-ignore
    value: e.value,
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, u, d) : Su({
    ...qt(e),
    children: typeof e.children == "function" ? !0 : e.children,
    validationBehavior: s
  }, ni(e), d), { isFocused: y, isFocusVisible: P, focusProps: S } = Ne(), A = b || p, { hoverProps: w, isHovered: M } = Fe({
    ...e,
    isDisabled: A
  }), T = le({
    ...e,
    defaultClassName: "react-aria-Checkbox",
    values: {
      isSelected: v,
      isIndeterminate: e.isIndeterminate || !1,
      isPressed: h,
      isHovered: M,
      isFocused: y,
      isFocusVisible: P,
      isDisabled: b,
      isReadOnly: p,
      isInvalid: $,
      isRequired: e.isRequired || !1
    }
  }), N = q(e, {
    global: !0
  });
  return delete N.id, delete N.onClick, /* @__PURE__ */ x.createElement("label", {
    ...R(N, c, w, T),
    ref: n,
    slot: e.slot || void 0,
    "data-selected": v || void 0,
    "data-indeterminate": e.isIndeterminate || void 0,
    "data-pressed": h || void 0,
    "data-hovered": M || void 0,
    "data-focused": y || void 0,
    "data-focus-visible": P || void 0,
    "data-disabled": b || void 0,
    "data-readonly": p || void 0,
    "data-invalid": $ || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ x.createElement(Zo, {
    elementType: "span"
  }, /* @__PURE__ */ x.createElement("input", {
    ...R(f, S),
    ref: d
  })), T.children);
}), qn = /* @__PURE__ */ O({}), h0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, qn);
  let { isDisabled: r, isInvalid: i, isReadOnly: l, onHoverStart: o, onHoverChange: a, onHoverEnd: s, ...u } = e, { hoverProps: d, isHovered: c } = Fe({
    onHoverStart: o,
    onHoverChange: a,
    onHoverEnd: s,
    isDisabled: r
  }), { isFocused: f, isFocusVisible: v, focusProps: b } = Ne({
    within: !0
  });
  r ?? (r = !!e["aria-disabled"] && e["aria-disabled"] !== "false"), i ?? (i = !!e["aria-invalid"] && e["aria-invalid"] !== "false");
  let p = le({
    ...e,
    values: {
      isHovered: c,
      isFocusWithin: f,
      isFocusVisible: v,
      isDisabled: r,
      isInvalid: i
    },
    defaultClassName: "react-aria-Group"
  });
  var h, $;
  return /* @__PURE__ */ x.createElement("div", {
    ...R(u, b, d),
    ...p,
    ref: n,
    role: (h = e.role) !== null && h !== void 0 ? h : "group",
    slot: ($ = e.slot) !== null && $ !== void 0 ? $ : void 0,
    "data-focus-within": f || void 0,
    "data-hovered": c || void 0,
    "data-focus-visible": v || void 0,
    "data-disabled": r || void 0,
    "data-invalid": i || void 0,
    "data-readonly": l || void 0
  }, p.children);
}), Yn = /* @__PURE__ */ O({});
let Mm = (t) => {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, ...i } = t;
  return i;
};
const $0 = /* @__PURE__ */ on(function(e, n) {
  [e, n] = ee(e, n, Yn);
  let { hoverProps: r, isHovered: i } = Fe(e), { isFocused: l, isFocusVisible: o, focusProps: a } = Ne({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), s = !!e["aria-invalid"] && e["aria-invalid"] !== "false", u = le({
    ...e,
    values: {
      isHovered: i,
      isFocused: l,
      isFocusVisible: o,
      isDisabled: e.disabled || !1,
      isInvalid: s
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ x.createElement("input", {
    ...R(Mm(e), a, r),
    ...u,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": i || void 0,
    "data-focus-visible": o || void 0,
    "data-invalid": s || void 0
  });
}), df = /* @__PURE__ */ O({}), g0 = /* @__PURE__ */ Kt(Bs, function(e, n) {
  return [e, n] = ee(e, n, df), /* @__PURE__ */ x.createElement("header", {
    className: "react-aria-Header",
    ...e,
    ref: n
  }, e.children);
}), Im = /* @__PURE__ */ O(null);
function cf(t) {
  let e = L({});
  return /* @__PURE__ */ x.createElement(Im.Provider, {
    value: e
  }, t.children);
}
const ai = /* @__PURE__ */ O({
  isSelected: !1
}), ff = /* @__PURE__ */ O({});
class vf extends $t {
  filter(e, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let i = this.clone();
      return n.addDescendants(i, e), i;
    }
    return null;
  }
}
vf.type = "separator";
const y0 = /* @__PURE__ */ Kt(vf, function(e, n) {
  [e, n] = ee(e, n, ff);
  let { elementType: r, orientation: i, style: l, className: o, slot: a, ...s } = e, u = r || "hr";
  u === "hr" && i === "vertical" && (u = "div");
  let { separatorProps: d } = fm({
    ...s,
    elementType: r,
    orientation: i
  }), c = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement(u, {
    ...R(c, d),
    style: l,
    className: o ?? "react-aria-Separator",
    ref: n,
    slot: a || void 0
  });
}), At = /* @__PURE__ */ O(null);
Kt(Fs, function(e, n, r) {
  let i = H(At), { isLoading: l, onLoadMore: o, scrollOffset: a, ...s } = e, u = L(null), d = z(() => ({
    onLoadMore: o,
    collection: i?.collection,
    sentinelRef: u,
    scrollOffset: a
  }), [
    o,
    a,
    i?.collection
  ]);
  mv(d, u);
  let c = le({
    ...s,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: null
  }), f = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: hv(!0)
  }, /* @__PURE__ */ x.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: u,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), l && c.children && /* @__PURE__ */ x.createElement("div", {
    ...R(q(e, {
      global: !0
    }), f),
    ...c,
    // aria-selected isn't needed here since this option is not selectable.
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    role: "option",
    ref: n
  }, c.children));
});
const bf = /* @__PURE__ */ O({
  placement: "bottom"
}), Xn = /* @__PURE__ */ O(null), yl = /* @__PURE__ */ O(null), x0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, Xn);
  let r = H(rt), i = Wn(e), l = e.isOpen != null || e.defaultOpen != null || !r ? i : r, o = Pn(n, l.isOpen) || e.isExiting || !1, a = Fp(), { direction: s } = Ae();
  if (a) {
    let u = e.children;
    return typeof u == "function" && (u = u({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ x.createElement(x.Fragment, null, u);
  }
  return l && !l.isOpen && !o ? null : /* @__PURE__ */ x.createElement(Am, {
    ...e,
    triggerRef: e.triggerRef,
    state: l,
    popoverRef: n,
    isExiting: o,
    dir: s
  });
});
function Am({ state: t, isExiting: e, UNSTABLE_portalContainer: n, clearContexts: r, ...i }) {
  let l = L(null), o = L(null), a = H(yl), s = a && i.trigger === "SubmenuTrigger";
  var u;
  let { popoverProps: d, underlayProps: c, arrowProps: f, placement: v, triggerAnchorPoint: b } = Zb({
    ...i,
    offset: (u = i.offset) !== null && u !== void 0 ? u : 8,
    arrowRef: l,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: s ? a : o
  }, t), p = i.popoverRef, h = zn(p, !!v) || i.isEntering || !1, $ = le({
    ...i,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: i.trigger || null,
      placement: v,
      isEntering: h,
      isExiting: e
    }
  }), y = !i.isNonModal || i.trigger === "SubmenuTrigger", [P, S] = W(!1);
  X(() => {
    p.current && S(y && !p.current.querySelector("[role=dialog]"));
  }, [
    p,
    y
  ]), _(() => {
    P && i.trigger !== "SubmenuTrigger" && p.current && !p.current.contains(document.activeElement) && $e(p.current);
  }, [
    P,
    p,
    i.trigger
  ]);
  let A = z(() => {
    let N = $.children;
    if (r) for (let I of r) N = /* @__PURE__ */ x.createElement(I.Provider, {
      value: null
    }, N);
    return N;
  }, [
    $.children,
    r
  ]), w = {
    ...d.style,
    "--trigger-anchor-point": b ? `${b.x}px ${b.y}px` : void 0,
    ...$.style
  }, M = /* @__PURE__ */ x.createElement("div", {
    ...R(q(i, {
      global: !0
    }), d),
    ...$,
    role: P ? "dialog" : void 0,
    tabIndex: P ? -1 : void 0,
    "aria-label": i["aria-label"],
    "aria-labelledby": i["aria-labelledby"],
    ref: p,
    slot: i.slot || void 0,
    style: w,
    dir: i.dir,
    "data-trigger": i.trigger,
    "data-placement": v,
    "data-entering": h || void 0,
    "data-exiting": e || void 0
  }, !i.isNonModal && /* @__PURE__ */ x.createElement(Kr, {
    onDismiss: t.close
  }), /* @__PURE__ */ x.createElement(bf.Provider, {
    value: {
      ...f,
      placement: v,
      ref: l
    }
  }, A), /* @__PURE__ */ x.createElement(Kr, {
    onDismiss: t.close
  }));
  if (!s) return /* @__PURE__ */ x.createElement(Lr, {
    ...i,
    shouldContainFocus: P,
    isExiting: e,
    portalContainer: n
  }, !i.isNonModal && t.isOpen && /* @__PURE__ */ x.createElement("div", {
    "data-testid": "underlay",
    ...c,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ x.createElement("div", {
    ref: o,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ x.createElement(yl.Provider, {
    value: o
  }, M)));
  var T;
  return /* @__PURE__ */ x.createElement(Lr, {
    ...i,
    shouldContainFocus: P,
    isExiting: e,
    portalContainer: (T = n ?? a?.current) !== null && T !== void 0 ? T : void 0
  }, M);
}
const Nm = /* @__PURE__ */ O({}), si = /* @__PURE__ */ O(null), Zn = /* @__PURE__ */ O(null), en = /* @__PURE__ */ O(null), In = /* @__PURE__ */ O(null);
function E0(t) {
  let e = oi(t), n = L(null), { menuTriggerProps: r, menuProps: i } = bp({
    ...t,
    type: "menu"
  }, e, n), [l, o] = W(null), a = j(() => {
    n.current && o(n.current.offsetWidth + "px");
  }, [
    n
  ]);
  Wt({
    ref: n,
    onResize: a
  });
  let s = L(null);
  return /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        si,
        {
          ...i,
          ref: s
        }
      ],
      [
        rt,
        e
      ],
      [
        en,
        e
      ],
      [
        Xn,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: s,
          placement: "bottom start",
          style: {
            "--trigger-width": l
          },
          "aria-labelledby": i["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(io, {
    ...r,
    ref: n,
    isPressed: e.isOpen
  }, t.children));
}
const pf = /* @__PURE__ */ O(null);
class mf extends $t {
  filter(e, n, r) {
    let i = e.getItem(this.firstChildKey);
    if (i && r(i.textValue, this)) {
      let l = this.clone();
      return n.addDescendants(l, e), l;
    }
    return null;
  }
}
mf.type = "submenutrigger";
const P0 = /* @__PURE__ */ Rs(mf, (t, e, n) => {
  let { CollectionBranch: r } = H(Lt), i = H(Zn), l = H(en), o = Sm({
    triggerKey: n.key
  }, l), a = L(null), s = Ie(e), { parentMenuRef: u, shouldUseVirtualFocus: d } = H(pf), { submenuTriggerProps: c, submenuProps: f, popoverProps: v } = xp({
    parentMenuRef: u,
    submenuRef: a,
    delay: t.delay,
    shouldUseVirtualFocus: d
  }, o, s);
  return /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        An,
        {
          ...c,
          onAction: void 0,
          ref: s
        }
      ],
      [
        si,
        {
          ref: a,
          ...f
        }
      ],
      [
        rt,
        o
      ],
      [
        Xn,
        {
          trigger: "SubmenuTrigger",
          triggerRef: s,
          placement: "end top",
          "aria-labelledby": f["aria-labelledby"],
          ...v
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(r, {
    collection: i.collection,
    parent: n
  }), t.children[1]);
}, (t) => t.children[0]), D0 = /* @__PURE__ */ ie(function(e, n) {
  return [e, n] = ee(e, n, si), /* @__PURE__ */ x.createElement(ei, {
    content: /* @__PURE__ */ x.createElement(ti, e)
  }, (r) => /* @__PURE__ */ x.createElement(Rm, {
    props: e,
    collection: r,
    menuRef: n
  }));
});
function Rm({ props: t, collection: e, menuRef: n }) {
  [t, n] = ee(t, n, $r);
  let { filter: r, ...i } = t, l = z(() => r ? e.filter(r) : e, [
    e,
    r
  ]), o = Bm({
    ...t,
    collection: l,
    children: void 0
  }), a = H(en), { isVirtualized: s, CollectionRoot: u } = H(Lt), { menuProps: d } = pp({
    ...t,
    isVirtualized: s,
    onClose: t.onClose || a?.close
  }, o, n), c = le({
    defaultClassName: "react-aria-Menu",
    className: t.className,
    style: t.style,
    values: {
      isEmpty: o.collection.size === 0
    }
  }), f = null;
  o.collection.size === 0 && t.renderEmptyState && (f = /* @__PURE__ */ x.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState()));
  let v = q(t, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement(oo, null, /* @__PURE__ */ x.createElement("div", {
    ...R(v, c, d),
    ref: n,
    slot: t.slot || void 0,
    "data-empty": o.collection.size === 0 || void 0,
    onScroll: t.onScroll
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Zn,
        o
      ],
      [
        ff,
        {
          elementType: "div"
        }
      ],
      [
        Hp,
        {
          name: "MenuSection",
          render: hf
        }
      ],
      [
        pf,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: i?.shouldUseVirtualFocus
        }
      ],
      [
        An,
        null
      ],
      [
        $r,
        null
      ],
      [
        Rr,
        null
      ],
      [
        In,
        o.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        en,
        a ?? oi({})
      ]
    ]
  }, /* @__PURE__ */ x.createElement(cf, null, /* @__PURE__ */ x.createElement(u, {
    collection: o.collection,
    persistedKeys: zs(o.selectionManager.focusedKey),
    scrollRef: n
  }))), f));
}
class Om extends an {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(e, n) {
    return this.parent.setFocusedKey(e, n);
  }
  setFocused(e) {
    this.parent.setFocused(e);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(e, n) {
    super(e.collection, n), this.parent = e;
  }
}
function hf(t, e, n, r = "react-aria-MenuSection") {
  var i, l;
  let o = H(Zn), { CollectionBranch: a } = H(Lt), [s, u] = Ft();
  var d;
  let { headingProps: c, groupProps: f } = hp({
    heading: u,
    "aria-label": (d = n.props["aria-label"]) !== null && d !== void 0 ? d : void 0
  }), v = le({
    defaultClassName: r,
    className: (i = n.props) === null || i === void 0 ? void 0 : i.className,
    style: (l = n.props) === null || l === void 0 ? void 0 : l.style,
    values: {}
  }), b = H(In), p = li(t), h = t.selectionMode != null ? new Om(b, p) : b, $ = q(t, {
    global: !0
  });
  return delete $.id, /* @__PURE__ */ x.createElement("section", {
    ...R($, v, f),
    ref: e
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        df,
        {
          ...c,
          ref: s
        }
      ],
      [
        In,
        h
      ]
    ]
  }, /* @__PURE__ */ x.createElement(a, {
    collection: o.collection,
    parent: n
  })));
}
const S0 = /* @__PURE__ */ Rs(Ks, hf), An = /* @__PURE__ */ O(null), C0 = /* @__PURE__ */ Kt(Qr, function(e, n, r) {
  var i;
  [e, n] = ee(e, n, An);
  let l = (i = mt(An)) === null || i === void 0 ? void 0 : i.id, o = H(Zn), a = Ie(n), s = H(In), { menuItemProps: u, labelProps: d, descriptionProps: c, keyboardShortcutProps: f, ...v } = mp({
    ...e,
    id: l,
    key: r.key,
    selectionManager: s
  }, o, a), { hoverProps: b, isHovered: p } = Fe({
    isDisabled: v.isDisabled
  }), h = le({
    ...e,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...v,
      isHovered: p,
      isFocusVisible: v.isFocusVisible,
      selectionMode: s.selectionMode,
      selectionBehavior: s.selectionBehavior,
      hasSubmenu: !!e["aria-haspopup"],
      isOpen: e["aria-expanded"] === "true"
    }
  }), $ = e.href ? "a" : "div", y = q(e, {
    global: !0
  });
  return delete y.id, delete y.onClick, /* @__PURE__ */ x.createElement($, {
    ...R(y, h, u, b),
    ref: a,
    "data-disabled": v.isDisabled || void 0,
    "data-hovered": p || void 0,
    "data-focused": v.isFocused || void 0,
    "data-focus-visible": v.isFocusVisible || void 0,
    "data-pressed": v.isPressed || void 0,
    "data-selected": v.isSelected || void 0,
    "data-selection-mode": s.selectionMode === "none" ? void 0 : s.selectionMode,
    "data-has-submenu": !!e["aria-haspopup"] || void 0,
    "data-open": e["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        It,
        {
          slots: {
            [Gt]: d,
            label: d,
            description: c
          }
        }
      ],
      [
        Nm,
        f
      ],
      [
        ai,
        {
          isSelected: v.isSelected
        }
      ]
    ]
  }, h.children));
}), $f = /* @__PURE__ */ O(null), rt = /* @__PURE__ */ O(null);
function w0(t) {
  let e = oi(t), n = L(null), { triggerProps: r, overlayProps: i } = vo({
    type: "dialog"
  }, e, n), [l, o] = W(null), a = j(() => {
    n.current && o(n.current.offsetWidth + "px");
  }, [
    n
  ]);
  return Wt({
    ref: n,
    onResize: a
  }), r.id = ae(), i["aria-labelledby"] = r.id, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        rt,
        e
      ],
      [
        en,
        e
      ],
      [
        $f,
        i
      ],
      [
        Xn,
        {
          trigger: "DialogTrigger",
          triggerRef: n,
          "aria-labelledby": i["aria-labelledby"],
          style: {
            "--trigger-width": l
          }
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(io, {
    ...r,
    ref: n,
    isPressed: e.isOpen
  }, t.children));
}
const T0 = /* @__PURE__ */ ie(function(e, n) {
  let r = e["aria-labelledby"];
  [e, n] = ee(e, n, $f);
  let { dialogProps: i, titleProps: l } = nm({
    ...e,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": r
  }, n), o = H(rt);
  !i["aria-label"] && !i["aria-labelledby"] && (e["aria-labelledby"] ? i["aria-labelledby"] = e["aria-labelledby"] : process.env.NODE_ENV !== "production" && console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let a = le({
    defaultClassName: "react-aria-Dialog",
    className: e.className,
    style: e.style,
    children: e.children,
    values: {
      close: o?.close || (() => {
      })
    }
  }), s = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("section", {
    ...R(s, a, i),
    ref: n,
    slot: e.slot || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Dl,
        {
          slots: {
            [Gt]: {},
            title: {
              ...l,
              level: 2
            }
          }
        }
      ],
      [
        gt,
        {
          slots: {
            [Gt]: {},
            close: {
              onPress: () => o?.close()
            }
          }
        }
      ]
    ]
  }, a.children));
}), gf = /* @__PURE__ */ O(null), k0 = /* @__PURE__ */ ie(function(e, n) {
  let r = Dm(e), i = le({
    ...e,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  }), l = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...l,
    ...i,
    ref: n,
    "data-disabled": e.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement(gf.Provider, {
    value: r
  }, i.children));
}), Vm = /* @__PURE__ */ O(null), zm = /* @__PURE__ */ O(null), yf = /* @__PURE__ */ O(null), B0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, Vm);
  let r = H(gf), { id: i, ...l } = e, o = ae();
  i || (i = o);
  let a = r ? r.expandedKeys.has(i) : e.isExpanded, s = Pm({
    ...e,
    isExpanded: a,
    onExpandedChange($) {
      var y;
      r && r.toggleKey(i), (y = e.onExpandedChange) === null || y === void 0 || y.call(e, $);
    }
  }), u = x.useRef(null), d = e.isDisabled || r?.isDisabled || !1, { buttonProps: c, panelProps: f } = rm({
    ...e,
    isExpanded: a,
    isDisabled: d
  }, s, u), { isFocusVisible: v, focusProps: b } = Ne({
    within: !0
  }), p = le({
    ...e,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: s.isExpanded,
      isDisabled: d,
      isFocusVisibleWithin: v,
      state: s
    }
  }), h = q(l, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        gt,
        {
          slots: {
            [Gt]: {},
            trigger: c
          }
        }
      ],
      [
        yf,
        {
          panelProps: f,
          panelRef: u
        }
      ],
      [
        zm,
        s
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...R(h, p, b),
    ref: n,
    "data-expanded": s.isExpanded || void 0,
    "data-disabled": d || void 0,
    "data-focus-visible-within": v || void 0
  }, p.children));
}), F0 = /* @__PURE__ */ ie(function(e, n) {
  let { role: r = "group" } = e, { panelProps: i, panelRef: l } = H(yf), { isFocusVisible: o, focusProps: a } = Ne({
    within: !0
  }), s = le({
    ...e,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin: o
    }
  }), u = q(e, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...R(u, s, i, a),
    ref: tn(n, l),
    role: r,
    "data-focus-visible-within": o || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        gt,
        null
      ]
    ]
  }, e.children));
}), K0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, Dl);
  let { children: r, level: i = 3, className: l, ...o } = e, a = `h${i}`;
  return /* @__PURE__ */ x.createElement(a, {
    ...o,
    ref: n,
    className: l ?? "react-aria-Heading"
  }, r);
}), Hm = /* @__PURE__ */ O(null), ui = /* @__PURE__ */ O(null), L0 = /* @__PURE__ */ ie(function(e, n) {
  if (H(ui)) {
    if (process.env.NODE_ENV !== "production" && (e.onOpenChange || e.defaultOpen !== void 0 || e.isOpen !== void 0)) {
      const p = /* @__PURE__ */ new Set([
        "isDismissable",
        "isKeyboardDismissDisabled",
        "isOpen",
        "defaultOpen",
        "onOpenChange",
        "isEntering",
        "isExiting",
        "UNSTABLE_portalContainer",
        "shouldCloseOnInteractOutside"
      ]), h = Object.keys(e).filter(($) => p.has($));
      console.warn(`This modal is already wrapped in a ModalOverlay, props [${h.join(", ")}] should be placed on the ModalOverlay instead.`);
    }
    return /* @__PURE__ */ x.createElement(xl, {
      ...e,
      modalRef: n
    }, e.children);
  }
  let { isDismissable: i, isKeyboardDismissDisabled: l, isOpen: o, defaultOpen: a, onOpenChange: s, children: u, isEntering: d, isExiting: c, UNSTABLE_portalContainer: f, shouldCloseOnInteractOutside: v, ...b } = e;
  return /* @__PURE__ */ x.createElement(Um, {
    isDismissable: i,
    isKeyboardDismissDisabled: l,
    isOpen: o,
    defaultOpen: a,
    onOpenChange: s,
    isEntering: d,
    isExiting: c,
    UNSTABLE_portalContainer: f,
    shouldCloseOnInteractOutside: v
  }, /* @__PURE__ */ x.createElement(xl, {
    ...b,
    modalRef: n
  }, u));
});
function _m(t, e) {
  [t, e] = ee(t, e, Hm);
  let n = H(rt), r = Wn(t), i = t.isOpen != null || t.defaultOpen != null || !n ? r : n;
  i === n && process.env.NODE_ENV !== "production" && (t.onOpenChange || t.defaultOpen !== void 0 || t.isOpen !== void 0) && console.warn("This modals state is controlled by a trigger, place onOpenChange on the trigger instead.");
  let l = Ie(e), o = L(null), a = Pn(l, i.isOpen), s = Pn(o, i.isOpen), u = a || s || t.isExiting || !1, d = Me();
  return !i.isOpen && !u || d ? null : /* @__PURE__ */ x.createElement(jm, {
    ...t,
    state: i,
    isExiting: u,
    overlayRef: l,
    modalRef: o
  });
}
const Um = /* @__PURE__ */ ie(_m);
function jm({ UNSTABLE_portalContainer: t, ...e }) {
  let n = e.modalRef, { state: r } = e, { modalProps: i, underlayProps: l } = Jb(e, r, n), o = zn(e.overlayRef) || e.isEntering || !1, a = le({
    ...e,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: o,
      isExiting: e.isExiting,
      state: r
    }
  }), s = vv(), u;
  if (typeof document < "u") {
    let c = bt(document.body) ? document.body : document.scrollingElement || document.documentElement, f = c.getBoundingClientRect().height % 1;
    u = c.scrollHeight - f;
  }
  let d = {
    ...a.style,
    "--visual-viewport-height": s.height + "px",
    "--page-height": u !== void 0 ? u + "px" : void 0
  };
  return /* @__PURE__ */ x.createElement(Lr, {
    isExiting: e.isExiting,
    portalContainer: t
  }, /* @__PURE__ */ x.createElement("div", {
    ...R(q(e, {
      global: !0
    }), l),
    ...a,
    style: d,
    ref: e.overlayRef,
    "data-entering": o || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        ui,
        {
          modalProps: i,
          modalRef: n,
          isExiting: e.isExiting,
          isDismissable: e.isDismissable
        }
      ],
      [
        rt,
        r
      ]
    ]
  }, a.children)));
}
function xl(t) {
  let { modalProps: e, modalRef: n, isExiting: r, isDismissable: i } = H(ui), l = H(rt), o = z(() => tn(t.modalRef, n), [
    t.modalRef,
    n
  ]), a = Ie(o), s = zn(a), u = le({
    ...t,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: s,
      isExiting: r,
      state: l
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...R(q(t, {
      global: !0
    }), e),
    ...u,
    ref: a,
    "data-entering": s || void 0,
    "data-exiting": r || void 0
  }, i && /* @__PURE__ */ x.createElement(Kr, {
    onDismiss: l.close
  }), u.children);
}
const Wm = /* @__PURE__ */ O(null), Gm = /* @__PURE__ */ O(null), M0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, Wm);
  let { validationBehavior: r } = mt(Gn) || {};
  var i, l;
  let o = (l = (i = e.validationBehavior) !== null && i !== void 0 ? i : r) !== null && l !== void 0 ? l : "native", { locale: a } = Ae(), s = Zp({
    ...e,
    locale: a,
    validationBehavior: o
  }), u = L(null), [d, c] = Ft(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: f, groupProps: v, inputProps: b, incrementButtonProps: p, decrementButtonProps: h, descriptionProps: $, errorMessageProps: y, ...P } = tm({
    ...qt(e),
    label: c,
    validationBehavior: o
  }, s, u), S = le({
    ...e,
    values: {
      state: s,
      isDisabled: e.isDisabled || !1,
      isInvalid: P.isInvalid || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), A = q(e, {
    global: !0
  });
  return delete A.id, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Gm,
        s
      ],
      [
        qn,
        v
      ],
      [
        Yn,
        {
          ...b,
          ref: u
        }
      ],
      [
        Mt,
        {
          ...f,
          ref: d
        }
      ],
      [
        gt,
        {
          slots: {
            increment: p,
            decrement: h
          }
        }
      ],
      [
        It,
        {
          slots: {
            description: $,
            errorMessage: y
          }
        }
      ],
      [
        sn,
        P
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...A,
    ...S,
    ref: n,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-required": e.isRequired || void 0,
    "data-invalid": P.isInvalid || void 0
  }), e.name && /* @__PURE__ */ x.createElement("input", {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: isNaN(s.numberValue) ? "" : s.numberValue,
    disabled: e.isDisabled || void 0
  }));
}), qm = /* @__PURE__ */ O(null), I0 = /* @__PURE__ */ on(function(e, n) {
  [e, n] = ee(e, n, qm);
  let { validationBehavior: r } = mt(Gn) || {};
  var i, l;
  let o = (l = (i = e.validationBehavior) !== null && i !== void 0 ? i : r) !== null && l !== void 0 ? l : "native", a = L(null);
  [e, a] = ee(e, a, Rr);
  let [s, u] = Ft(!e["aria-label"] && !e["aria-labelledby"]), d = Cm({
    ...e,
    validationBehavior: o
  }), { labelProps: c, inputProps: f, clearButtonProps: v, descriptionProps: b, errorMessageProps: p, ...h } = wp({
    ...qt(e),
    label: u,
    validationBehavior: o
  }, d, a), $ = le({
    ...e,
    values: {
      isEmpty: d.value === "",
      isDisabled: e.isDisabled || !1,
      isInvalid: h.isInvalid || !1,
      state: d
    },
    defaultClassName: "react-aria-SearchField"
  }), y = q(e, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ x.createElement("div", {
    ...y,
    ...$,
    ref: n,
    slot: e.slot || void 0,
    "data-empty": d.value === "" || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": h.isInvalid || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Mt,
        {
          ...c,
          ref: s
        }
      ],
      [
        Yn,
        {
          ...f,
          ref: a
        }
      ],
      [
        gt,
        v
      ],
      [
        It,
        {
          slots: {
            description: b,
            errorMessage: p
          }
        }
      ],
      [
        qn,
        {
          isInvalid: h.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        sn,
        h
      ]
    ]
  }, $.children));
}), Ym = /* @__PURE__ */ O(null), xf = /* @__PURE__ */ O(null), A0 = /* @__PURE__ */ ie(function(e, n) {
  return [e, n] = ee(e, n, Ym), /* @__PURE__ */ x.createElement(At.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(ei, {
    content: e.children
  }, (r) => /* @__PURE__ */ x.createElement(Xm, {
    props: e,
    forwardedRef: n,
    collection: r
  })));
});
function Xm({ props: t, forwardedRef: e, collection: n }) {
  let r = L(null), { id: i, ...l } = t;
  [l, r] = ee(l, r, $r);
  let { filter: o, shouldUseVirtualFocus: a, ...s } = l, [u, d] = Ft(!t["aria-label"] && !t["aria-labelledby"]), c = xm({
    ...s,
    children: void 0,
    collection: n
  }), f = Em(c, o), v = q(l, {
    global: !0
  }), b = Object.fromEntries(Object.entries(v).map(([S, A]) => [
    S,
    S === "id" ? A : void 0
  ])), { gridProps: p, labelProps: h, descriptionProps: $, errorMessageProps: y } = vm({
    ...s,
    ...b,
    label: d
  }, f, r);
  var P;
  return /* @__PURE__ */ x.createElement("div", {
    ...v,
    id: i,
    ref: e,
    slot: t.slot || void 0,
    className: (P = t.className) !== null && P !== void 0 ? P : "react-aria-TagGroup",
    style: t.style
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Mt,
        {
          ...h,
          elementType: "span",
          ref: u
        }
      ],
      [
        xf,
        {
          ...p,
          ref: r
        }
      ],
      [
        At,
        f
      ],
      [
        It,
        {
          slots: {
            description: $,
            errorMessage: y
          }
        }
      ]
    ]
  }, t.children));
}
const N0 = /* @__PURE__ */ ie(function(e, n) {
  return H(At) ? /* @__PURE__ */ x.createElement(Zm, {
    props: e,
    forwardedRef: n
  }) : /* @__PURE__ */ x.createElement(ti, e);
});
function Zm({ props: t, forwardedRef: e }) {
  let n = H(At), { CollectionRoot: r } = H(Lt), [i, l] = ee({}, e, xf), { focusProps: o, isFocused: a, isFocusVisible: s } = Ne(), u = {
    isEmpty: n.collection.size === 0,
    isFocused: a,
    isFocusVisible: s,
    state: n
  }, d = le({
    className: t.className,
    style: t.style,
    defaultClassName: "react-aria-TagList",
    values: u
  }), c = zs(n.selectionManager.focusedKey), f = q(t, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...R(f, d, i, o),
    ref: l,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": a || void 0,
    "data-focus-visible": s || void 0
  }, /* @__PURE__ */ x.createElement(cf, null, n.collection.size === 0 && t.renderEmptyState ? t.renderEmptyState(u) : /* @__PURE__ */ x.createElement(r, {
    collection: n.collection,
    persistedKeys: c
  })));
}
const R0 = /* @__PURE__ */ Kt(Qr, (t, e, n) => {
  let r = H(At), i = Ie(e), { focusProps: l, isFocusVisible: o } = Ne({
    within: !1
  }), { rowProps: a, gridCellProps: s, removeButtonProps: u, ...d } = pm({
    item: n
  }, r, i), { hoverProps: c, isHovered: f } = Fe({
    isDisabled: !d.allowsSelection,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), v = le({
    ...t,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...d,
      isFocusVisible: o,
      isHovered: f,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior
    }
  });
  _(() => {
    !n.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]);
  let b = q(t, {
    global: !0
  });
  return delete b.id, delete b.onClick, /* @__PURE__ */ x.createElement("div", {
    ref: i,
    ...R(b, v, a, l, c),
    "data-selected": d.isSelected || void 0,
    "data-disabled": d.isDisabled || void 0,
    "data-hovered": f || void 0,
    "data-focused": d.isFocused || void 0,
    "data-focus-visible": o || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-allows-removing": d.allowsRemoving || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ x.createElement("div", {
    ...s,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        gt,
        {
          slots: {
            remove: u
          }
        }
      ],
      [
        Lt,
        Vs
      ],
      [
        ai,
        {
          isSelected: d.isSelected
        }
      ]
    ]
  }, v.children)));
}), Jm = /* @__PURE__ */ O({}), Qm = /* @__PURE__ */ O(null), O0 = /* @__PURE__ */ on(function(e, n) {
  [e, n] = ee(e, n, Qm);
  let { validationBehavior: r } = mt(Gn) || {};
  var i, l;
  let o = (l = (i = e.validationBehavior) !== null && i !== void 0 ? i : r) !== null && l !== void 0 ? l : "native", a = L(null);
  [e, a] = ee(e, a, Rr);
  let [s, u] = Ft(!e["aria-label"] && !e["aria-labelledby"]), [d, c] = W("input"), { labelProps: f, inputProps: v, descriptionProps: b, errorMessageProps: p, ...h } = Jr({
    ...qt(e),
    inputElementType: d,
    label: u,
    validationBehavior: o
  }, a), $ = j((S) => {
    a.current = S, S && c(S instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, [
    a
  ]), y = le({
    ...e,
    values: {
      isDisabled: e.isDisabled || !1,
      isInvalid: h.isInvalid,
      isReadOnly: e.isReadOnly || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-TextField"
  }), P = q(e, {
    global: !0
  });
  return delete P.id, /* @__PURE__ */ x.createElement("div", {
    ...P,
    ...y,
    ref: n,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": h.isInvalid || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        Mt,
        {
          ...f,
          ref: s
        }
      ],
      [
        Yn,
        {
          ...v,
          ref: $
        }
      ],
      [
        Jm,
        {
          ...v,
          ref: $
        }
      ],
      [
        qn,
        {
          role: "presentation",
          isInvalid: h.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        It,
        {
          slots: {
            description: b,
            errorMessage: p
          }
        }
      ],
      [
        sn,
        h
      ]
    ]
  }, y.children));
}), e0 = /* @__PURE__ */ O(null), t0 = /* @__PURE__ */ O({}), V0 = /* @__PURE__ */ ie(function(e, n) {
  [e, n] = ee(e, n, t0);
  let r = H(e0), i = ni(r && e.id != null ? {
    isSelected: r.selectedKeys.has(e.id),
    onChange(h) {
      r.setSelected(e.id, h);
    }
  } : e), { buttonProps: l, isPressed: o, isSelected: a, isDisabled: s } = r && e.id != null ? Gp({
    ...e,
    id: e.id
  }, r, n) : Du({
    ...e,
    id: e.id != null ? String(e.id) : void 0
  }, i, n), { focusProps: u, isFocused: d, isFocusVisible: c } = Ne(e), { hoverProps: f, isHovered: v } = Fe(e), b = le({
    ...e,
    id: void 0,
    values: {
      isHovered: v,
      isPressed: o,
      isFocused: d,
      isSelected: i.isSelected,
      isFocusVisible: c,
      isDisabled: s,
      state: i
    },
    defaultClassName: "react-aria-ToggleButton"
  }), p = q(e, {
    global: !0
  });
  return delete p.id, delete p.onClick, /* @__PURE__ */ x.createElement("button", {
    ...R(p, b, l, u, f),
    ref: n,
    slot: e.slot || void 0,
    "data-focused": d || void 0,
    "data-disabled": s || void 0,
    "data-pressed": o || void 0,
    "data-selected": a || void 0,
    "data-hovered": v || void 0,
    "data-focus-visible": c || void 0
  }, /* @__PURE__ */ x.createElement(ai.Provider, {
    value: {
      isSelected: a
    }
  }, b.children));
}), di = /* @__PURE__ */ O(null), Ef = /* @__PURE__ */ O(null);
function z0(t) {
  let e = uf(t), n = L(null), { triggerProps: r, tooltipProps: i } = hm(t, e, n);
  return /* @__PURE__ */ x.createElement(pe, {
    values: [
      [
        di,
        e
      ],
      [
        Ef,
        {
          ...i,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(Pb, {
    ...r,
    ref: n
  }, t.children));
}
const H0 = /* @__PURE__ */ ie(function({ UNSTABLE_portalContainer: e, ...n }, r) {
  [n, r] = ee(n, r, Ef);
  let i = H(di), l = uf(n), o = n.isOpen != null || n.defaultOpen != null || !i ? l : i, a = Pn(r, o.isOpen) || n.isExiting || !1;
  return !o.isOpen && !a ? null : /* @__PURE__ */ x.createElement(Wb, {
    portalContainer: e
  }, /* @__PURE__ */ x.createElement(n0, {
    ...n,
    tooltipRef: r,
    isExiting: a
  }));
});
function n0(t) {
  let e = H(di), n = L(null), { overlayProps: r, arrowProps: i, placement: l, triggerAnchorPoint: o } = ql({
    placement: t.placement || "top",
    targetRef: t.triggerRef,
    overlayRef: t.tooltipRef,
    arrowRef: n,
    offset: t.offset,
    crossOffset: t.crossOffset,
    isOpen: e.isOpen,
    arrowBoundaryOffset: t.arrowBoundaryOffset,
    shouldFlip: t.shouldFlip,
    containerPadding: t.containerPadding,
    onClose: () => e.close(!0)
  }), a = zn(t.tooltipRef, !!l) || t.isEntering || !1, s = le({
    ...t,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: l,
      isEntering: a,
      isExiting: t.isExiting,
      state: e
    }
  });
  t = R(t, r);
  let { tooltipProps: u } = mm(t, e), d = q(t, {
    global: !0
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...R(d, s, u),
    ref: t.tooltipRef,
    style: {
      ...r.style,
      "--trigger-anchor-point": o ? `${o.x}px ${o.y}px` : void 0,
      ...s.style
    },
    "data-placement": l ?? void 0,
    "data-entering": a || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ x.createElement(bf.Provider, {
    value: {
      ...i,
      placement: l,
      ref: n
    }
  }, s.children));
}
export {
  Gb as $,
  F0 as A,
  k0 as B,
  ae as C,
  tn as D,
  Ne as E,
  R as F,
  s0 as G,
  I0 as H,
  O0 as I,
  R0 as J,
  Fe as K,
  v0 as L,
  H0 as M,
  z0 as N,
  x0 as O,
  K0 as P,
  D0 as Q,
  g0 as R,
  C0 as S,
  gm as T,
  y0 as U,
  p0 as V,
  f0 as W,
  $0 as X,
  S0 as a,
  P0 as b,
  E0 as c,
  w0 as d,
  Um as e,
  Xf as f,
  L0 as g,
  T0 as h,
  o0 as i,
  Ae as j,
  a0 as k,
  Gl as l,
  b0 as m,
  u0 as n,
  Dr as o,
  d0 as p,
  c0 as q,
  l0 as r,
  M0 as s,
  h0 as t,
  A0 as u,
  N0 as v,
  V0 as w,
  Ie as x,
  m0 as y,
  B0 as z
};
//# sourceMappingURL=vendor--aJiswR_.js.map
